import { inject as Ct, reactive as Et, watch as pe, ref as M, computed as R, shallowRef as ft, markRaw as go, defineComponent as le, onMounted as we, nextTick as De, openBlock as u, createElementBlock as p, withKeys as je, unref as i, createElementVNode as o, withModifiers as ve, normalizeStyle as Ee, normalizeClass as te, renderSlot as Me, createCommentVNode as K, toDisplayString as y, createBlock as Z, resolveDynamicComponent as On, withCtx as ue, createVNode as X, Fragment as _e, renderList as ge, withDirectives as he, vModelCheckbox as lt, vModelText as Ke, onBeforeUnmount as rt, defineAsyncComponent as Ln, Suspense as Rn, vShow as qe, onUnmounted as Pe, useTemplateRef as st, createStaticVNode as St, createTextVNode as ye, createSlots as yo, Teleport as bt, resolveComponent as Bn, customRef as wo, isRef as bo, vModelSelect as Kt, vModelRadio as zt, mergeProps as Ne, toHandlers as Ye, normalizeProps as Ze, guardReactiveProps as et, onUpdated as ko, useModel as zn, mergeModels as $o, Transition as xo, provide as So } from "vue";
import Co from "mitt";
import { useStore as oe } from "@nanostores/vue";
import { persistentAtom as Vn } from "@nanostores/persistent";
import { toast as xt, Toaster as Fo } from "vue-sonner";
import { atom as Le, computed as Qe } from "nanostores";
import { QueryClient as To, isCancelledError as Eo } from "@tanstack/vue-query";
import Po from "@uppy/core";
import qt from "vanilla-lazyload";
import { Cropper as Do } from "vue-advanced-cropper";
import { OverlayScrollbars as _t, SizeObserverPlugin as Mo } from "overlayscrollbars";
import { computePosition as it, offset as pt, flip as mt, shift as ht, autoUpdate as Qt } from "@floating-ui/dom";
import Io from "@viselect/vanilla";
import Ao from "@uppy/xhr-upload";
const Jt = /* @__PURE__ */ new Map(), Wt = /* @__PURE__ */ Symbol("ServiceContainerId");
function Oo(s, e) {
  Jt.set(s, e);
}
function Lo(s) {
  Jt.delete(s);
}
function ae(s) {
  const e = s ?? Ct(Wt);
  if (!e)
    throw new Error(
      "No VueFinder app instance found. Make sure VueFinder component is mounted and provide the id explicitly or use within a VueFinder component tree."
    );
  const t = Jt.get(e);
  if (!t)
    throw new Error(
      `VueFinder app instance with id "${e}" was not found. Make sure the VueFinder component with id="${e}" is mounted.`
    );
  return t;
}
function Ro(s) {
  const e = localStorage.getItem(s + "_storage"), t = Et(JSON.parse(e ?? "{}"));
  pe(t, n);
  function n() {
    Object.keys(t).length ? localStorage.setItem(s + "_storage", JSON.stringify(t)) : localStorage.removeItem(s + "_storage");
  }
  function a(c, v) {
    t[c] = v;
  }
  function d(c) {
    delete t[c];
  }
  function r() {
    Object.keys(t).forEach((c) => d(c));
  }
  return { getStore: (c, v = null) => c in t ? t[c] : v, setStore: a, removeStore: d, clearStore: r };
}
function Fe(s, e = "An error occurred") {
  if (!s)
    return e;
  if (typeof s == "string")
    return s || e;
  if (s instanceof Error)
    return s.message || e;
  if (typeof s == "object" && s !== null) {
    const t = s;
    if (typeof t.message == "string" && t.message)
      return t.message;
    if (typeof t.error == "string" && t.error)
      return t.error;
  }
  return e;
}
function Bo(s, e) {
  return Vn(s, e, {
    encode: JSON.stringify,
    decode: JSON.parse
  });
}
function zo(s) {
  if (!s?.config?.get)
    return !0;
  try {
    return !!s.config.get("notificationsEnabled");
  } catch {
    return !0;
  }
}
function ot(s, e, t) {
  const n = { type: e, message: t };
  if (s?.emitter?.emit?.("vf-notify", n), !!zo(s))
    switch (e) {
      case "success":
        xt.success(t);
        break;
      case "error":
        xt.error(t);
        break;
      case "warning":
        xt.warning(t);
        break;
      default:
        xt.info(t);
        break;
    }
}
function Be(s) {
  return {
    success(e) {
      ot(s, "success", e);
    },
    error(e) {
      ot(s, "error", e);
    },
    info(e) {
      ot(s, "info", e);
    },
    warning(e) {
      ot(s, "warning", e);
    },
    emit(e, t) {
      ot(s, e, t);
    }
  };
}
const Vt = /* @__PURE__ */ new Map();
async function Ut(s, e) {
  const t = e[s];
  return typeof t == "function" ? (await t()).default : t;
}
function Vo(s, e, t, n, a) {
  const d = Be({ emitter: t, config: a }), r = "vuefinder_locale", l = "global";
  let c;
  if (Vt.has(l))
    c = Vt.get(l), e && e !== c.get() && c.set(e);
  else {
    const C = localStorage.getItem(r) ? JSON.parse(localStorage.getItem(r)) : null;
    c = Bo(r, e || C || "en"), Vt.set(l, c);
  }
  const v = "vuefinder_translations", w = (C) => {
    try {
      const A = localStorage.getItem(v);
      if (A)
        return JSON.parse(A)[C] || null;
    } catch {
    }
    return null;
  }, h = (C, A) => {
    try {
      const S = localStorage.getItem(v), L = S ? JSON.parse(S) : {};
      L[C] = A, localStorage.setItem(v, JSON.stringify(L));
    } catch {
    }
  }, _ = oe(c), k = String(_.value), b = w(k), $ = M(b || {});
  let m = !1;
  !b && Object.keys(n).length > 0 && Ut(k, n).then((C) => {
    $.value = C, h(k, C);
  }).catch(() => {
  }), pe(
    _,
    async (C, A) => {
      if (A && C === A)
        return;
      if (!m) {
        m = !0;
        const L = w(String(C));
        if (L)
          $.value = L;
        else if (Object.keys(n).length > 0)
          try {
            const H = await Ut(String(C), n);
            $.value = H, h(String(C), H);
          } catch {
          }
        return;
      }
      const S = w(String(C));
      if (S)
        $.value = S;
      else
        try {
          const L = await Ut(String(C), n);
          $.value = L, h(String(C), L);
        } catch (L) {
          const H = Fe(L, "Locale cannot be loaded!");
          d.error(H);
          return;
        }
      Object.values(n).length > 1 && (d.success("The language is set to " + C), t.emit("vf-language-saved"));
    },
    { immediate: !1 }
  );
  const g = (C, ...A) => A.length ? g(C = C.replace("%s", String(A.shift())), ...A) : C;
  function f(C, ...A) {
    return $.value && Object.prototype.hasOwnProperty.call($.value, C) ? g($.value[C] || C, ...A) : g(C, ...A);
  }
  const F = R({
    get: () => _.value,
    set: (C) => {
      c.set(C);
    }
  });
  return Et({ t: f, locale: F, localeAtom: c });
}
const Uo = [
  "edit",
  "newfile",
  "newfolder",
  "preview",
  "archive",
  "unarchive",
  "search",
  "rename",
  "upload",
  "delete",
  "fullscreen",
  "download",
  "language",
  "move",
  "copy",
  "history",
  "theme",
  "pinned"
], Un = {
  simple: {
    search: !0,
    preview: !0,
    rename: !0,
    upload: !0,
    delete: !0,
    newfile: !0,
    newfolder: !0,
    download: !0
  },
  advanced: Uo.reduce((s, e) => (s[e] = !0, s), {})
};
function yn() {
  return Un.advanced;
}
function Nn(s) {
  return s ? s === "simple" || s === "advanced" ? { ...Un[s] } : { ...yn(), ...s } : yn();
}
const No = "4.6.0";
function Zt(s, e, t, n, a) {
  return e = Math, t = e.log, n = 1024, a = t(s) / t(n) | 0, (s / e.pow(n, a)).toFixed(0) + " " + (a ? "KMGTPEZY"[--a] + "iB" : "B");
}
function Hn(s, e, t, n, a) {
  return e = Math, t = e.log, n = 1e3, a = t(s) / t(n) | 0, (s / e.pow(n, a)).toFixed(0) + " " + (a ? "KMGTPEZY"[--a] + "B" : "B");
}
function Ho(s) {
  if (typeof s == "number") return s;
  const e = { k: 1, m: 2, g: 3, t: 4 }, n = /(\d+(?:\.\d+)?)\s?(k|m|g|t)?b?/i.exec(s);
  if (!n) return 0;
  const a = parseFloat(n[1] || "0"), d = (n[2] || "").toLowerCase(), r = e[d] ?? 0;
  return Math.round(a * Math.pow(1024, r));
}
function jo(s) {
  const e = ft(null), t = M(!1), n = M(), a = M(!1), d = ft(null);
  return {
    visible: t,
    type: e,
    data: n,
    open: (h, _ = null) => {
      s.get("fullScreen") || (document.querySelector("body").style.overflow = "hidden"), t.value = !0, e.value = h, n.value = _;
    },
    close: () => {
      s.get("fullScreen") || (document.querySelector("body").style.overflow = ""), t.value = !1, e.value = null, a.value = !1, d.value = null;
    },
    setEditMode: (h) => {
      a.value = h;
    },
    editMode: a,
    controls: d,
    registerControls: (h) => {
      d.value = h;
    },
    unregisterControls: (h) => {
      d.value === h && (d.value = null);
    }
  };
}
const Ft = {
  view: "grid",
  theme: "silver",
  fullScreen: !1,
  showTreeView: !1,
  showHiddenFiles: !0,
  metricUnits: !1,
  showThumbnails: !0,
  persist: !1,
  path: "",
  pinnedFolders: [],
  notificationsEnabled: !0,
  expandTreeByDefault: !1,
  expandedTreePaths: []
}, Tt = {
  initialPath: null,
  maxFileSize: null,
  loadingIndicator: "circular",
  showMenuBar: !0,
  showToolbar: !0,
  showFilesInTree: !1,
  gridItemWidth: 96,
  gridItemHeight: 80,
  gridItemGap: 8,
  gridIconSize: 48,
  listItemHeight: 32,
  listItemGap: 2,
  listIconSize: 16,
  notificationPosition: "bottom-center",
  notificationDuration: 3e3,
  notificationVisibleToasts: 4,
  notificationRichColors: !0
}, Ko = new Set(
  Object.keys(Tt)
);
function qo(s) {
  return s || "silver";
}
function jn(s) {
  return Ko.has(s);
}
function wn(s) {
  const e = {}, t = {}, n = s;
  for (const a in n)
    if (jn(a))
      t[a] = n[a];
    else if (a in Ft) {
      const d = a;
      e[d] = n[a];
    }
  return { persistenceConfig: e, nonPersistenceConfig: t };
}
function bn(s, e) {
  const t = { ...Ft, ...s, ...e };
  return t.theme = qo(t.theme), t;
}
function kn(s, e) {
  return { ...Tt, ...e, ...s };
}
const Wo = (s, e = {}) => {
  const t = `vuefinder_config_${s}`, { persistenceConfig: n, nonPersistenceConfig: a } = wn(e), d = bn(
    n,
    Ft
  ), r = kn(
    a,
    Tt
  ), l = Vn(
    t,
    d,
    {
      encode: JSON.stringify,
      decode: JSON.parse
    }
  ), c = Le(r), v = Qe(
    [l, c],
    (m, g) => ({
      ...m,
      ...g
    })
  ), w = (m = {}) => {
    const g = l.get(), f = c.get(), { persistenceConfig: F, nonPersistenceConfig: C } = wn(m), A = bn(F, g), S = kn(
      C,
      f
    );
    l.set(A), c.set(S);
  }, h = (m) => jn(m) ? c.get()[m] : l.get()[m], _ = () => ({
    ...l.get(),
    ...c.get()
  }), k = (m, g) => {
    const f = l.get();
    typeof m == "object" && m !== null ? l.set({ ...f, ...m }) : l.set({
      ...f,
      [m]: g
    });
  };
  return {
    // Store atom (combined)
    state: v,
    // Methods
    init: w,
    get: h,
    set: k,
    toggle: (m) => {
      const g = l.get();
      k(m, !g[m]);
    },
    all: _,
    reset: () => {
      l.set({ ...Ft }), c.set({ ...Tt });
    }
  };
}, ke = (s) => `${s.type}:${s.path}`;
function Kn(s, e) {
  if (typeof s == "string" && typeof e == "string")
    return s.toLowerCase().localeCompare(e.toLowerCase());
  const t = Number(s) || 0, n = Number(e) || 0;
  return t === n ? 0 : t < n ? -1 : 1;
}
const Go = () => {
  const s = Le(""), e = Le([]), t = Le(!1), n = Le([]), a = Le({ active: !1, column: "", order: "" }), d = Le({
    kind: "all",
    showHidden: !1
  }), r = Le(/* @__PURE__ */ new Set()), l = Le({
    type: "copy",
    path: "",
    items: /* @__PURE__ */ new Set()
  }), c = Le(null), v = Le(0), w = Le(!1), h = Le([]), _ = Le(-1), k = Qe([s], (ee) => {
    const ne = (ee ?? "").trim(), ie = ne.indexOf("://"), re = ie >= 0 ? ne.slice(0, ie) : "", Te = (ie >= 0 ? ne.slice(ie + 3) : ne).split("/").filter(Boolean);
    let Se = "";
    const We = Te.map((Ae) => (Se = Se ? `${Se}/${Ae}` : Ae, {
      basename: Ae,
      name: Ae,
      path: re ? `${re}://${Se}` : Se,
      type: "dir"
    }));
    return { storage: re, breadcrumb: We, path: ne };
  }), b = Qe([n, a, d], (ee, ne, ie) => {
    let re = ee;
    ie.kind === "files" ? re = re.filter((Ae) => Ae.type === "file") : ie.kind === "folders" && (re = re.filter((Ae) => Ae.type === "dir")), ie.showHidden || (re = re.filter((Ae) => !Ae.basename.startsWith(".")));
    const { active: Ue, column: Te, order: Se } = ne;
    if (!Ue || !Te) return re;
    const We = Se === "asc" ? 1 : -1;
    return re.slice().sort((Ae, Rt) => Kn(Ae[Te], Rt[Te]) * We);
  }), $ = Qe([n, r], (ee, ne) => ne.size === 0 ? [] : ee.filter((ie) => ne.has(ke(ie)))), m = (ee, ne) => {
    const ie = s.get();
    if ((ne ?? !0) && ie !== ee) {
      const re = h.get(), Ue = _.get();
      Ue < re.length - 1 && re.splice(Ue + 1), re.length === 0 && ie && re.push(ie), re.push(ee), h.set([...re]), _.set(re.length - 1);
    }
    s.set(ee);
  }, g = (ee) => {
    n.set(ee ?? []);
  }, f = (ee) => {
    e.set(ee ?? []);
  }, F = (ee, ne) => {
    a.set({ active: !0, column: ee, order: ne });
  }, C = (ee) => {
    const ne = a.get();
    ne.active && ne.column === ee ? a.set({
      active: ne.order === "asc",
      column: ee,
      order: "desc"
    }) : a.set({
      active: !0,
      column: ee,
      order: "asc"
    });
  }, A = () => {
    a.set({ active: !1, column: "", order: "" });
  }, S = (ee, ne) => {
    d.set({ kind: ee, showHidden: ne });
  }, L = () => {
    d.set({ kind: "all", showHidden: !1 });
  }, H = (ee, ne = "multiple") => {
    const ie = new Set(r.get());
    ne === "single" && ie.clear(), ie.add(ee), r.set(ie);
  }, Y = (ee, ne = "multiple") => {
    const ie = new Set(r.get());
    ne === "single" && ie.clear(), ee.forEach((re) => ie.add(re)), r.set(ie);
  }, Q = (ee) => {
    const ne = new Set(r.get());
    ne.delete(ee), r.set(ne);
  }, B = (ee) => r.get().has(ee), W = (ee, ne = "multiple") => {
    const ie = new Set(r.get());
    ie.has(ee) ? ie.delete(ee) : (ne === "single" && ie.clear(), ie.add(ee)), r.set(ie);
  }, T = (ee = "multiple", ne) => {
    if (ee === "single") {
      const ie = n.get()[0];
      if (ie) {
        const re = ke(ie);
        r.set(/* @__PURE__ */ new Set([re])), v.set(1);
      }
    } else {
      if (ne?.selectionFilterType || ne?.selectionFilterMimeIncludes && ne.selectionFilterMimeIncludes.length > 0) {
        const ie = n.get().filter((re) => {
          const Ue = ne.selectionFilterType, Te = ne.selectionFilterMimeIncludes;
          return Ue === "files" && re.type === "dir" || Ue === "dirs" && re.type === "file" ? !1 : Te && Array.isArray(Te) && Te.length > 0 && re.type !== "dir" ? re.mime_type ? Te.some((Se) => re.mime_type?.startsWith(Se)) : !1 : !0;
        }).map((re) => ke(re));
        r.set(new Set(ie));
      } else {
        const ie = new Set(n.get().map((re) => ke(re)));
        r.set(ie);
      }
      J(r.get().size);
    }
  }, D = () => {
    r.set(/* @__PURE__ */ new Set()), v.set(0);
  }, N = (ee) => {
    const ne = new Set(ee ?? []), ie = new Set(
      n.get().filter((re) => ne.has(re.path)).map((re) => ke(re))
    );
    r.set(ie), v.set(ie.size);
  }, J = (ee) => {
    v.set(ee);
  }, ce = (ee) => {
    w.set(!!ee);
  }, z = () => w.get(), x = (ee, ne) => {
    const ie = n.get().filter((re) => ne.has(ke(re)));
    l.set({
      type: ee,
      path: k.get().path,
      items: new Set(ie)
    });
  }, U = (ee) => Qe([l], (ne) => ne.type === "cut" && Array.from(ne.items).some((ie) => ke(ie) === ee)), E = (ee) => Qe([l], (ne) => ne.type === "copy" && Array.from(ne.items).some((ie) => ke(ie) === ee)), V = (ee) => {
    const ne = U(ee);
    return oe(ne).value ?? !1;
  }, I = (ee) => {
    const ne = E(ee);
    return oe(ne).value ?? !1;
  }, O = () => {
    l.set({ type: "copy", path: "", items: /* @__PURE__ */ new Set() });
  }, q = () => l.get(), P = (ee) => {
    c.set(ee);
  }, j = () => c.get(), de = () => {
    c.set(null);
  }, me = () => {
    const ee = h.get(), ne = _.get();
    if (ne > 0) {
      const ie = ne - 1, re = ee[ie];
      re && (_.set(ie), m(re, !1));
    }
  }, G = () => {
    const ee = h.get(), ne = _.get();
    if (ne < ee.length - 1) {
      const ie = ne + 1, re = ee[ie];
      re && (_.set(ie), m(re, !1));
    }
  }, se = Qe([_], (ee) => ee > 0), fe = Qe(
    [h, _],
    (ee, ne) => ne < ee.length - 1
  );
  return {
    // Atoms (state)
    files: n,
    storages: e,
    currentPath: s,
    sort: a,
    filter: d,
    selectedKeys: r,
    selectedCount: v,
    loading: w,
    draggedItem: c,
    clipboardItems: l,
    // Computed values
    path: k,
    sortedFiles: b,
    selectedItems: $,
    // Actions
    setPath: m,
    setFiles: g,
    setStorages: f,
    setSort: F,
    toggleSort: C,
    clearSort: A,
    setFilter: S,
    clearFilter: L,
    select: H,
    selectMultiple: Y,
    deselect: Q,
    toggleSelect: W,
    selectAll: T,
    isSelected: B,
    clearSelection: D,
    setSelection: N,
    setSelectedCount: J,
    setLoading: ce,
    isLoading: z,
    setClipboard: x,
    createIsCut: U,
    createIsCopied: E,
    isCut: V,
    isCopied: I,
    clearClipboard: O,
    getClipboard: q,
    setDraggedItem: P,
    getDraggedItem: j,
    clearDraggedItem: de,
    setReadOnly: (ee) => {
      t.set(ee);
    },
    getReadOnly: () => t.get(),
    isReadOnly: (ee) => t.get() ? !0 : ee.read_only ?? !1,
    // Navigation
    goBack: me,
    goForward: G,
    canGoBack: se,
    canGoForward: fe,
    navigationHistory: h,
    historyIndex: _
  };
};
class en {
  /**
   * Validate that required parameters are provided
   */
  validateParam(e, t) {
    if (e == null)
      throw new Error(`${t} is required`);
  }
  /**
   * Validate that a file path is provided
   */
  validatePath(e) {
    if (!e)
      throw new Error("Path must be a non-empty string");
  }
  /**
   * Extract storage and path from a combined path string
   * Format: "storage://path" or just "path"
   */
  parsePath(e) {
    if (!e)
      return {};
    if (e.includes("://")) {
      const [t, ...n] = e.split("://");
      return { storage: t, path: n.join("://") };
    }
    return { path: e };
  }
  /**
   * Combine storage and path into a single path string
   */
  combinePath(e, t) {
    return e && t ? `${e}://${t}` : t || "";
  }
}
class Yo extends en {
  filesSource;
  defaultStorage;
  storages;
  storagesSet;
  readOnly;
  contentStore;
  constructor(e) {
    super(), this.filesSource = e.files;
    const t = e.storages && e.storages.length > 0 ? e.storages : [e.storage || "memory"];
    this.storages = [...new Set(t)], this.defaultStorage = e.storage || this.storages[0] || "memory", this.storages.includes(this.defaultStorage) || this.storages.unshift(this.defaultStorage), this.storagesSet = new Set(this.storages), this.readOnly = !!e.readOnly, this.contentStore = e.contentStore || /* @__PURE__ */ new Map();
  }
  get files() {
    return Array.isArray(this.filesSource) ? this.filesSource : this.filesSource.value;
  }
  set files(e) {
    Array.isArray(this.filesSource) ? (this.filesSource.length = 0, this.filesSource.push(...e)) : this.filesSource.value = e;
  }
  ensureWritable() {
    if (this.readOnly)
      throw new Error("Driver is read-only");
  }
  ensureStorageSupported(e) {
    if (!this.storagesSet.has(e))
      throw new Error(`Unsupported storage: ${e}`);
  }
  combine(e, t = this.defaultStorage) {
    this.ensureStorageSupported(t);
    const n = e ?? "";
    return n === "" ? `${t}://` : `${t}://${n}`;
  }
  split(e) {
    return this.parsePath(e);
  }
  normalizePath(e, t = this.defaultStorage) {
    const { storage: n, path: a } = this.split(e || ""), d = n || t;
    return this.combine(a ?? "", d);
  }
  parent(e) {
    const { storage: t, path: n } = this.split(e), a = t || this.defaultStorage;
    if (!n) return this.combine("", a);
    const d = n.replace(/\/+$/g, "").replace(/^\/+/, ""), r = d.lastIndexOf("/");
    return r <= 0 ? this.combine("", a) : this.combine(d.slice(0, r), a);
  }
  join(e, t) {
    const { storage: n, path: a } = this.split(e), d = n || this.defaultStorage, r = (a ?? "").replace(/\/$/, ""), l = r ? `${r}/${t}` : t;
    return this.combine(l, d);
  }
  getExtension(e) {
    const t = e.lastIndexOf(".");
    return t > 0 ? e.slice(t + 1) : "";
  }
  cloneEntry(e, t = {}) {
    return { ...e, ...t };
  }
  findByPath(e) {
    return this.files.find((t) => t.path === e);
  }
  listChildren(e) {
    return this.files.filter((t) => t.dir === e);
  }
  replaceAll(e) {
    this.files = e;
  }
  upsert(e) {
    const t = this.files.slice(), n = t.findIndex((a) => a.path === e.path);
    n === -1 ? t.push(e) : t[n] = e, this.replaceAll(t);
  }
  removeExact(e) {
    const t = this.files.filter((n) => n.path !== e);
    this.replaceAll(t);
  }
  removeTree(e) {
    const t = [], n = [];
    for (const a of this.files)
      this.isInTree(a.path, e) ? t.push(a) : n.push(a);
    this.replaceAll(n);
    for (const a of t)
      this.contentStore.delete(a.path);
    return t;
  }
  isInTree(e, t) {
    return e === t || e.startsWith(`${t}/`);
  }
  getTree(e, t = this.files) {
    return t.filter((n) => this.isInTree(n.path, e)).sort((n, a) => n.path.length - a.path.length);
  }
  uniqueName(e, t, n) {
    if (!n.has(this.join(e, t))) return t;
    const a = t.lastIndexOf("."), d = a > 0 ? t.slice(0, a) : t, r = a > 0 ? t.slice(a) : "";
    let l = 1;
    for (; ; ) {
      const c = `${d} copy ${l}${r}`, v = this.join(e, c);
      if (!n.has(v)) return c;
      l++;
    }
  }
  topLevelSources(e, t = this.defaultStorage) {
    const n = [...new Set(e)].map((d) => this.normalizePath(d, t)).filter((d) => this.findByPath(d)).sort((d, r) => d.length - r.length), a = [];
    for (const d of n)
      a.some((r) => this.isInTree(d, r)) || a.push(d);
    return a;
  }
  makeDirEntry(e, t) {
    const n = this.join(e, t), { storage: a } = this.split(n);
    return {
      storage: a || this.defaultStorage,
      dir: e,
      basename: t,
      extension: "",
      path: n,
      type: "dir",
      file_size: null,
      last_modified: Date.now(),
      mime_type: null,
      visibility: "public"
    };
  }
  makeFileEntry(e, t, n = 0, a = null) {
    const d = this.join(e, t), { storage: r } = this.split(d);
    return {
      storage: r || this.defaultStorage,
      dir: e,
      basename: t,
      extension: this.getExtension(t),
      path: d,
      type: "file",
      file_size: n,
      last_modified: Date.now(),
      mime_type: a,
      visibility: "public"
    };
  }
  resultForDir(e) {
    return {
      files: this.listChildren(e),
      storages: this.storages,
      read_only: this.readOnly,
      dirname: e
    };
  }
  async list(e) {
    const t = this.normalizePath(e?.path);
    return {
      storages: this.storages,
      dirname: t,
      files: this.listChildren(t),
      read_only: this.readOnly
    };
  }
  async delete(e) {
    this.ensureWritable(), this.validateParam(e.items, "items"), this.validateParam(e.path, "path");
    const t = this.normalizePath(e.path), { storage: n } = this.split(t), a = [];
    for (const r of e.items) {
      const l = this.normalizePath(r.path, n || this.defaultStorage), c = this.findByPath(l);
      c && (c.type === "dir" ? a.push(...this.removeTree(c.path)) : (this.removeExact(c.path), this.contentStore.delete(c.path), a.push(c)));
    }
    return { ...this.resultForDir(t), deleted: a };
  }
  async rename(e) {
    this.ensureWritable(), this.validateParam(e.name, "name");
    const t = this.normalizePath(e.path), { storage: n } = this.split(t), a = this.normalizePath(
      e.item || e.path,
      n || this.defaultStorage
    ), d = this.findByPath(a);
    if (!d) throw new Error("Item not found");
    const r = d.dir, l = this.join(r, e.name);
    if (l !== d.path && this.findByPath(l))
      throw new Error("Target already exists");
    if (d.type === "dir") {
      const v = d.path, w = l, h = this.files.map((_) => {
        if (_.storage !== d.storage || !this.isInTree(_.path, v)) return _;
        const k = w + _.path.slice(v.length);
        return this.cloneEntry(_, {
          path: k,
          dir: this.parent(k),
          basename: _.path === v ? e.name : _.basename,
          last_modified: Date.now()
        });
      });
      for (const [_, k] of Array.from(this.contentStore.entries()))
        this.isInTree(_, v) && (this.contentStore.delete(_), this.contentStore.set(w + _.slice(v.length), k));
      this.replaceAll(h);
    } else {
      const v = this.cloneEntry(d, {
        path: l,
        basename: e.name,
        extension: this.getExtension(e.name),
        last_modified: Date.now()
      });
      this.upsert(v), this.removeExact(d.path);
      const w = this.contentStore.get(d.path);
      w !== void 0 && (this.contentStore.delete(d.path), this.contentStore.set(v.path, w));
    }
    const c = e.path ? this.normalizePath(e.path, d.storage || this.defaultStorage) : r;
    return this.resultForDir(c || r);
  }
  async copy(e) {
    this.ensureWritable(), this.validateParam(e.sources, "sources"), this.validateParam(e.destination, "destination");
    const t = this.normalizePath(
      e.destination,
      e.path ? this.split(this.normalizePath(e.path)).storage || this.defaultStorage : this.defaultStorage
    ), { storage: n } = this.split(t), a = this.topLevelSources(e.sources, n || this.defaultStorage), d = new Set(this.files.map((l) => l.path)), r = [];
    for (const l of a) {
      const c = this.findByPath(l);
      if (!c) continue;
      if (c.type === "file") {
        const _ = this.uniqueName(t, c.basename, d), k = this.makeFileEntry(
          t,
          _,
          c.file_size || 0,
          c.mime_type
        );
        r.push(k), d.add(k.path);
        const b = this.contentStore.get(c.path);
        b !== void 0 && this.contentStore.set(k.path, b);
        continue;
      }
      const v = this.getTree(c.path), w = this.uniqueName(t, c.basename, d), h = /* @__PURE__ */ new Map();
      h.set(c.path, this.join(t, w));
      for (const _ of v) {
        const k = _.path === c.path ? h.get(c.path) : this.join(h.get(_.dir), _.basename);
        h.set(_.path, k);
        const b = _.path === c.path ? t : h.get(_.dir), $ = _.path === c.path ? w : _.basename, m = this.cloneEntry(_, {
          path: k,
          dir: b,
          basename: $,
          extension: _.type === "file" ? this.getExtension($) : "",
          last_modified: Date.now()
        });
        if (r.push(m), d.add(m.path), _.type === "file") {
          const g = this.contentStore.get(_.path);
          g !== void 0 && this.contentStore.set(m.path, g);
        }
      }
    }
    return this.replaceAll(this.files.concat(r)), this.resultForDir(t);
  }
  async move(e) {
    this.ensureWritable(), this.validateParam(e.sources, "sources"), this.validateParam(e.destination, "destination");
    const t = this.normalizePath(
      e.destination,
      e.path ? this.split(this.normalizePath(e.path)).storage || this.defaultStorage : this.defaultStorage
    ), { storage: n } = this.split(t), a = this.topLevelSources(e.sources, n || this.defaultStorage);
    let d = this.files.slice();
    for (const r of a) {
      const l = d.find((b) => b.path === r);
      if (!l) continue;
      if (l.type === "dir" && this.isInTree(t, l.path))
        throw new Error("Cannot move directory into itself");
      if (l.dir === t)
        continue;
      const c = this.getTree(l.path, d), v = new Set(c.map((b) => b.path)), w = new Set(d.filter((b) => !v.has(b.path)).map((b) => b.path)), h = this.uniqueName(t, l.basename, w), _ = /* @__PURE__ */ new Map();
      _.set(l.path, this.join(t, h));
      const k = /* @__PURE__ */ new Map();
      for (const b of c) {
        const $ = b.path === l.path ? _.get(l.path) : this.join(_.get(b.dir), b.basename);
        _.set(b.path, $);
        const m = b.path === l.path ? t : _.get(b.dir), g = b.path === l.path ? h : b.basename;
        k.set(
          b.path,
          this.cloneEntry(b, {
            path: $,
            dir: m,
            basename: g,
            extension: b.type === "file" ? this.getExtension(g) : "",
            last_modified: Date.now()
          })
        );
      }
      d = d.map((b) => k.get(b.path) || b);
      for (const [b, $] of _.entries()) {
        if (b === $) continue;
        const m = this.contentStore.get(b);
        m !== void 0 && (this.contentStore.delete(b), this.contentStore.set($, m));
      }
    }
    return this.replaceAll(d), this.resultForDir(t);
  }
  async archive(e) {
    this.ensureWritable(), this.validateParam(e.path, "path"), this.validateParam(e.items, "items"), this.validateParam(e.name, "name");
    const t = this.normalizePath(e.path), n = e.name.endsWith(".zip") ? e.name : `${e.name}.zip`, a = this.makeFileEntry(t, n, 0, "application/zip");
    return this.upsert(a), this.resultForDir(t);
  }
  async unarchive(e) {
    this.ensureWritable(), this.validateParam(e.item, "item"), this.validateParam(e.path, "path");
    const t = this.normalizePath(e.item), n = this.normalizePath(e.path), a = this.findByPath(t);
    if (!a) throw new Error("Archive not found");
    const d = a.basename.replace(/\.zip$/i, ""), r = this.makeDirEntry(n, d);
    return this.upsert(r), this.resultForDir(n);
  }
  async createFile(e) {
    this.ensureWritable(), this.validateParam(e.path, "path"), this.validateParam(e.name, "name");
    const t = this.normalizePath(e.path), n = this.makeFileEntry(t, e.name, 0, null);
    return this.upsert(n), this.contentStore.set(n.path, ""), this.resultForDir(t);
  }
  async createFolder(e) {
    this.ensureWritable(), this.validateParam(e.path, "path"), this.validateParam(e.name, "name");
    const t = this.normalizePath(e.path), n = this.makeDirEntry(t, e.name);
    return this.upsert(n), this.resultForDir(t);
  }
  getPreviewUrl(e) {
    return "";
  }
  async getContent(e) {
    this.validatePath(e.path);
    const t = this.normalizePath(e.path), n = this.contentStore.get(t);
    if (typeof n == "string" || n === void 0)
      return {
        content: n ?? "",
        mimeType: this.findByPath(t)?.mime_type || void 0
      };
    const a = new Uint8Array(n);
    let d = "";
    for (let r = 0; r < a.length; r++) d += String.fromCharCode(a[r]);
    return {
      content: btoa(d),
      mimeType: this.findByPath(t)?.mime_type || void 0
    };
  }
  getDownloadUrl(e) {
    return "";
  }
  async search(e) {
    const t = (e.filter || "").toLowerCase(), n = e.path ? this.normalizePath(e.path) : void 0;
    return this.files.filter((a) => {
      if (n) {
        if (e.deep) {
          if (!this.isInTree(a.path, n)) return !1;
        } else if (a.dir !== n)
          return !1;
      }
      return a.basename.toLowerCase().includes(t) || a.path.toLowerCase().includes(t);
    });
  }
  async save(e) {
    this.ensureWritable(), this.validateParam(e.path, "path");
    const t = this.normalizePath(e.path), n = this.findByPath(t);
    if (!n) throw new Error("File not found");
    if (n.type !== "file") throw new Error("Can only save file content");
    return this.contentStore.set(t, e.content), this.upsert(
      this.cloneEntry(n, { file_size: e.content.length, last_modified: Date.now() })
    ), t;
  }
  configureUploader(e, t) {
    e && e.on("upload-success", async (n) => {
      try {
        this.ensureWritable();
        const a = this.normalizePath(t.getTargetPath()), d = n?.name || "file", r = n?.type || null, l = n?.data, c = n?.size || 0, v = this.makeFileEntry(a, d, c, r);
        if (this.upsert(v), l)
          try {
            const w = await l.arrayBuffer();
            this.contentStore.set(v.path, w);
          } catch {
            this.contentStore.set(v.path, "");
          }
        else
          this.contentStore.set(v.path, "");
      } catch {
      }
    });
  }
}
function $n(s, e, t) {
  const n = `HTTP ${e}: ${t}`;
  if (!s)
    return n;
  try {
    const a = JSON.parse(s);
    if (a.message)
      return a.message;
    if (a.error) {
      if (typeof a.error == "string")
        return a.error;
      if (a.error.message)
        return a.error.message;
    }
    if (a.errors && Array.isArray(a.errors) && a.errors.length > 0) {
      const d = a.errors.map((r) => r.message).filter((r) => !!r);
      if (d.length > 0)
        return d.join(", ");
    }
    return a.detail ? a.detail : a.title ? a.title : s;
  } catch {
    return s || n;
  }
}
class qn extends en {
  config;
  /**
   * Default URL endpoints
   */
  static DEFAULT_URLS = {
    list: "",
    upload: "/upload",
    delete: "/delete",
    rename: "/rename",
    copy: "/copy",
    move: "/move",
    archive: "/archive",
    unarchive: "/unarchive",
    createFile: "/create-file",
    createFolder: "/create-folder",
    preview: "/preview",
    download: "/download",
    search: "/search",
    save: "/save"
  };
  constructor(e) {
    super();
    const t = {
      ...qn.DEFAULT_URLS,
      ...e.url || {}
    };
    this.config = {
      ...e,
      baseURL: e.baseURL || "",
      url: t
    };
  }
  /**
   * Set or update the base URL for API requests
   */
  setBaseURL(e) {
    this.config.baseURL = e || "";
  }
  /**
   * Set or update the authentication token
   * Pass undefined to remove the token
   */
  setToken(e) {
    this.config.token = e;
  }
  configureUploader(e, t) {
    const n = this.getHeaders();
    delete n["Content-Type"], e.use(Ao, {
      endpoint: `${this.config.baseURL}${this.config.url.upload}`,
      fieldName: "file",
      bundle: !1,
      headers: n,
      formData: !0
    }), e.on("upload", () => {
      const a = t.getTargetPath();
      e.getFiles().forEach((r) => {
        e.setFileMeta(r.id, { path: a });
      });
    });
  }
  getHeaders() {
    const e = {
      "Content-Type": "application/json",
      ...this.config.headers
    };
    return this.config.token && (e.Authorization = `Bearer ${this.config.token}`), e;
  }
  async request(e, t = {}) {
    const n = `${this.config.baseURL}${e}`, a = await fetch(n, {
      ...t,
      headers: {
        ...this.getHeaders(),
        ...t.headers
      }
    });
    if (!a.ok) {
      const r = await a.text(), l = $n(r, a.status, a.statusText);
      throw new Error(l);
    }
    return a.status === 204 || a.status === 304 ? {} : (a.headers.get("content-type") || "").includes("application/json") ? await a.json() : await a.text();
  }
  async list(e) {
    const t = new URLSearchParams();
    e?.path && t.append("path", e.path);
    const n = t.toString() ? `${this.config.url.list}?${t.toString()}` : this.config.url.list;
    return await this.request(n, { method: "GET", signal: e?.signal });
  }
  async delete(e) {
    return this.validateParam(e.items, "items"), this.validateParam(e.path, "path"), await this.request(this.config.url.delete, {
      method: "POST",
      body: JSON.stringify({ path: e.path, items: e.items })
    });
  }
  async rename(e) {
    return this.validateParam(e.path, "path"), this.validateParam(e.item, "item"), this.validateParam(e.name, "name"), this.validatePath(e.path), await this.request(this.config.url.rename, {
      method: "POST",
      body: JSON.stringify({ path: e.path, item: e.item, name: e.name })
    });
  }
  async copy(e) {
    return this.validateParam(e.sources, "sources"), this.validateParam(e.destination, "destination"), e.path && this.validatePath(e.path), await this.request(this.config.url.copy, {
      method: "POST",
      body: JSON.stringify({
        sources: e.sources,
        destination: e.destination,
        path: e.path
      })
    });
  }
  async move(e) {
    return this.validateParam(e.sources, "sources"), this.validateParam(e.destination, "destination"), e.path && this.validatePath(e.path), await this.request(this.config.url.move, {
      method: "POST",
      body: JSON.stringify({
        sources: e.sources,
        destination: e.destination,
        path: e.path
      })
    });
  }
  async archive(e) {
    return this.validateParam(e.items, "items"), this.validateParam(e.name, "name"), this.validateParam(e.path, "path"), await this.request(this.config.url.archive, {
      method: "POST",
      body: JSON.stringify({
        items: e.items,
        path: e.path,
        name: e.name,
        // Optional. Backends that ignore unknown fields will fall back to `path`.
        ...e.destination ? { destination: e.destination } : {}
      })
    });
  }
  async unarchive(e) {
    return this.validateParam(e.item, "item"), this.validateParam(e.path, "path"), await this.request(this.config.url.unarchive, {
      method: "POST",
      body: JSON.stringify({
        item: e.item,
        path: e.path,
        // Optional. Backends that ignore unknown fields will fall back to `path`.
        ...e.destination ? { destination: e.destination } : {}
      })
    });
  }
  async createFile(e) {
    return this.validateParam(e.name, "name"), this.validateParam(e.path, "path"), await this.request(this.config.url.createFile, {
      method: "POST",
      body: JSON.stringify({ path: e.path, name: e.name })
    });
  }
  async createFolder(e) {
    return this.validateParam(e.name, "name"), this.validateParam(e.path, "path"), await this.request(this.config.url.createFolder, {
      method: "POST",
      body: JSON.stringify({ path: e.path, name: e.name })
    });
  }
  getPreviewUrl(e) {
    this.validatePath(e.path);
    const t = new URLSearchParams({ path: e.path });
    return `${this.config.baseURL}${this.config.url.preview}?${t.toString()}`;
  }
  async getContent(e) {
    this.validatePath(e.path);
    const t = new URLSearchParams({ path: e.path }), n = `${this.config.baseURL}${this.config.url.preview}?${t.toString()}`, a = await fetch(n, { headers: this.getHeaders(), signal: e.signal });
    if (!a.ok) {
      const r = await a.text(), l = $n(r, a.status, a.statusText);
      throw new Error(l);
    }
    return { content: await a.text(), mimeType: a.headers.get("Content-Type") || void 0 };
  }
  getDownloadUrl(e) {
    this.validatePath(e.path);
    const t = new URLSearchParams({ path: e.path });
    return `${this.config.baseURL}${this.config.url.download}?${t.toString()}`;
  }
  async search(e) {
    const t = this.config.url.search, n = new URLSearchParams();
    e.path && n.set("path", e.path), e.filter && n.set("filter", e.filter), e.deep && n.set("deep", "1"), e.size && e.size !== "all" && n.set("size", e.size);
    const a = n.toString() ? `${t}?${n.toString()}` : t;
    return (await this.request(a, {
      method: "GET",
      signal: e.signal
    })).files || [];
  }
  async save(e) {
    return this.validateParam(e.path, "path"), await this.request(this.config.url.save, {
      method: "POST",
      body: JSON.stringify({ path: e.path, content: e.content }),
      headers: this.getHeaders(),
      signal: e.signal
    });
  }
}
class Ip extends en {
  dbName;
  defaultStorage;
  storages;
  storagesSet;
  readOnly;
  version;
  db = null;
  dbPromise = null;
  entries = [];
  contentStore = /* @__PURE__ */ new Map();
  driver;
  readyPromise = null;
  constructor(e = {}) {
    super(), this.dbName = e.dbName || "vuefinder";
    const t = e.storages && e.storages.length > 0 ? e.storages : [e.storage || "indexeddb"];
    this.storages = [...new Set(t)], this.defaultStorage = e.storage || this.storages[0] || "indexeddb", this.storages.includes(this.defaultStorage) || this.storages.unshift(this.defaultStorage), this.storagesSet = new Set(this.storages), this.readOnly = !!e.readOnly, this.version = e.version || 1, this.driver = new Yo({
      files: this.entries,
      storage: this.defaultStorage,
      storages: this.storages,
      readOnly: this.readOnly,
      contentStore: this.contentStore
    }), this.readyPromise = this.loadSnapshotFromDB();
  }
  isManagedStorage(e) {
    return !!(e && this.storagesSet.has(e));
  }
  isManagedPath(e) {
    if (!e) return !1;
    const { storage: t } = this.parsePath(e);
    return this.isManagedStorage(t);
  }
  async initDB() {
    return this.dbPromise ? this.dbPromise : (this.dbPromise = new Promise((e, t) => {
      const n = indexedDB.open(this.dbName, this.version);
      n.onerror = () => t(n.error), n.onsuccess = () => {
        this.db = n.result, e(this.db);
      }, n.onupgradeneeded = (a) => {
        const d = a.target.result;
        if (!d.objectStoreNames.contains("files")) {
          const r = d.createObjectStore("files", { keyPath: "path" });
          r.createIndex("storage", "storage", { unique: !1 }), r.createIndex("dir", "dir", { unique: !1 });
        }
        d.objectStoreNames.contains("content") || d.createObjectStore("content", { keyPath: "path" });
      };
    }), this.dbPromise);
  }
  async getDB() {
    return this.db ? this.db : this.initDB();
  }
  requestToPromise(e) {
    return new Promise((t, n) => {
      e.onsuccess = () => t(e.result), e.onerror = () => n(e.error);
    });
  }
  waitTransaction(e) {
    return new Promise((t, n) => {
      e.oncomplete = () => t(), e.onerror = () => n(e.error), e.onabort = () => n(e.error);
    });
  }
  async loadSnapshotFromDB() {
    const t = (await this.getDB()).transaction(["files", "content"], "readonly"), n = t.objectStore("files"), a = t.objectStore("content"), [d, r] = await Promise.all([
      this.requestToPromise(n.getAll()),
      this.requestToPromise(a.getAll())
    ]);
    await this.waitTransaction(t), this.entries.length = 0, this.entries.push(...d.filter((l) => this.isManagedStorage(l.storage))), this.contentStore.clear();
    for (const l of r)
      this.isManagedPath(l?.path) && this.contentStore.set(l.path, l.content);
  }
  async persistSnapshot() {
    if (this.readOnly) return;
    const t = (await this.getDB()).transaction(["files", "content"], "readwrite"), n = t.objectStore("files"), a = t.objectStore("content"), d = this.requestToPromise(
      n.getAll()
    ), r = this.requestToPromise(
      a.getAll()
    ), [l, c] = await Promise.all([
      d,
      r
    ]);
    n.clear(), a.clear();
    for (const v of l)
      this.isManagedStorage(v.storage) || n.put(v);
    for (const v of c)
      this.isManagedPath(v.path) || a.put(v);
    for (const v of this.entries)
      this.isManagedStorage(v.storage) && n.put(v);
    for (const [v, w] of this.contentStore.entries())
      this.isManagedPath(v) && a.put({ path: v, content: w });
    await this.waitTransaction(t);
  }
  async ensureReady() {
    this.readyPromise || (this.readyPromise = this.loadSnapshotFromDB()), await this.readyPromise;
  }
  async list(e) {
    return await this.ensureReady(), this.driver.list(e);
  }
  async delete(e) {
    await this.ensureReady();
    const t = await this.driver.delete(e);
    return await this.persistSnapshot(), t;
  }
  async rename(e) {
    await this.ensureReady();
    const t = await this.driver.rename(e);
    return await this.persistSnapshot(), t;
  }
  async copy(e) {
    await this.ensureReady();
    const t = await this.driver.copy(e);
    return await this.persistSnapshot(), t;
  }
  async move(e) {
    await this.ensureReady();
    const t = await this.driver.move(e);
    return await this.persistSnapshot(), t;
  }
  async archive(e) {
    await this.ensureReady();
    const t = await this.driver.archive(e);
    return await this.persistSnapshot(), t;
  }
  async unarchive(e) {
    await this.ensureReady();
    const t = await this.driver.unarchive(e);
    return await this.persistSnapshot(), t;
  }
  async createFile(e) {
    await this.ensureReady();
    const t = await this.driver.createFile(e);
    return await this.persistSnapshot(), t;
  }
  async createFolder(e) {
    await this.ensureReady();
    const t = await this.driver.createFolder(e);
    return await this.persistSnapshot(), t;
  }
  getPreviewUrl(e) {
    return this.driver.getPreviewUrl(e);
  }
  async getContent(e) {
    return await this.ensureReady(), this.driver.getContent(e);
  }
  getDownloadUrl(e) {
    return this.driver.getDownloadUrl(e);
  }
  async search(e) {
    return await this.ensureReady(), this.driver.search(e);
  }
  async save(e) {
    await this.ensureReady();
    const t = await this.driver.save(e);
    return await this.persistSnapshot(), t;
  }
  configureUploader(e, t) {
    this.ensureReady(), this.driver.configureUploader?.(e, t), e && e.on("upload-success", async () => {
      try {
        await this.ensureReady(), await this.persistSnapshot();
      } catch {
      }
    });
  }
}
const Nt = {
  list: (s) => ["adapter", "list", s],
  search: (s, e, t, n) => ["adapter", "search", s, e, t, n],
  delete: (s) => ["adapter", "delete", s],
  rename: () => ["adapter", "rename"],
  copy: () => ["adapter", "copy"],
  move: () => ["adapter", "move"],
  archive: () => ["adapter", "archive"],
  unarchive: () => ["adapter", "unarchive"],
  createFile: () => ["adapter", "createFile"],
  createFolder: () => ["adapter", "createFolder"]
};
class Xo {
  driver;
  queryClient;
  config;
  onBeforeOpen;
  onAfterOpen;
  constructor(e, t = {}) {
    this.driver = e, this.onBeforeOpen = t.onBeforeOpen, this.onAfterOpen = t.onAfterOpen, this.queryClient = t.queryClient || new To({
      defaultOptions: {
        queries: {
          refetchOnWindowFocus: t.refetchOnWindowFocus ?? !1,
          staleTime: t.staleTime ?? 300 * 1e3,
          retry: t.retry ?? 2
        },
        mutations: {
          retry: t.retry ?? 1
        }
      }
    }), this.config = {
      queryClient: this.queryClient,
      refetchOnWindowFocus: t.refetchOnWindowFocus ?? !1,
      staleTime: t.staleTime ?? 300 * 1e3,
      cacheTime: t.cacheTime ?? 600 * 1e3,
      retry: t.retry ?? 2,
      onBeforeOpen: this.onBeforeOpen ?? (() => {
      }),
      onAfterOpen: this.onAfterOpen ?? (() => {
      })
    };
  }
  /**
   * Get the underlying driver instance
   */
  getDriver() {
    return this.driver;
  }
  /**
   * Get the query client instance
   */
  getQueryClient() {
    return this.queryClient;
  }
  /**
   * List files with caching and automatic refetching
   */
  async list(e) {
    const t = Nt.list(e);
    return await this.queryClient.fetchQuery({
      queryKey: t,
      queryFn: ({ signal: n }) => this.driver.list({ path: e, signal: n }),
      staleTime: this.config.staleTime
    });
  }
  /**
   * Open a path and optionally update state
   * @param path
   * @returns
   */
  async open(e) {
    this.onBeforeOpen && this.onBeforeOpen();
    try {
      const t = await this.list(e);
      return this.onAfterOpen && this.onAfterOpen(t), t;
    } catch (t) {
      if (Eo(t) || t?.name === "AbortError")
        return;
      throw t;
    }
  }
  /**
   * Cancel an in-flight list/open request. Aborts the underlying fetch via
   * the AbortSignal that TanStack Query passes to the query function.
   */
  cancelOpen(e) {
    const t = e === void 0 ? ["adapter", "list"] : Nt.list(e);
    this.queryClient.cancelQueries({ queryKey: t });
  }
  /**
   * Delete files with optimistic updates
   */
  async delete(e) {
    const t = await this.driver.delete(e);
    return this.invalidateListQueries(), t;
  }
  /**
   * Rename a file or folder
   */
  async rename(e) {
    const t = await this.driver.rename(e);
    return this.invalidateListQueries(), t;
  }
  /**
   * Copy files to a destination
   */
  async copy(e) {
    const t = await this.driver.copy(e);
    return this.invalidateListQueries(), t;
  }
  /**
   * Move files to a destination
   */
  async move(e) {
    const t = await this.driver.move(e);
    return this.invalidateListQueries(), t;
  }
  /**
   * Create a zip archive
   */
  async archive(e) {
    const t = await this.driver.archive(e);
    return this.invalidateListQueries(), t;
  }
  /**
   * Extract files from a zip archive
   */
  async unarchive(e) {
    const t = await this.driver.unarchive(e);
    return this.invalidateListQueries(), t;
  }
  /**
   * Create a new file
   */
  async createFile(e) {
    const t = await this.driver.createFile(e);
    return this.invalidateListQueries(), t;
  }
  /**
   * Create a new folder
   */
  async createFolder(e) {
    const t = await this.driver.createFolder(e);
    return this.invalidateListQueries(), t;
  }
  /**
   * Get file content (cached)
   */
  async getContent(e) {
    const t = ["adapter", "content", e.path];
    return await this.queryClient.fetchQuery({
      queryKey: t,
      queryFn: ({ signal: n }) => this.driver.getContent({ path: e.path, signal: e.signal ?? n }),
      staleTime: this.config.staleTime
    });
  }
  /**
   * Get preview URL
   */
  getPreviewUrl(e) {
    return this.driver.getPreviewUrl(e);
  }
  /**
   * Get download URL
   */
  getDownloadUrl(e) {
    return this.driver.getDownloadUrl(e);
  }
  /**
   * Search files (cached per path+filter)
   */
  async search(e) {
    const t = Nt.search(e.path, e.filter, e.deep, e.size);
    return await this.queryClient.fetchQuery({
      queryKey: t,
      queryFn: ({ signal: n }) => this.driver.search({ ...e, signal: e.signal ?? n }),
      staleTime: this.config.staleTime
    });
  }
  /**
   * Save content to file (and invalidate list cache)
   */
  async save(e) {
    const t = await this.driver.save(e);
    return this.invalidateListQueries(), t;
  }
  /**
   * Invalidate all list queries
   */
  invalidateListQueries() {
    this.queryClient.invalidateQueries({
      queryKey: ["adapter"],
      exact: !1
    });
  }
  invalidateListQuery(e) {
    this.queryClient.invalidateQueries({
      queryKey: ["adapter", "list", e],
      exact: !0
    });
  }
  /**
   * Clear all cached queries
   */
  clearCache() {
    this.queryClient.clear();
  }
}
function Qo(s) {
  const e = oe(s.state);
  return {
    current: R(() => e.value.theme || "silver"),
    set: (a) => {
      s.set("theme", a);
    }
  };
}
const Jo = (s, e) => {
  const t = Ro(s.id ?? "vf"), n = Co(), a = e.i18n, d = s.locale ?? e.locale, r = Wo(s.id ?? "vf", s.config ?? {}), l = Go();
  if (!s.driver)
    throw new Error("Driver is required for VueFinder");
  const c = new Xo(s.driver);
  return Et({
    // app version
    version: No,
    // config store
    config: r,
    // Theme
    theme: (() => {
      const v = Qo(r);
      return {
        current: v.current,
        set: v.set
      };
    })(),
    // files store
    fs: l,
    // root element
    root: null,
    // app id
    debug: s.debug ?? !1,
    // Event Bus
    emitter: n,
    // storage
    storage: t,
    // localization object
    i18n: Vo(
      t,
      d,
      n,
      a,
      r
    ),
    // modal state
    modal: jo(r),
    // adapter for file operations (always wrapped with AdapterManager)
    // Use markRaw to prevent TanStack Query from being made reactive
    adapter: go(c),
    // active features
    features: Nn(s.features),
    // selection mode
    selectionMode: s.selectionMode || "multiple",
    // selection filters - computed properties for better reactivity
    selectionFilterType: R(() => s.selectionFilterType || "both"),
    selectionFilterMimeIncludes: R(() => s.selectionFilterMimeIncludes || []),
    // treeViewData - temp. opened folders
    treeViewData: [],
    // human readable file sizes
    filesize: r.get("metricUnits") ? Hn : Zt,
    // possible items of the context menu
    contextMenuItems: s.contextMenuItems,
    // expose custom uploader if provided
    customUploader: s.customUploader
  });
}, Zo = ["data-theme"], es = { class: "vuefinder__modal-layout__container" }, ts = { class: "vuefinder__modal-layout__content" }, ns = {
  key: 0,
  class: "vuefinder__modal-layout__footer"
}, os = {
  key: 0,
  class: "vuefinder__modal-drag-overlay"
}, ss = { class: "vuefinder__modal-drag-message" }, ze = /* @__PURE__ */ le({
  __name: "ModalLayout",
  props: {
    showDragOverlay: { type: Boolean },
    dragOverlayText: {},
    onRequestClose: { type: Function },
    bodyStyle: { type: [Boolean, null, String, Object, Array] },
    bodyClass: {},
    onBodyTouchstart: { type: Function },
    onBodyTouchmove: { type: Function },
    onBodyTouchend: { type: Function },
    onBodyTouchcancel: { type: Function }
  },
  setup(s) {
    const e = M(null), t = ae();
    t.config;
    const n = s, a = () => {
      n.onRequestClose ? n.onRequestClose() : t.modal.close();
    };
    we(() => {
      const r = document.querySelector(".v-f-modal input");
      r && r.focus(), De(() => {
        if (document.querySelector(".v-f-modal input") && window.innerWidth < 768 && e.value) {
          const l = e.value.getBoundingClientRect().bottom + 16;
          window.scrollTo({
            top: l,
            left: 0,
            behavior: "smooth"
          });
        }
      });
    });
    const d = (r) => {
      r.target.classList.contains(
        "vuefinder__modal-layout__wrapper"
      ) && (r.preventDefault(), r.stopPropagation());
    };
    return (r, l) => (u(), p("div", {
      "data-theme": i(t).theme.current,
      class: "vuefinder__themer vuefinder__modal-layout",
      "aria-labelledby": "modal-title",
      role: "dialog",
      "aria-modal": "true",
      tabindex: "0",
      onKeyup: l[5] || (l[5] = je((c) => a(), ["esc"]))
    }, [
      l[6] || (l[6] = o("div", { class: "vuefinder__modal-layout__overlay" }, null, -1)),
      o("div", es, [
        o("div", {
          class: "vuefinder__modal-layout__wrapper",
          onContextmenu: d,
          onMousedown: l[4] || (l[4] = ve((c) => a(), ["self"]))
        }, [
          o("div", {
            ref_key: "modalBody",
            ref: e,
            class: te(["vuefinder__modal-layout__body", n.bodyClass]),
            style: Ee(n.bodyStyle),
            onTouchstart: l[0] || (l[0] = //@ts-ignore
            (...c) => n.onBodyTouchstart && n.onBodyTouchstart(...c)),
            onTouchmove: l[1] || (l[1] = //@ts-ignore
            (...c) => n.onBodyTouchmove && n.onBodyTouchmove(...c)),
            onTouchend: l[2] || (l[2] = //@ts-ignore
            (...c) => n.onBodyTouchend && n.onBodyTouchend(...c)),
            onTouchcancel: l[3] || (l[3] = //@ts-ignore
            (...c) => n.onBodyTouchcancel && n.onBodyTouchcancel(...c))
          }, [
            o("div", ts, [
              Me(r.$slots, "default")
            ]),
            r.$slots.buttons ? (u(), p("div", ns, [
              Me(r.$slots, "buttons")
            ])) : K("", !0)
          ], 38)
        ], 32)
      ]),
      n.showDragOverlay ? (u(), p("div", os, [
        o("div", ss, y(n.dragOverlayText || "Drag and drop the files/folders to here."), 1)
      ])) : K("", !0)
    ], 40, Zo));
  }
}), is = { class: "vuefinder__modal-header" }, as = { class: "vuefinder__modal-header__icon-container" }, ls = {
  id: "modal-title",
  class: "vuefinder__modal-header__title"
}, He = /* @__PURE__ */ le({
  __name: "ModalHeader",
  props: {
    title: {},
    icon: {}
  },
  setup(s) {
    return (e, t) => (u(), p("div", is, [
      o("div", as, [
        (u(), Z(On(s.icon), { class: "vuefinder__modal-header__icon" }))
      ]),
      o("div", ls, y(s.title), 1)
    ]));
  }
}), rs = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  viewBox: "0 0 24 24"
};
function ds(s, e) {
  return u(), p("svg", rs, [...e[0] || (e[0] = [
    o("circle", {
      cx: "12",
      cy: "12",
      r: "9"
    }, null, -1),
    o("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 8.2h.01M10.75 11.25H12v4.5m0 0h1.25m-1.25 0h-2"
    }, null, -1)
  ])]);
}
const tn = { render: ds }, cs = { class: "vuefinder__about-modal__content" }, us = { class: "vuefinder__about-modal__main" }, vs = { class: "vuefinder__about-modal__tab-content" }, fs = { class: "vuefinder__about-modal__lead" }, _s = { class: "vuefinder__about-modal__description" }, ps = { class: "vuefinder__about-modal__links" }, ms = {
  href: "https://vuefinder.ozdemir.be",
  class: "vuefinder__about-modal__link-btn",
  target: "_blank",
  rel: "noopener noreferrer"
}, hs = { class: "vuefinder__about-modal__meta" }, gs = { class: "vuefinder__about-modal__meta-item" }, ys = { class: "vuefinder__about-modal__meta-label" }, ws = { class: "vuefinder__about-modal__meta-value" }, bs = { class: "vuefinder__about-modal__meta-item" }, ks = { class: "vuefinder__about-modal__meta-label" }, Wn = /* @__PURE__ */ le({
  __name: "ModalAbout",
  setup(s) {
    const e = ae(), { t } = e.i18n;
    return (n, a) => (u(), Z(ze, null, {
      buttons: ue(() => [
        o("button", {
          type: "button",
          class: "vf-btn vf-btn-secondary",
          onClick: a[0] || (a[0] = (d) => i(e).modal.close())
        }, y(i(t)("Close")), 1)
      ]),
      default: ue(() => [
        o("div", cs, [
          X(He, {
            icon: i(tn),
            title: "Vuefinder " + i(e).version
          }, null, 8, ["icon", "title"]),
          o("div", us, [
            o("div", vs, [
              o("div", fs, y(i(t)("A modern, customizable file manager component built for Vue.")), 1),
              o("div", _s, y(i(t)("If you like it, please follow and ⭐ star on GitHub.")), 1),
              o("div", ps, [
                o("a", ms, y(i(t)("Project Home")), 1),
                a[1] || (a[1] = o("a", {
                  href: "https://github.com/n1crack/vuefinder",
                  class: "vuefinder__about-modal__link-btn",
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, " GitHub ", -1))
              ]),
              o("div", hs, [
                o("div", gs, [
                  o("span", ys, y(i(t)("Version")), 1),
                  o("span", ws, y(i(e).version), 1)
                ]),
                o("div", bs, [
                  o("span", ks, y(i(t)("License")), 1),
                  a[2] || (a[2] = o("span", { class: "vuefinder__about-modal__meta-value" }, "MIT", -1))
                ])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }));
  }
}), $s = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function xs(s, e) {
  return u(), p("svg", $s, [...e[0] || (e[0] = [
    o("path", { d: "m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21q.512.078 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48 48 0 0 0-3.478-.397m-12 .562q.51-.089 1.022-.165m0 0a48 48 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a52 52 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a49 49 0 0 0-7.5 0" }, null, -1)
  ])]);
}
const Gn = { render: xs }, Ss = { class: "vuefinder__delete-modal__content" }, Cs = { class: "vuefinder__delete-modal__form" }, Fs = { class: "vuefinder__delete-modal__description" }, Ts = { class: "vuefinder__delete-modal__files vf-scrollbar" }, Es = {
  key: 0,
  class: "vuefinder__delete-modal__icon vuefinder__delete-modal__icon--dir",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "1"
}, Ps = {
  key: 1,
  class: "vuefinder__delete-modal__icon",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "1"
}, Ds = { class: "vuefinder__delete-modal__file-name" }, Ms = { class: "vuefinder__delete-modal__confirmation" }, Is = { class: "vuefinder__delete-modal__confirmation-label" }, As = { class: "vuefinder__delete-modal__confirmation-text" }, Os = ["disabled"], Pt = /* @__PURE__ */ le({
  __name: "ModalDelete",
  setup(s) {
    const e = ae(), t = Be(e), { t: n } = e.i18n, a = e.fs, d = oe(a.path), r = M(e.modal.data.items), l = M(!1), c = () => {
      r.value.length && l.value && e.adapter.delete({
        path: d.value.path,
        items: r.value.map(({ path: v, type: w }) => ({
          path: v,
          type: w
        }))
      }).then((v) => {
        t.success(n("Files deleted.")), e.fs.setFiles(v.files), e.modal.close();
      }).catch((v) => {
        t.error(Fe(v, n("Failed to delete files")));
      });
    };
    return (v, w) => (u(), Z(ze, null, {
      buttons: ue(() => [
        o("div", Ms, [
          o("label", Is, [
            he(o("input", {
              "onUpdate:modelValue": w[0] || (w[0] = (h) => l.value = h),
              type: "checkbox",
              class: "vuefinder__delete-modal__checkbox"
            }, null, 512), [
              [lt, l.value]
            ]),
            o("span", As, y(i(n)("I'm sure delete it, This action cannot be undone.")), 1)
          ])
        ]),
        o("button", {
          type: "button",
          class: "vf-btn vf-btn-danger",
          disabled: !l.value,
          onClick: c
        }, y(i(n)("Yes, Delete!")), 9, Os),
        o("button", {
          type: "button",
          class: "vf-btn vf-btn-secondary",
          onClick: w[1] || (w[1] = (h) => i(e).modal.close())
        }, y(i(n)("Cancel")), 1)
      ]),
      default: ue(() => [
        o("div", null, [
          X(He, {
            icon: i(Gn),
            title: i(n)("Delete files")
          }, null, 8, ["icon", "title"]),
          o("div", Ss, [
            o("div", Cs, [
              o("p", Fs, y(i(n)("Are you sure you want to delete these files?")), 1),
              o("div", Ts, [
                (u(!0), p(_e, null, ge(r.value, (h) => (u(), p("p", {
                  key: h.path,
                  class: "vuefinder__delete-modal__file"
                }, [
                  h.type === "dir" ? (u(), p("svg", Es, [...w[2] || (w[2] = [
                    o("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      d: "M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
                    }, null, -1)
                  ])])) : (u(), p("svg", Ps, [...w[3] || (w[3] = [
                    o("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      d: "M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                    }, null, -1)
                  ])])),
                  o("span", Ds, y(h.basename), 1)
                ]))), 128))
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }));
  }
}), Ls = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function Rs(s, e) {
  return u(), p("svg", Ls, [...e[0] || (e[0] = [
    o("path", { d: "m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" }, null, -1)
  ])]);
}
const Yn = { render: Rs }, Bs = { class: "vuefinder__rename-modal__content" }, zs = { class: "vuefinder__rename-modal__item" }, Vs = { class: "vuefinder__rename-modal__item-info" }, Us = {
  key: 0,
  class: "vuefinder__rename-modal__icon vuefinder__rename-modal__icon--dir",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "1"
}, Ns = {
  key: 1,
  class: "vuefinder__rename-modal__icon",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "1"
}, Hs = { class: "vuefinder__rename-modal__item-name" }, Dt = /* @__PURE__ */ le({
  __name: "ModalRename",
  setup(s) {
    const e = ae(), t = Be(e), { t: n } = e.i18n, a = e.fs, d = oe(a.path), r = M(e.modal.data.items[0]), l = M(r.value.basename), c = () => {
      l.value != r.value.basename && e.adapter.rename({
        path: d.value.path,
        item: r.value.path,
        name: l.value
      }).then((v) => {
        t.success(n("%s is renamed.", l.value)), e.fs.setFiles(v.files), e.modal.close();
      }).catch((v) => {
        t.error(Fe(v, n("Failed to rename")));
      });
    };
    return (v, w) => (u(), Z(ze, null, {
      buttons: ue(() => [
        o("button", {
          type: "button",
          class: "vf-btn vf-btn-primary",
          onClick: c
        }, y(i(n)("Rename")), 1),
        o("button", {
          type: "button",
          class: "vf-btn vf-btn-secondary",
          onClick: w[1] || (w[1] = (h) => i(e).modal.close())
        }, y(i(n)("Cancel")), 1)
      ]),
      default: ue(() => [
        o("div", null, [
          X(He, {
            icon: i(Yn),
            title: i(n)("Rename")
          }, null, 8, ["icon", "title"]),
          o("div", Bs, [
            o("div", zs, [
              o("p", Vs, [
                r.value.type === "dir" ? (u(), p("svg", Us, [...w[2] || (w[2] = [
                  o("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
                  }, null, -1)
                ])])) : (u(), p("svg", Ns, [...w[3] || (w[3] = [
                  o("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                  }, null, -1)
                ])])),
                o("span", Hs, y(r.value.basename), 1)
              ]),
              he(o("input", {
                "onUpdate:modelValue": w[0] || (w[0] = (h) => l.value = h),
                class: "vuefinder__rename-modal__input",
                placeholder: "Name",
                type: "text",
                onKeyup: je(c, ["enter"])
              }, null, 544), [
                [Ke, l.value]
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }));
  }
});
function Ve() {
  const s = ae(), e = R(() => s.features);
  return {
    enabled: (n) => e.value[n] ?? !1
  };
}
function js(s, e = null) {
  return new Date(s * 1e3).toLocaleString(e ?? navigator.language ?? "en-US");
}
const Ks = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.5",
  class: "vuefinder__breadcrumb__close-icon",
  viewBox: "0 0 24 24"
};
function qs(s, e) {
  return u(), p("svg", Ks, [...e[0] || (e[0] = [
    o("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6 18 18 6M6 6l12 12"
    }, null, -1)
  ])]);
}
const Xn = { render: qs }, Ws = { class: "vuefinder__preview-chrome" }, Gs = { class: "vuefinder__preview-chrome__popover-host vuefinder__preview-chrome__info-host" }, Ys = ["title", "aria-label"], Xs = {
  key: 0,
  class: "vuefinder__preview-chrome__popover"
}, Qs = { class: "vuefinder__preview-chrome__popover-label" }, Js = { class: "vuefinder__preview-chrome__popover-value" }, Zs = ["title"], ei = { class: "vuefinder__preview-chrome__actions" }, ti = ["aria-label"], ni = {
  key: 1,
  class: "vuefinder__preview-chrome__popover-host"
}, oi = ["title", "aria-label"], si = {
  key: 0,
  class: "vuefinder__preview-chrome__popover"
}, ii = ["href", "download"], ai = { class: "vuefinder__preview-chrome__popover-hint" }, li = ["title", "aria-label"], ri = /* @__PURE__ */ le({
  name: "PreviewChrome",
  __name: "PreviewChrome",
  emits: ["close-request"],
  setup(s, { emit: e }) {
    const t = e, n = ae(), { enabled: a } = Ve(), { t: d } = n.i18n, r = oe(n.fs.sortedFiles), l = R(() => r.value.filter((f) => f.type === "file")), c = R(
      () => l.value.findIndex((f) => f.path === n.modal.data.item.path)
    ), v = R(() => l.value.length), w = R(() => n.modal.controls ?? null), h = R(() => !!i(w.value?.isEditing));
    R(() => !!i(w.value?.isDirty));
    const _ = M(!1), k = M(!1), b = (f) => {
      f === "info" ? (_.value = !_.value, k.value = !1) : (k.value = !k.value, _.value = !1);
    }, $ = (f) => {
      f.target.closest(".vuefinder__preview-chrome__popover-host") || (_.value = !1, k.value = !1);
    };
    we(() => document.addEventListener("mousedown", $)), rt(() => document.removeEventListener("mousedown", $));
    const m = R(() => {
      const f = n.modal.data.item, F = [
        { label: d("File Size"), value: n.filesize(f.file_size ?? 0) },
        { label: d("Last Modified"), value: js(f.last_modified ?? 0) }
      ];
      f.mime_type && F.push({ label: d("Type"), value: f.mime_type });
      const C = i(w.value?.extraInfo);
      if (Array.isArray(C))
        for (const A of C) F.push(A);
      return F.push({ label: d("Path"), value: f.path }), F;
    }), g = R(() => n.adapter.getDownloadUrl(n.modal.data.item));
    return (f, F) => (u(), p("div", Ws, [
      o("div", Gs, [
        o("button", {
          type: "button",
          class: te(["vuefinder__preview-chrome__info-btn", { "vuefinder__preview-chrome__info-btn--active": _.value }]),
          title: i(d)("File info"),
          "aria-label": i(d)("File info"),
          onClick: F[0] || (F[0] = (C) => b("info"))
        }, [
          X(i(tn), { class: "vuefinder__preview-chrome__icon" })
        ], 10, Ys),
        _.value ? (u(), p("div", Xs, [
          (u(!0), p(_e, null, ge(m.value, (C) => (u(), p("div", {
            key: C.label,
            class: "vuefinder__preview-chrome__popover-row"
          }, [
            o("span", Qs, y(C.label), 1),
            o("span", Js, y(C.value), 1)
          ]))), 128))
        ])) : K("", !0)
      ]),
      o("div", {
        id: "modal-title",
        class: "vuefinder__preview-chrome__title",
        title: i(n).modal.data.item.path
      }, y(i(n).modal.data.item.basename), 9, Zs),
      o("div", ei, [
        v.value > 1 && !h.value ? (u(), p("span", {
          key: 0,
          class: "vuefinder__preview-chrome__counter",
          "aria-label": i(d)("File %s of %s", String(c.value + 1), String(v.value))
        }, y(c.value + 1) + " / " + y(v.value), 9, ti)) : K("", !0),
        i(a)("download") && !h.value ? (u(), p("div", ni, [
          o("button", {
            type: "button",
            class: te(["vuefinder__preview-chrome__info-btn", { "vuefinder__preview-chrome__info-btn--active": k.value }]),
            title: i(d)("Download"),
            "aria-label": i(d)("Download"),
            onClick: F[1] || (F[1] = (C) => b("download"))
          }, [...F[3] || (F[3] = [
            o("svg", {
              class: "vuefinder__preview-chrome__icon",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "1.8",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              o("path", { d: "M12 3v12" }),
              o("path", { d: "M7 10l5 5 5-5" }),
              o("path", { d: "M5 21h14" })
            ], -1)
          ])], 10, oi),
          k.value ? (u(), p("div", si, [
            o("a", {
              href: g.value,
              download: g.value,
              target: "_blank",
              class: "vuefinder__preview-chrome__popover-action"
            }, [
              F[4] || (F[4] = o("svg", {
                class: "vuefinder__preview-chrome__icon",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "1.8",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                o("path", { d: "M12 3v12" }),
                o("path", { d: "M7 10l5 5 5-5" }),
                o("path", { d: "M5 21h14" })
              ], -1)),
              o("span", null, y(i(d)("Download")), 1)
            ], 8, ii),
            o("p", ai, y(i(d)(
              `Download doesn't work? You can try right-click "Download" button, select "Save link as...".`
            )), 1)
          ])) : K("", !0)
        ])) : K("", !0),
        o("button", {
          type: "button",
          class: "vuefinder__preview-chrome__btn vuefinder__preview-chrome__btn--icon vuefinder__preview-chrome__btn--close",
          title: i(d)("Close"),
          "aria-label": i(d)("Close"),
          onClick: F[2] || (F[2] = (C) => t("close-request"))
        }, [
          X(i(Xn), { class: "vuefinder__preview-chrome__icon vuefinder__preview-chrome__icon--lg" })
        ], 8, li)
      ])
    ]));
  }
});
function nn(s) {
  const e = ae();
  we(() => {
    if (typeof e.modal.registerControls != "function") {
      console.warn(
        "[vuefinder] PreviewControls registration skipped: app.modal.registerControls is missing. Hard refresh the page to pick up the latest modal API."
      );
      return;
    }
    e.modal.registerControls(s);
  }), rt(() => {
    typeof e.modal.unregisterControls == "function" && e.modal.unregisterControls(s);
  });
}
const di = { class: "vuefinder__text-preview" }, ci = { class: "vuefinder__text-preview__body" }, ui = {
  key: 0,
  class: "vuefinder__text-preview__content"
}, vi = /* @__PURE__ */ le({
  __name: "Text",
  emits: ["success"],
  setup(s, { emit: e }) {
    const t = Ln({
      loader: () => import("./CodeMirrorEditor-BNNnvm2Q.js").then((f) => f.Q),
      delay: 100
    }), n = e, a = M(""), d = M(""), r = M(!1), l = M(!1), c = ae(), v = Be(c), { enabled: w } = Ve(), { t: h } = c.i18n;
    we(async () => {
      try {
        const f = await c.adapter.getContent({ path: c.modal.data.item.path });
        a.value = f.content, d.value = f.content, n("success");
      } catch (f) {
        Fe(f, "Failed to load text content"), n("success");
      }
    });
    const _ = R(
      () => w("edit") && !c.fs.isReadOnly(c.modal.data.item)
    ), k = R(() => r.value), b = R(() => r.value && d.value !== a.value), $ = () => {
      d.value = a.value, r.value = !0, c.modal.setEditMode(!0);
    }, m = () => {
      r.value = !1, d.value = a.value, c.modal.setEditMode(!1);
    }, g = async () => {
      try {
        await c.adapter.save({
          path: c.modal.data.item.path,
          content: d.value
        }), a.value = d.value, v.success(h("Updated.")), r.value = !1, c.modal.setEditMode(!1), n("success");
      } catch (f) {
        v.error(Fe(f, h("Failed to save file")));
      }
    };
    return nn({
      isEditable: _,
      isEditing: k,
      isDirty: b,
      primaryActionLabel: R(() => h("Save")),
      enterEdit: $,
      commitEdit: g,
      cancelEdit: m
    }), (f, F) => (u(), p("div", di, [
      o("div", ci, [
        (u(), Z(Rn, {
          onResolve: F[2] || (F[2] = (C) => l.value = !0)
        }, {
          fallback: ue(() => [
            r.value ? he((u(), p("textarea", {
              key: 1,
              "onUpdate:modelValue": F[1] || (F[1] = (C) => d.value = C),
              class: "vuefinder__text-preview__textarea",
              name: "text",
              cols: "30",
              rows: "10"
            }, null, 512)), [
              [Ke, d.value]
            ]) : (u(), p("pre", ui, y(a.value), 1))
          ]),
          default: ue(() => [
            X(i(t), {
              "model-value": r.value ? d.value : a.value,
              readonly: !r.value,
              filename: i(c).modal.data.item.basename,
              "onUpdate:modelValue": F[0] || (F[0] = (C) => r.value ? d.value = C : null)
            }, null, 8, ["model-value", "readonly", "filename"])
          ]),
          _: 1
        })),
        he(o("span", null, y(l.value), 513), [
          [qe, !1]
        ])
      ])
    ]));
  }
}), fi = { class: "vuefinder__text-preview" }, _i = { class: "vuefinder__text-preview__body vuefinder__csv-preview__body" }, pi = {
  key: 0,
  class: "vuefinder__text-preview__content"
}, mi = {
  key: 0,
  class: "vuefinder__csv-preview__error"
}, hi = {
  key: 1,
  class: "vuefinder__csv-preview__empty"
}, gi = {
  key: 2,
  class: "vuefinder__csv-preview__table-wrap"
}, yi = { class: "vuefinder__csv-preview__table" }, wi = ["title"], bi = { class: "vuefinder__csv-preview__row-num" }, ki = ["title"], $i = {
  key: 0,
  class: "vuefinder__csv-preview__truncated"
}, xi = {
  key: 2,
  class: "vuefinder__csv-preview__view-checkbox"
}, Ht = 1e3, Si = /* @__PURE__ */ le({
  name: "CsvPreview",
  __name: "Csv",
  emits: ["success"],
  setup(s, { emit: e }) {
    const t = Ln({
      loader: () => import("./CodeMirrorEditor-BNNnvm2Q.js").then((Y) => Y.Q),
      delay: 100
    }), n = e, a = M(""), d = M(""), r = ft([]), l = ft([]), c = M(null), v = M(!1), w = M(!1), h = R(() => r.value.length > Ht), _ = R(() => h.value ? r.value.slice(0, Ht) : r.value), k = ae(), b = Be(k), { enabled: $ } = Ve(), { t: m } = k.i18n;
    async function g(Y) {
      try {
        const { parse: Q } = await import("./papaparse.min-BlyJFnW-.js").then((D) => D.p), B = Q(Y, {
          skipEmptyLines: !0,
          delimiter: ""
        });
        if (!B.data.length) {
          l.value = [], r.value = [];
          return;
        }
        const [W, ...T] = B.data;
        l.value = W ?? [], r.value = T, c.value = null;
      } catch (Q) {
        c.value = Fe(Q, m("Failed to parse CSV")), l.value = [], r.value = [];
      }
    }
    we(async () => {
      try {
        const Y = await k.adapter.getContent({ path: k.modal.data.item.path });
        a.value = Y.content, d.value = Y.content, await g(Y.content), n("success");
      } catch (Y) {
        Fe(Y, "Failed to load CSV content"), n("success");
      }
    });
    const f = R(() => !v.value && w.value), F = R(
      () => $("edit") && !k.fs.isReadOnly(k.modal.data.item)
    ), C = R(() => v.value), A = R(() => v.value && d.value !== a.value), S = () => {
      d.value = a.value, v.value = !0, w.value = !1, k.modal.setEditMode(!0);
    }, L = () => {
      v.value = !1, d.value = a.value, k.modal.setEditMode(!1);
    }, H = async () => {
      try {
        await k.adapter.save({ path: k.modal.data.item.path, content: d.value }), a.value = d.value, await g(a.value), b.success(m("Updated.")), v.value = !1, k.modal.setEditMode(!1), n("success");
      } catch (Y) {
        b.error(Fe(Y, m("Failed to save file")));
      }
    };
    return nn({
      isEditable: F,
      isEditing: C,
      isDirty: A,
      primaryActionLabel: R(() => m("Save")),
      enterEdit: S,
      commitEdit: H,
      cancelEdit: L
    }), (Y, Q) => (u(), p("div", fi, [
      o("div", _i, [
        f.value ? (u(), p(_e, { key: 1 }, [
          c.value ? (u(), p("div", mi, y(c.value), 1)) : !r.value.length && !l.value.length ? (u(), p("div", hi, y(i(m)("No rows to display")), 1)) : (u(), p("div", gi, [
            o("table", yi, [
              o("thead", null, [
                o("tr", null, [
                  Q[3] || (Q[3] = o("th", { class: "vuefinder__csv-preview__row-num" }, null, -1)),
                  (u(!0), p(_e, null, ge(l.value, (B, W) => (u(), p("th", {
                    key: W,
                    title: B
                  }, y(B), 9, wi))), 128))
                ])
              ]),
              o("tbody", null, [
                (u(!0), p(_e, null, ge(_.value, (B, W) => (u(), p("tr", { key: W }, [
                  o("td", bi, y(W + 1), 1),
                  (u(!0), p(_e, null, ge(B, (T, D) => (u(), p("td", {
                    key: D,
                    title: T
                  }, y(T), 9, ki))), 128))
                ]))), 128))
              ])
            ]),
            h.value ? (u(), p("div", $i, y(i(m)("Showing first %s rows out of %s", Ht, r.value.length)), 1)) : K("", !0)
          ]))
        ], 64)) : (u(), Z(Rn, { key: 0 }, {
          fallback: ue(() => [
            v.value ? he((u(), p("textarea", {
              key: 1,
              "onUpdate:modelValue": Q[1] || (Q[1] = (B) => d.value = B),
              class: "vuefinder__text-preview__textarea",
              name: "text",
              cols: "30",
              rows: "10"
            }, null, 512)), [
              [Ke, d.value]
            ]) : (u(), p("pre", pi, y(a.value), 1))
          ]),
          default: ue(() => [
            X(i(t), {
              "model-value": v.value ? d.value : a.value,
              readonly: !v.value,
              filename: i(k).modal.data.item.basename,
              "onUpdate:modelValue": Q[0] || (Q[0] = (B) => v.value ? d.value = B : null)
            }, null, 8, ["model-value", "readonly", "filename"])
          ]),
          _: 1
        })),
        v.value ? K("", !0) : (u(), p("label", xi, [
          he(o("input", {
            "onUpdate:modelValue": Q[2] || (Q[2] = (B) => w.value = B),
            type: "checkbox"
          }, null, 512), [
            [lt, w.value]
          ]),
          o("span", null, y(i(m)("Show as table")), 1)
        ]))
      ])
    ]));
  }
}), on = async (s, e) => {
  if (e) {
    if (e.isFile) {
      const t = await new Promise((n) => {
        e.file(n);
      });
      s(e, t);
    }
    if (e.isDirectory) {
      const t = e.createReader(), n = await new Promise((a) => {
        t.readEntries(a);
      });
      for (const a of n)
        await on(s, a);
    }
  }
}, xe = {
  PENDING: 0,
  CANCELED: 1,
  UPLOADING: 2,
  ERROR: 3,
  DONE: 10
};
function Qn(s) {
  const e = ae(), { t } = e.i18n, n = e.fs, a = oe(n.path), d = e.config, r = M({ QUEUE_ENTRY_STATUS: xe }), l = M(null), c = M(null), v = M(null), w = M(null), h = M(null), _ = M([]), k = M(""), b = M(!1), $ = M(!1), m = M(null);
  let g;
  const f = (x) => {
    x.preventDefault(), x.stopPropagation(), $.value = !0;
  }, F = (x) => {
    x.preventDefault(), x.stopPropagation(), $.value = !0;
  }, C = (x) => {
    x.preventDefault(), x.stopPropagation(), (!x.relatedTarget || x.relatedTarget === document.body) && ($.value = !1);
  }, A = (x) => {
    x.preventDefault(), x.stopPropagation(), $.value = !1;
    const U = /^[/\\](.+)/, E = x.dataTransfer;
    E && (E.items && E.items.length ? Array.from(E.items).forEach((V) => {
      if (V.kind === "file") {
        const I = V.webkitGetAsEntry?.();
        if (I)
          on((O, q) => {
            const P = U.exec(O?.fullPath || "");
            L(q, P ? P[1] : q.name);
          }, I);
        else {
          const O = V.getAsFile?.();
          O && L(O);
        }
      }
    }) : E.files && E.files.length && Array.from(E.files).forEach((V) => L(V)));
  }, S = (x) => _.value.findIndex((U) => U.id === x), L = (x, U) => g.addFile({ name: U || x.name, type: x.type, data: x, source: "Local" }), H = (x) => x.status === xe.DONE ? "text-green-600" : x.status === xe.ERROR || x.status === xe.CANCELED ? "text-red-600" : "", Y = (x) => x.status === xe.DONE ? "✓" : x.status === xe.ERROR || x.status === xe.CANCELED ? "!" : "...", Q = () => w.value?.click(), B = () => e.modal.close(), W = (x) => {
    if (b.value || !_.value.filter((U) => U.status !== xe.DONE).length) {
      b.value || (k.value = t("Please select file to upload first."));
      return;
    }
    k.value = "", m.value = x || a.value, g.upload();
  }, T = () => {
    g.cancelAll(), _.value.forEach((x) => {
      x.status !== xe.DONE && (x.status = xe.CANCELED, x.statusName = t("Canceled"));
    }), b.value = !1;
  }, D = (x) => {
    b.value || (g.removeFile(x.id), _.value.splice(S(x.id), 1));
  }, N = (x) => {
    if (!b.value)
      if (g.cancelAll(), x) {
        const U = _.value.filter((E) => E.status !== xe.DONE);
        _.value = [], U.forEach((E) => L(E.originalFile, E.name));
      } else
        _.value = [];
  }, J = (x) => {
    x.forEach((U) => {
      L(U);
    });
  }, ce = (x, U) => x.endsWith("://") || x.endsWith("/") ? x + U : x + "/" + U, z = async (x, U) => {
    const E = U.trim();
    if (b.value || !E) return;
    if (E.includes("/") || E.includes("\\")) {
      k.value = t("Name cannot contain slashes.");
      return;
    }
    const V = x.name.split("/");
    V[V.length - 1] = E;
    const I = V.join("/");
    if (I === x.name) return;
    if (x.status === xe.DONE) {
      const me = m.value?.path || a.value.path, G = ce(me, x.name), se = x.name.split("/");
      se.pop();
      const fe = se.length ? ce(me, se.join("/")) : me;
      try {
        await e.adapter.rename({ path: fe, item: G, name: E }), x.name = I, e.adapter.invalidateListQuery(me), me === a.value.path && e.adapter.open(me);
      } catch (be) {
        k.value = be?.message || t("Failed to rename");
      }
      return;
    }
    const O = S(x.id);
    if (O === -1) return;
    const q = x.originalFile, P = x.name;
    g.removeFile(x.id), _.value.splice(O, 1);
    let j;
    try {
      j = L(q, I);
    } catch (me) {
      k.value = me?.message || t("Failed to rename");
      try {
        L(q, P);
      } catch {
      }
      return;
    }
    if (!j) return;
    const de = S(j);
    if (de !== -1 && de !== O) {
      const me = _.value.splice(de, 1)[0];
      me && _.value.splice(O, 0, me);
    }
  };
  return we(() => {
    g = new Po({
      debug: e.debug,
      restrictions: { maxFileSize: Ho(d.get("maxFileSize") ?? "10mb") },
      locale: e.i18n.t("uppy"),
      onBeforeFileAdded: (V, I) => {
        if (I[V.id] != null) {
          const q = S(V.id);
          _.value[q]?.status === xe.PENDING && (k.value = g.i18n("noDuplicates", { fileName: V.name })), _.value = _.value.filter((P) => P.id !== V.id);
        }
        return _.value.push({
          id: V.id,
          name: V.name,
          size: e.filesize(V.size),
          status: xe.PENDING,
          statusName: t("Pending upload"),
          percent: null,
          originalFile: V.data
        }), !0;
      }
    });
    const x = {
      getTargetPath: () => (m.value || a.value).path
    };
    if (s)
      s(g, x);
    else if (e.adapter.getDriver().configureUploader)
      e.adapter.getDriver().configureUploader(g, x);
    else
      throw new Error("No uploader configured");
    g.on("restriction-failed", (V, I) => {
      const O = _.value[S(V.id)];
      O && D(O), k.value = I.message;
    }), g.on("upload-start", (V) => {
      V.forEach((I) => {
        const O = _.value[S(I.id)];
        O && (O.status = xe.UPLOADING, O.statusName = t("Uploading"), O.percent = "0%");
      });
    }), g.on("upload-progress", (V, I) => {
      const O = I.bytesTotal ?? 1, q = Math.floor(I.bytesUploaded / O * 100), P = S(V.id);
      P !== -1 && _.value[P] && (_.value[P].percent = `${q}%`);
    }), g.on("upload-success", (V) => {
      const I = _.value[S(V.id)];
      I && (I.status = xe.DONE, I.statusName = t("Done"));
    }), g.on("upload-error", (V, I) => {
      const O = _.value[S(V.id)];
      O && (O.percent = null, O.status = xe.ERROR, O.statusName = I?.isNetworkError ? t("Network Error, Unable establish connection to the server or interrupted.") : I?.message || t("Unknown Error"));
    }), g.on("error", (V) => {
      k.value = V.message, b.value = !1;
    }), g.on("complete", (V) => {
      b.value = !1;
      const I = m.value || a.value;
      e.adapter.invalidateListQuery(I.path), e.adapter.open(I.path);
      const O = _.value.filter(
        (q) => q.status === xe.DONE && V.successful.includes(q.id)
      ).map((q) => q.name);
      e.emitter.emit("vf-upload-complete", O);
    }), w.value?.addEventListener("click", () => c.value?.click()), h.value?.addEventListener("click", () => v.value?.click());
    const U = { capture: !0 };
    document.addEventListener("dragover", f, U), document.addEventListener("dragenter", F, U), document.addEventListener("dragleave", C, U), document.addEventListener("drop", A, U);
    const E = (V) => {
      const I = V.target, O = I.files;
      if (O) {
        for (const q of O) L(q);
        I.value = "";
      }
    };
    c.value?.addEventListener("change", E), v.value?.addEventListener("change", E);
  }), Pe(() => {
    const x = { capture: !0 };
    document.removeEventListener("dragover", f, x), document.removeEventListener("dragenter", F, x), document.removeEventListener("dragleave", C, x), document.removeEventListener("drop", A, x);
  }), {
    container: l,
    internalFileInput: c,
    internalFolderInput: v,
    pickFiles: w,
    pickFolders: h,
    queue: _,
    message: k,
    uploading: b,
    hasFilesInDropArea: $,
    definitions: r,
    openFileSelector: Q,
    upload: W,
    cancel: T,
    remove: D,
    clear: N,
    close: B,
    getClassNameForEntry: H,
    getIconForEntry: Y,
    addExternalFiles: J,
    renameEntry: z
  };
}
const xn = "image/png", sn = "image/jpeg", Ci = "image/webp";
function Fi(s) {
  const e = (s.split(".").pop() ?? "").toLowerCase();
  return e === "png" ? xn : e === "webp" ? Ci : e === "gif" ? xn : sn;
}
function Jn(s) {
  return new Promise((e, t) => {
    const n = new Image();
    n.crossOrigin = "anonymous", n.onload = () => e(n), n.onerror = () => t(new Error("Failed to load image")), n.src = s;
  });
}
function Zn(s, e) {
  const t = document.createElement("canvas");
  t.width = s, t.height = e;
  const n = t.getContext("2d");
  if (!n) throw new Error("Could not acquire 2D canvas context");
  return { canvas: t, ctx: n };
}
async function Sn(s, e, t) {
  const n = await Jn(s), { canvas: a, ctx: d } = Zn(n.naturalWidth, n.naturalHeight);
  return d.filter = e, d.drawImage(n, 0, 0), a.toDataURL(t, t === sn ? 0.92 : void 0);
}
async function Ti(s, e, t, n, a) {
  const d = await Jn(s), r = d.naturalWidth, l = d.naturalHeight, c = e === 90 || e === 270, { canvas: v, ctx: w } = Zn(c ? l : r, c ? r : l);
  return w.translate(v.width / 2, v.height / 2), e && w.rotate(e * Math.PI / 180), (t || n) && w.scale(t ? -1 : 1, n ? -1 : 1), w.drawImage(d, -r / 2, -l / 2), v.toDataURL(a, a === sn ? 0.92 : void 0);
}
function Ei(s, e, t) {
  const n = 1 + s / 100, a = 1 + e / 100, d = 1 + t / 100;
  return `brightness(${n}) contrast(${a}) saturate(${d})`;
}
async function Pi(s) {
  return await (await fetch(s)).blob();
}
const Di = { class: "vuefinder__image-editor" }, Mi = {
  class: "vuefinder__image-editor__strip",
  role: "tablist"
}, Ii = ["aria-selected", "onClick"], Ai = {
  key: 0,
  class: "vuefinder__image-editor__tab-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, Oi = {
  key: 1,
  class: "vuefinder__image-editor__tab-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, Li = {
  key: 2,
  class: "vuefinder__image-editor__tab-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, Ri = {
  key: 3,
  class: "vuefinder__image-editor__tab-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, Bi = { class: "vuefinder__image-editor__tab-label" }, zi = {
  key: 0,
  class: "vuefinder__image-editor__panel"
}, Vi = { class: "vuefinder__image-editor__stage" }, Ui = { class: "vuefinder__image-editor__controls" }, Ni = { class: "vuefinder__image-editor__chips" }, Hi = ["onClick"], ji = ["disabled"], Ki = {
  key: 1,
  class: "vuefinder__image-editor__panel"
}, qi = { class: "vuefinder__image-editor__stage" }, Wi = ["src", "alt"], Gi = { class: "vuefinder__image-editor__controls" }, Yi = { class: "vuefinder__image-editor__rotate-btns" }, Xi = ["title"], Qi = ["title"], Ji = ["title"], Zi = ["title"], ea = ["disabled"], ta = {
  key: 2,
  class: "vuefinder__image-editor__panel"
}, na = { class: "vuefinder__image-editor__stage" }, oa = ["src", "alt"], sa = { class: "vuefinder__image-editor__controls" }, ia = { class: "vuefinder__image-editor__toggle" }, aa = ["disabled"], la = {
  key: 3,
  class: "vuefinder__image-editor__panel"
}, ra = { class: "vuefinder__image-editor__stage" }, da = ["src", "alt"], ca = { class: "vuefinder__image-editor__controls vuefinder__image-editor__controls--stacked" }, ua = { class: "vuefinder__image-editor__slider" }, va = { class: "vuefinder__image-editor__slider" }, fa = { class: "vuefinder__image-editor__slider" }, _a = { class: "vuefinder__image-editor__row" }, pa = ["disabled"], ma = /* @__PURE__ */ le({
  name: "ImageEditor",
  __name: "ImageEditor",
  props: {
    src: {},
    filename: {}
  },
  emits: ["update:src"],
  setup(s, { emit: e }) {
    const t = s, n = e, a = ae(), { t: d } = a.i18n, r = M("crop"), l = M(!1), c = M(null), v = [
      { label: "Original", value: null },
      { label: "1:1", value: 1 },
      { label: "4:3", value: 4 / 3 },
      { label: "16:9", value: 16 / 9 },
      { label: "9:16", value: 9 / 16 }
    ], w = st("cropperRef"), h = M(0), _ = M(!1), k = M(!1), b = M(!1), $ = M(0), m = M(0), g = M(0), f = R(
      () => Ei($.value, m.value, g.value)
    );
    pe([() => t.src, r], () => {
      h.value = 0, _.value = !1, k.value = !1, b.value = !1, $.value = 0, m.value = 0, g.value = 0;
    });
    const F = R(() => Fi(t.filename)), C = R(() => {
      const x = [];
      return h.value && x.push(`rotate(${h.value}deg)`), _.value && x.push("scaleX(-1)"), k.value && x.push("scaleY(-1)"), x.length ? { transform: x.join(" ") } : {};
    }), A = (x) => {
      l.value || (r.value = x);
    }, S = () => {
      const U = w.value?.getResult()?.canvas;
      if (!U) return;
      const E = U.toDataURL(F.value, F.value === "image/jpeg" ? 0.92 : void 0);
      n("update:src", E);
    }, L = async () => {
      if (J.value) {
        l.value = !0;
        try {
          const x = await Ti(
            t.src,
            N.value,
            _.value,
            k.value,
            F.value
          );
          n("update:src", x);
        } finally {
          l.value = !1;
        }
      }
    }, H = async () => {
      if (b.value) {
        l.value = !0;
        try {
          const x = await Sn(t.src, "grayscale(1)", F.value);
          n("update:src", x);
        } finally {
          l.value = !1;
        }
      }
    }, Y = async () => {
      if (!($.value === 0 && m.value === 0 && g.value === 0)) {
        l.value = !0;
        try {
          const x = await Sn(t.src, f.value, F.value);
          n("update:src", x);
        } finally {
          l.value = !1;
        }
      }
    }, Q = () => {
      $.value = 0, m.value = 0, g.value = 0;
    }, B = () => {
      h.value -= 90;
    }, W = () => {
      h.value += 90;
    }, T = () => {
      _.value = !_.value;
    }, D = () => {
      k.value = !k.value;
    }, N = R(
      () => (h.value % 360 + 360) % 360
    ), J = R(
      () => N.value !== 0 || _.value || k.value
    ), ce = R(
      () => $.value !== 0 || m.value !== 0 || g.value !== 0
    ), z = R(() => b.value);
    return (x, U) => (u(), p("div", Di, [
      o("div", Mi, [
        (u(), p(_e, null, ge(["crop", "rotate", "grayscale", "adjust"], (E) => o("button", {
          key: E,
          type: "button",
          role: "tab",
          "aria-selected": r.value === E,
          class: te(["vuefinder__image-editor__tab", { "vuefinder__image-editor__tab--active": r.value === E }]),
          onClick: (V) => A(E)
        }, [
          E === "crop" ? (u(), p("svg", Ai, [...U[4] || (U[4] = [
            o("path", { d: "M6 2v16a2 2 0 0 0 2 2h14" }, null, -1),
            o("path", { d: "M2 6h16a2 2 0 0 1 2 2v14" }, null, -1)
          ])])) : E === "rotate" ? (u(), p("svg", Oi, [...U[5] || (U[5] = [
            o("polyline", { points: "23 4 23 10 17 10" }, null, -1),
            o("path", { d: "M20.49 15a9 9 0 1 1-2.12-9.36L23 10" }, null, -1)
          ])])) : E === "grayscale" ? (u(), p("svg", Li, [...U[6] || (U[6] = [
            o("circle", {
              cx: "12",
              cy: "12",
              r: "9"
            }, null, -1),
            o("path", { d: "M12 3v18" }, null, -1),
            o("path", {
              d: "M12 3a9 9 0 0 0 0 18",
              fill: "currentColor"
            }, null, -1)
          ])])) : (u(), p("svg", Ri, [...U[7] || (U[7] = [
            St('<line x1="4" y1="6" x2="14" y2="6"></line><circle cx="17" cy="6" r="2"></circle><line x1="10" y1="12" x2="20" y2="12"></line><circle cx="7" cy="12" r="2"></circle><line x1="4" y1="18" x2="14" y2="18"></line><circle cx="17" cy="18" r="2"></circle>', 6)
          ])])),
          o("span", Bi, y(E === "crop" ? i(d)("Crop") : E === "rotate" ? i(d)("Rotate") : E === "grayscale" ? i(d)("Grayscale") : i(d)("Adjust")), 1)
        ], 10, Ii)), 64))
      ]),
      r.value === "crop" ? (u(), p("div", zi, [
        o("div", Vi, [
          X(i(Do), {
            ref_key: "cropperRef",
            ref: w,
            class: "vuefinder__image-editor__cropper",
            crossorigin: "anonymous",
            src: t.src,
            "stencil-props": c.value === null ? {} : { aspectRatio: c.value },
            "auto-zoom": !0,
            priority: "image",
            transitions: !0
          }, null, 8, ["src", "stencil-props"])
        ]),
        o("div", Ui, [
          o("div", Ni, [
            (u(), p(_e, null, ge(v, (E) => o("button", {
              key: E.label,
              type: "button",
              class: te(["vuefinder__image-editor__chip", { "vuefinder__image-editor__chip--active": c.value === E.value }]),
              onClick: (V) => c.value = E.value
            }, y(i(d)(E.label)), 11, Hi)), 64))
          ]),
          o("button", {
            type: "button",
            class: "vuefinder__image-editor__apply",
            disabled: l.value,
            onClick: S
          }, y(i(d)("Apply")), 9, ji)
        ])
      ])) : r.value === "rotate" ? (u(), p("div", Ki, [
        o("div", qi, [
          o("img", {
            class: "vuefinder__image-editor__preview",
            src: t.src,
            style: Ee(C.value),
            alt: t.filename
          }, null, 12, Wi)
        ]),
        o("div", Gi, [
          o("div", Yi, [
            o("button", {
              type: "button",
              class: "vuefinder__image-editor__icon-btn",
              title: i(d)("Rotate left 90°"),
              onClick: B
            }, [...U[8] || (U[8] = [
              o("svg", {
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "1.8",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                o("polyline", { points: "1 4 1 10 7 10" }),
                o("path", { d: "M3.51 15a9 9 0 1 0 2.13-9.36L1 10" })
              ], -1)
            ])], 8, Xi),
            o("button", {
              type: "button",
              class: "vuefinder__image-editor__icon-btn",
              title: i(d)("Rotate right 90°"),
              onClick: W
            }, [...U[9] || (U[9] = [
              o("svg", {
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "1.8",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                o("polyline", { points: "23 4 23 10 17 10" }),
                o("path", { d: "M20.49 15a9 9 0 1 1-2.12-9.36L23 10" })
              ], -1)
            ])], 8, Qi),
            o("button", {
              type: "button",
              class: te(["vuefinder__image-editor__icon-btn", { "vuefinder__image-editor__icon-btn--active": _.value }]),
              title: i(d)("Flip horizontal"),
              onClick: T
            }, [...U[10] || (U[10] = [
              St('<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="8 3 4 7 8 11"></polyline><polyline points="16 3 20 7 16 11"></polyline><line x1="4" y1="7" x2="20" y2="7"></line><line x1="12" y1="13" x2="12" y2="21"></line></svg>', 1)
            ])], 10, Ji),
            o("button", {
              type: "button",
              class: te(["vuefinder__image-editor__icon-btn", { "vuefinder__image-editor__icon-btn--active": k.value }]),
              title: i(d)("Flip vertical"),
              onClick: D
            }, [...U[11] || (U[11] = [
              St('<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 8 7 4 11 8"></polyline><polyline points="3 16 7 20 11 16"></polyline><line x1="7" y1="4" x2="7" y2="20"></line><line x1="13" y1="12" x2="21" y2="12"></line></svg>', 1)
            ])], 10, Zi)
          ]),
          o("button", {
            type: "button",
            class: "vuefinder__image-editor__apply",
            disabled: l.value || !J.value,
            onClick: L
          }, y(i(d)("Apply")), 9, ea)
        ])
      ])) : r.value === "grayscale" ? (u(), p("div", ta, [
        o("div", na, [
          o("img", {
            class: "vuefinder__image-editor__preview",
            src: t.src,
            style: Ee(b.value ? { filter: "grayscale(1)" } : {}),
            alt: t.filename
          }, null, 12, oa)
        ]),
        o("div", sa, [
          o("label", ia, [
            he(o("input", {
              "onUpdate:modelValue": U[0] || (U[0] = (E) => b.value = E),
              type: "checkbox"
            }, null, 512), [
              [lt, b.value]
            ]),
            o("span", null, y(i(d)("Grayscale")), 1)
          ]),
          o("button", {
            type: "button",
            class: "vuefinder__image-editor__apply",
            disabled: l.value || !z.value,
            onClick: H
          }, y(i(d)("Apply")), 9, aa)
        ])
      ])) : (u(), p("div", la, [
        o("div", ra, [
          o("img", {
            class: "vuefinder__image-editor__preview",
            src: t.src,
            style: Ee({ filter: f.value }),
            alt: t.filename
          }, null, 12, da)
        ]),
        o("div", ca, [
          o("div", ua, [
            o("label", null, [
              ye(y(i(d)("Brightness")), 1),
              o("span", null, y($.value), 1)
            ]),
            he(o("input", {
              "onUpdate:modelValue": U[1] || (U[1] = (E) => $.value = E),
              type: "range",
              min: "-100",
              max: "100",
              step: "1"
            }, null, 512), [
              [
                Ke,
                $.value,
                void 0,
                { number: !0 }
              ]
            ])
          ]),
          o("div", va, [
            o("label", null, [
              ye(y(i(d)("Contrast")), 1),
              o("span", null, y(m.value), 1)
            ]),
            he(o("input", {
              "onUpdate:modelValue": U[2] || (U[2] = (E) => m.value = E),
              type: "range",
              min: "-100",
              max: "100",
              step: "1"
            }, null, 512), [
              [
                Ke,
                m.value,
                void 0,
                { number: !0 }
              ]
            ])
          ]),
          o("div", fa, [
            o("label", null, [
              ye(y(i(d)("Saturation")), 1),
              o("span", null, y(g.value), 1)
            ]),
            he(o("input", {
              "onUpdate:modelValue": U[3] || (U[3] = (E) => g.value = E),
              type: "range",
              min: "-100",
              max: "100",
              step: "1"
            }, null, 512), [
              [
                Ke,
                g.value,
                void 0,
                { number: !0 }
              ]
            ])
          ]),
          o("div", _a, [
            o("button", {
              type: "button",
              class: "vuefinder__image-editor__reset",
              onClick: Q
            }, y(i(d)("Reset")), 1),
            o("button", {
              type: "button",
              class: "vuefinder__image-editor__apply",
              disabled: l.value || !ce.value,
              onClick: Y
            }, y(i(d)("Apply")), 9, pa)
          ])
        ])
      ]))
    ]));
  }
}), ha = { class: "vuefinder__image-preview" }, ga = ["src"], ya = ["aria-label", "title"], wa = ["aria-label", "title"], ba = ["aria-label", "title"], ka = 0.5, $a = 3, Cn = 0.25, xa = /* @__PURE__ */ le({
  name: "ImagePreview",
  __name: "Image",
  emits: ["success"],
  setup(s, { emit: e }) {
    const t = e, n = ae(), a = Be(n), { enabled: d } = Ve(), { t: r } = n.i18n, l = M(!1), c = M(
      n.modal.data.item.previewUrl ?? n.adapter.getPreviewUrl({ path: n.modal.data.item.path })
    ), v = M(c.value), w = M(!1), h = M(1), _ = M(null), k = M(0), b = M(0), $ = M(1), m = M(!1), g = M(0), f = M(0);
    let F = null, C = 0, A = 0, S = 0, L = 0;
    const { addExternalFiles: H, upload: Y, queue: Q } = Qn(n.customUploader), B = n.fs, W = oe(B.path), T = R(() => k.value * $.value), D = R(() => b.value * $.value), N = (G, se) => {
      const fe = _.value?.clientWidth ?? 0, be = _.value?.clientHeight ?? 0, Ie = Math.max(0, (T.value * h.value - fe) / 2), tt = Math.max(0, (D.value * h.value - be) / 2);
      return {
        x: Math.min(Ie, Math.max(-Ie, G)),
        y: Math.min(tt, Math.max(-tt, se))
      };
    }, J = R(() => {
      if (!k.value || !b.value)
        return {};
      const { x: G, y: se } = N(g.value, f.value);
      return {
        width: `${T.value}px`,
        height: `${D.value}px`,
        transform: `translate(${G}px, ${se}px) scale(${h.value})`,
        transformOrigin: "center center"
      };
    }), ce = () => {
      if (!_.value || !k.value || !b.value) return;
      const G = _.value.getBoundingClientRect();
      !G.width || !G.height || ($.value = Math.min(G.width / k.value, G.height / b.value));
    }, z = (G) => {
      const se = G.target;
      se instanceof HTMLImageElement && (k.value = se.naturalWidth || se.clientWidth, b.value = se.naturalHeight || se.clientHeight, ce());
    }, x = (G) => Math.min($a, Math.max(ka, G)), U = () => {
      h.value = x(Number((h.value + Cn).toFixed(2)));
      const G = N(g.value, f.value);
      g.value = G.x, f.value = G.y;
    }, E = () => {
      h.value = x(Number((h.value - Cn).toFixed(2)));
      const G = N(g.value, f.value);
      g.value = G.x, f.value = G.y;
    }, V = () => {
      h.value = 1, g.value = 0, f.value = 0;
    }, I = (G) => {
      l.value || (G.deltaY > 0 ? E() : G.deltaY < 0 && U());
    }, O = (G) => {
      if (l.value) return;
      const se = G.target;
      if (se instanceof HTMLInputElement || se instanceof HTMLTextAreaElement || se?.isContentEditable)
        return;
      const fe = G.key === "=" || G.key === "+", be = G.key === "-" || G.key === "_", Ie = G.key === "0";
      if (!(!fe && !be && !Ie)) {
        if (G.preventDefault(), fe) {
          U();
          return;
        }
        if (be) {
          E();
          return;
        }
        V();
      }
    }, q = () => {
      m.value = !1;
    }, P = (G) => {
      l.value || h.value <= 1 || !_.value || (m.value = !0, C = G.clientX, A = G.clientY, S = g.value, L = f.value, G.currentTarget?.setPointerCapture?.(G.pointerId));
    }, j = (G) => {
      if (!m.value) return;
      const se = G.clientX - C, fe = G.clientY - A, be = N(S + se, L + fe);
      g.value = be.x, f.value = be.y;
    };
    nn({
      isEditable: R(
        () => d("edit") && !n.fs.isReadOnly(n.modal.data.item)
      ),
      isEditing: R(() => l.value),
      isDirty: R(() => l.value && w.value),
      primaryActionLabel: R(() => r("Save")),
      enterEdit: () => {
        v.value = c.value, w.value = !1, l.value = !0, n.modal.setEditMode(!0);
      },
      commitEdit: () => me(),
      cancelEdit: () => {
        l.value = !1, v.value = c.value, w.value = !1, n.modal.setEditMode(!1);
      },
      extraInfo: R(() => !k.value || !b.value ? [] : [{ label: r("Dimensions"), value: `${k.value} × ${b.value}` }])
    });
    const de = (G) => {
      v.value = G, w.value = !0;
    }, me = async () => {
      if (!w.value) return;
      const G = n.modal.data.item.basename, se = G.split(".").pop()?.toLowerCase() || "jpg", fe = se === "png" ? "image/png" : se === "gif" ? "image/gif" : "image/jpeg";
      try {
        const be = await Pi(v.value), Ie = new File([be], G, { type: fe }), ee = n.modal.data.item.path.split("/");
        ee.pop();
        const ie = {
          path: ee.join("/") || (W.value?.path ?? "")
        };
        H([Ie]), await new Promise((Se) => setTimeout(Se, 100));
        const re = Q.value.find((Se) => Se.name === Ie.name);
        if (!re)
          throw new Error("File was not added to upload queue");
        Y(ie);
        let Ue = 0;
        for (; Ue < 150; ) {
          await new Promise((We) => setTimeout(We, 200));
          const Se = Q.value.find((We) => We.id === re.id);
          if (Se?.status === xe.DONE) break;
          if (Se?.status === xe.ERROR)
            throw new Error(Se.statusName || "Upload failed");
          Ue++;
        }
        a.success(r("Updated.")), await fetch(c.value, { cache: "reload", mode: "no-cors" });
        const Te = n.root?.querySelector?.('[data-src="' + c.value + '"]');
        Te && Te instanceof HTMLElement && qt.resetStatus(Te), n.emitter.emit("vf-refresh-thumbnails"), l.value = !1, w.value = !1, v.value = c.value, n.modal.setEditMode(!1), t("success");
      } catch (be) {
        a.error(Fe(be, r("Failed to save image")));
      }
    };
    return we(() => {
      F = new ResizeObserver(() => {
        ce();
      }), _.value && F.observe(_.value), window.addEventListener("keydown", O), t("success");
    }), rt(() => {
      window.removeEventListener("keydown", O), F?.disconnect();
    }), (G, se) => (u(), p("div", ha, [
      o("div", {
        ref_key: "imageContainer",
        ref: _,
        class: "vuefinder__image-preview__image-container"
      }, [
        l.value ? (u(), Z(ma, {
          key: 1,
          src: v.value,
          filename: i(n).modal.data.item.basename,
          "onUpdate:src": de
        }, null, 8, ["src", "filename"])) : (u(), p("div", {
          key: 0,
          class: "vuefinder__image-preview__stage",
          onWheel: ve(I, ["prevent"])
        }, [
          o("img", {
            style: Ee(J.value),
            src: i(n).modal.data.item.previewUrl ?? i(n).adapter.getPreviewUrl({ path: i(n).modal.data.item.path }),
            class: te(["vuefinder__image-preview__image", {
              "vuefinder__image-preview__image--zoomed": h.value > 1,
              "vuefinder__image-preview__image--panning": m.value
            }]),
            draggable: !1,
            onLoad: z,
            onPointerdown: P,
            onPointermove: j,
            onPointerup: q,
            onPointercancel: q,
            onLostpointercapture: q
          }, null, 46, ga),
          o("div", {
            class: "vuefinder__image-preview__zoom-controls",
            onPointerdown: se[0] || (se[0] = ve(() => {
            }, ["stop"])),
            onWheel: se[1] || (se[1] = ve(() => {
            }, ["stop"]))
          }, [
            o("button", {
              type: "button",
              class: "vuefinder__image-preview__zoom-button",
              "aria-label": i(r)("Zoom out"),
              title: i(r)("Zoom out"),
              onClick: E
            }, [...se[2] || (se[2] = [
              o("svg", {
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2"
              }, [
                o("circle", {
                  cx: "11",
                  cy: "11",
                  r: "7"
                }),
                o("line", {
                  x1: "8",
                  y1: "11",
                  x2: "14",
                  y2: "11"
                }),
                o("line", {
                  x1: "16.5",
                  y1: "16.5",
                  x2: "21",
                  y2: "21"
                })
              ], -1)
            ])], 8, ya),
            o("button", {
              type: "button",
              class: "vuefinder__image-preview__zoom-reset",
              "aria-label": i(r)("Reset zoom"),
              title: i(r)("Reset zoom"),
              onClick: V
            }, y(Math.round(h.value * 100)) + "% ", 9, wa),
            o("button", {
              type: "button",
              class: "vuefinder__image-preview__zoom-button",
              "aria-label": i(r)("Zoom in"),
              title: i(r)("Zoom in"),
              onClick: U
            }, [...se[3] || (se[3] = [
              St('<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="7"></circle><line x1="11" y1="8" x2="11" y2="14"></line><line x1="8" y1="11" x2="14" y2="11"></line><line x1="16.5" y1="16.5" x2="21" y2="21"></line></svg>', 1)
            ])], 8, ba)
          ], 32)
        ], 32))
      ], 512)
    ]));
  }
}), Sa = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
function Ca(s, e) {
  return u(), p("svg", Sa, [...e[0] || (e[0] = [
    o("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M7 21h10a2 2 0 0 0 2-2V9.414a1 1 0 0 0-.293-.707l-5.414-5.414A1 1 0 0 0 12.586 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2"
    }, null, -1)
  ])]);
}
const gt = { render: Ca }, Fa = { class: "vuefinder__default-preview" }, Ta = { class: "vuefinder__default-preview__content" }, Ea = { class: "vuefinder__default-preview__icon-container" }, Pa = ["title"], Da = /* @__PURE__ */ le({
  __name: "Default",
  emits: ["success"],
  setup(s, { emit: e }) {
    const t = ae(), n = e;
    return we(() => {
      n("success");
    }), (a, d) => (u(), p("div", Fa, [
      o("div", Ta, [
        o("div", Ea, [
          X(i(gt), { class: "vuefinder__default-preview__file-icon" }),
          o("div", {
            class: "vuefinder__default-preview__file-name",
            title: i(t).modal.data.item.path
          }, y(i(t).modal.data.item.basename), 9, Pa)
        ])
      ])
    ]));
  }
}), Ma = { class: "vuefinder__video-preview" }, Ia = {
  class: "vuefinder__video-preview__video",
  preload: "metadata",
  controls: ""
}, Aa = ["src"], Oa = /* @__PURE__ */ le({
  __name: "Video",
  emits: ["success"],
  setup(s, { emit: e }) {
    const t = ae(), n = e, a = () => t.adapter.getPreviewUrl({ path: t.modal.data.item.path });
    return we(() => {
      n("success");
    }), (d, r) => (u(), p("div", Ma, [
      o("div", null, [
        o("video", Ia, [
          o("source", {
            src: a(),
            type: "video/mp4"
          }, null, 8, Aa),
          r[0] || (r[0] = ye(" Your browser does not support the video tag. ", -1))
        ])
      ])
    ]));
  }
}), La = { class: "vuefinder__audio-preview" }, Ra = {
  class: "vuefinder__audio-preview__audio",
  controls: ""
}, Ba = ["src"], za = /* @__PURE__ */ le({
  __name: "Audio",
  emits: ["success"],
  setup(s, { emit: e }) {
    const t = e;
    ae();
    const n = () => {
      const a = ae();
      return a.adapter.getPreviewUrl({ path: a.modal.data.item.path });
    };
    return we(() => {
      t("success");
    }), (a, d) => (u(), p("div", La, [
      o("div", null, [
        o("audio", Ra, [
          o("source", {
            src: n(),
            type: "audio/mpeg"
          }, null, 8, Ba),
          d[0] || (d[0] = ye(" Your browser does not support the audio element. ", -1))
        ])
      ])
    ]));
  }
}), Va = { class: "vuefinder__pdf-preview" }, Ua = ["data"], Na = ["src"], Ha = /* @__PURE__ */ le({
  __name: "Pdf",
  emits: ["success"],
  setup(s, { emit: e }) {
    ae();
    const t = e, n = () => {
      const a = ae();
      return a.adapter.getPreviewUrl({ path: a.modal.data.item.path });
    };
    return we(() => {
      t("success");
    }), (a, d) => (u(), p("div", Va, [
      o("div", null, [
        o("object", {
          class: "vuefinder__pdf-preview__object",
          data: n(),
          type: "application/pdf",
          width: "100%",
          height: "100%"
        }, [
          o("iframe", {
            class: "vuefinder__pdf-preview__iframe",
            src: n(),
            width: "100%",
            height: "100%"
          }, " Your browser does not support PDFs ", 8, Na)
        ], 8, Ua)
      ])
    ]));
  }
}), ja = ["data-theme"], Ka = ["disabled", "title"], qa = ["disabled", "title"], Wa = { class: "vuefinder__preview-modal__content" }, Ga = { key: 0 }, Ya = {
  key: 1,
  class: "vuefinder__preview-modal__status-strip"
}, Xa = ["aria-label"], Qa = { class: "vuefinder__preview-modal__loading" }, Ja = {
  key: 0,
  class: "vuefinder__preview-modal__loading-indicator"
}, Za = { class: "vuefinder__preview-modal__edit-actions" }, el = ["disabled"], Fn = 8, tl = 1.4, nl = 0.22, ct = 220, ol = ".vuefinder__preview-chrome__title, .vuefinder__preview-modal__status-strip", Xe = /* @__PURE__ */ le({
  __name: "ModalPreview",
  setup(s) {
    const e = ae(), { enabled: t } = Ve(), { t: n } = e.i18n, a = M(!1), d = (I) => {
      const O = (I || "").split("/").pop() || "", q = O.lastIndexOf(".");
      return q >= 0 ? O.slice(q + 1).toLowerCase() : "";
    }, r = (I, O) => {
      if (!O) return !1;
      const q = /* @__PURE__ */ new Set(["png", "jpg", "jpeg", "gif", "webp", "svg", "bmp", "ico", "avif"]), P = /* @__PURE__ */ new Set(["mp4", "webm", "ogg", "ogv", "mov", "m4v"]), j = /* @__PURE__ */ new Set(["mp3", "wav", "ogg", "oga", "m4a", "flac", "aac"]), de = /* @__PURE__ */ new Set([
        "txt",
        "md",
        "markdown",
        "json",
        "jsonc",
        "js",
        "mjs",
        "cjs",
        "ts",
        "tsx",
        "jsx",
        "vue",
        "svelte",
        "css",
        "scss",
        "sass",
        "less",
        "html",
        "htm",
        "xml",
        "svg",
        "csv",
        "tsv",
        "log",
        "yml",
        "yaml",
        "toml",
        "ini",
        "conf",
        "env",
        "sh",
        "bash",
        "zsh",
        "fish",
        "py",
        "rb",
        "php",
        "go",
        "rs",
        "java",
        "kt",
        "swift",
        "c",
        "h",
        "cpp",
        "hpp",
        "cs",
        "sql",
        "graphql",
        "gql",
        "dockerfile",
        "gitignore",
        "gitattributes",
        "editorconfig",
        "prettierrc",
        "eslintrc",
        "lock"
      ]);
      return I === "image" ? q.has(O) : I === "video" ? P.has(O) : I === "audio" ? j.has(O) : I === "csv" ? O === "csv" || O === "tsv" : I === "text" ? de.has(O) : I === "application/pdf" ? O === "pdf" : !1;
    }, l = (I) => {
      const O = e.modal.data.forceType;
      if (O) return O === I;
      const q = e.modal.data.item.mime_type;
      if (q && typeof q == "string" && q.startsWith(I)) return !0;
      const P = d(e.modal.data.item.path);
      return r(I, P);
    }, c = t("preview");
    c || (a.value = !0);
    const v = R(() => e.modal.data.item), w = oe(e.fs.sortedFiles), h = R(() => w.value.filter((I) => I.type === "file")), _ = R(
      () => h.value.findIndex((I) => I.path === v.value.path)
    ), k = R(() => !!i(e.modal.controls?.isEditable)), b = R(() => !!i(e.modal.controls?.isEditing)), $ = R(() => !!i(e.modal.controls?.isDirty)), m = R(
      () => i(e.modal.controls?.primaryActionLabel) ?? n("Save")
    ), g = async () => {
      await e.modal.controls?.enterEdit?.();
    }, f = async () => {
      await e.modal.controls?.commitEdit?.();
    }, F = async () => {
      $.value && !window.confirm(n("Discard unsaved changes?")) || await e.modal.controls?.cancelEdit?.();
    }, C = R(() => !b.value && _.value > 0), A = R(
      () => !b.value && _.value < h.value.length - 1
    ), S = () => {
      if (!C.value) return;
      const I = h.value[_.value - 1];
      I && (e.fs.clearSelection(), e.fs.select(I.path), e.modal.data.item = I, a.value = !1);
    }, L = () => {
      if (!A.value) return;
      const I = h.value[_.value + 1];
      I && (e.fs.clearSelection(), e.fs.select(I.path), e.modal.data.item = I, a.value = !1);
    }, H = () => {
      b.value && $.value && !window.confirm(n("Discard unsaved changes?")) || e.modal.close();
    }, Y = M(0), Q = M(!1);
    let B = 0, W = 0, T = !1, D = !1;
    const N = R(() => ({
      transform: `translate3d(${Y.value}px, 0, 0)`,
      transition: Q.value ? `transform ${ct}ms ease-out` : "none"
    })), J = (I, O) => {
      setTimeout(O, I);
    }, ce = (I) => {
      if (b.value || I.touches.length !== 1 || !I.target?.closest?.(ol)) return;
      const q = I.touches[0];
      q && (T = !0, D = !1, B = q.clientX, W = q.clientY, Q.value = !1);
    }, z = (I) => {
      if (!T) return;
      const O = I.touches[0];
      if (!O) return;
      const q = O.clientX - B, P = O.clientY - W;
      if (!D) {
        if (Math.abs(q) < Fn && Math.abs(P) < Fn) return;
        if (Math.abs(q) < Math.abs(P) * tl) {
          T = !1;
          return;
        }
        D = !0;
      }
      let j = q;
      q > 0 && !C.value && (j = q * 0.3), q < 0 && !A.value && (j = q * 0.3), Y.value = j, I.cancelable && I.preventDefault();
    }, x = (I) => {
      const O = window.innerWidth || 1, q = I === "prev" ? O : -O, P = I === "prev" ? -O : O, j = I === "prev" ? S : L;
      Q.value = !0, Y.value = q, J(ct, () => {
        j(), Q.value = !1, Y.value = P, requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            Q.value = !0, Y.value = 0, J(ct, () => {
              Q.value = !1;
            });
          });
        });
      });
    }, U = () => {
      if (!T || (T = !1, !D)) return;
      const I = window.innerWidth || 1, O = Y.value, q = Math.abs(O) >= I * nl;
      if (q && O > 0 && C.value) {
        x("prev");
        return;
      }
      if (q && O < 0 && A.value) {
        x("next");
        return;
      }
      Q.value = !0, Y.value = 0, J(ct, () => {
        Q.value = !1;
      });
    }, E = () => {
      T && (T = !1, D && (Q.value = !0, Y.value = 0, J(ct, () => {
        Q.value = !1;
      })));
    }, V = (I) => {
      if (I.key === "Escape") {
        I.preventDefault(), I.stopPropagation(), H();
        return;
      }
      if ((I.metaKey || I.ctrlKey) && I.key.toLowerCase() === "s") {
        const O = e.modal.controls;
        if (O && i(O.isEditing)) {
          I.preventDefault(), O.commitEdit();
          return;
        }
      }
      b.value || (I.key === "ArrowLeft" || I.key === "ArrowRight") && (I.preventDefault(), I.stopPropagation(), I.key === "ArrowLeft" ? S() : L());
    };
    return we(() => {
      const I = document.querySelector(".vuefinder__preview-modal");
      I && I.focus();
    }), (I, O) => (u(), Z(ze, {
      "on-request-close": H,
      "body-style": N.value,
      "body-class": "vuefinder__modal-layout__body--swipeable " + (b.value ? "vuefinder__modal-layout__body--editing" : ""),
      "on-body-touchstart": ce,
      "on-body-touchmove": z,
      "on-body-touchend": U,
      "on-body-touchcancel": E
    }, yo({
      default: ue(() => [
        o("div", {
          class: "vuefinder__preview-modal",
          tabindex: "0",
          onKeydown: V
        }, [
          X(ri, { onCloseRequest: H }),
          (u(), Z(bt, { to: "body" }, [
            b.value ? K("", !0) : (u(), p("div", {
              key: 0,
              class: "vuefinder__themer vuefinder__preview-modal__nav-overlay",
              "data-theme": i(e).theme.current
            }, [
              o("button", {
                disabled: !C.value,
                class: "vuefinder__preview-modal__nav-side vuefinder__preview-modal__nav-side--left",
                title: i(n)("Previous file"),
                onClick: S
              }, [...O[7] || (O[7] = [
                o("svg", {
                  class: "vuefinder__preview-modal__nav-icon",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2"
                }, [
                  o("polyline", { points: "15,18 9,12 15,6" })
                ], -1)
              ])], 8, Ka),
              o("button", {
                disabled: !A.value,
                class: "vuefinder__preview-modal__nav-side vuefinder__preview-modal__nav-side--right",
                title: i(n)("Next file"),
                onClick: L
              }, [...O[8] || (O[8] = [
                o("svg", {
                  class: "vuefinder__preview-modal__nav-icon",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2"
                }, [
                  o("polyline", { points: "9,18 15,12 9,6" })
                ], -1)
              ])], 8, qa)
            ], 8, ja))
          ])),
          o("div", Wa, [
            i(c) ? (u(), p("div", Ga, [
              l("csv") ? (u(), Z(Si, {
                key: `csv-${v.value.path}`,
                onSuccess: O[0] || (O[0] = (q) => a.value = !0)
              })) : l("text") ? (u(), Z(vi, {
                key: `text-${v.value.path}`,
                onSuccess: O[1] || (O[1] = (q) => a.value = !0)
              })) : l("image") ? (u(), Z(xa, {
                key: `image-${v.value.path}`,
                onSuccess: O[2] || (O[2] = (q) => a.value = !0)
              })) : l("video") ? (u(), Z(Oa, {
                key: `video-${v.value.path}`,
                onSuccess: O[3] || (O[3] = (q) => a.value = !0)
              })) : l("audio") ? (u(), Z(za, {
                key: `audio-${v.value.path}`,
                onSuccess: O[4] || (O[4] = (q) => a.value = !0)
              })) : l("application/pdf") ? (u(), Z(Ha, {
                key: `pdf-${v.value.path}`,
                onSuccess: O[5] || (O[5] = (q) => a.value = !0)
              })) : (u(), Z(Da, {
                key: `default-${v.value.path}`,
                onSuccess: O[6] || (O[6] = (q) => a.value = !0)
              }))
            ])) : K("", !0),
            b.value || h.value.length > 1 ? (u(), p("div", Ya, [
              b.value ? (u(), p("span", {
                key: 0,
                class: te(["vuefinder__preview-modal__edit-chip", { "vuefinder__preview-modal__edit-chip--dirty": $.value }])
              }, y($.value ? i(n)("Unsaved") : i(n)("Editing")), 3)) : (u(), p("span", {
                key: 1,
                class: "vuefinder__preview-modal__pagination-text",
                "aria-label": i(n)("File %s of %s", String(_.value + 1), String(h.value.length))
              }, y(_.value + 1) + " / " + y(h.value.length), 9, Xa))
            ])) : K("", !0),
            o("div", Qa, [
              a.value === !1 ? (u(), p("div", Ja, [
                O[9] || (O[9] = o("svg", {
                  class: "vuefinder__preview-modal__spinner",
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24"
                }, [
                  o("circle", {
                    class: "vuefinder__preview-modal__spinner-circle",
                    cx: "12",
                    cy: "12",
                    r: "10",
                    stroke: "currentColor",
                    "stroke-width": "4"
                  }),
                  o("path", {
                    class: "vuefinder__preview-modal__spinner-path",
                    fill: "currentColor",
                    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  })
                ], -1)),
                o("span", null, y(i(n)("Loading")), 1)
              ])) : K("", !0)
            ])
          ])
        ], 32)
      ]),
      _: 2
    }, [
      k.value ? {
        name: "buttons",
        fn: ue(() => [
          o("div", Za, [
            b.value ? (u(), p(_e, { key: 1 }, [
              o("button", {
                type: "button",
                class: "vf-btn vf-btn-primary vuefinder__preview-modal__edit-btn",
                disabled: !$.value,
                onClick: f
              }, y(m.value), 9, el),
              o("button", {
                type: "button",
                class: "vf-btn vf-btn-secondary vuefinder__preview-modal__edit-btn",
                onClick: F
              }, y(i(n)("Cancel")), 1)
            ], 64)) : (u(), p("button", {
              key: 0,
              type: "button",
              class: "vf-btn vf-btn-primary vuefinder__preview-modal__edit-btn",
              onClick: g
            }, y(i(n)("Edit")), 1))
          ])
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["body-style", "body-class"]));
  }
}), sl = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2"
};
function il(s, e) {
  return u(), p("svg", sl, [...e[0] || (e[0] = [
    o("path", {
      stroke: "none",
      d: "M0 0h24v24H0z"
    }, null, -1),
    o("path", { d: "M13 19H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h4l3 3h7a2 2 0 0 1 2 2v4M16 22l5-5M21 21.5V17h-4.5" }, null, -1)
  ])]);
}
const al = { render: il }, ll = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
function rl(s, e) {
  return u(), p("svg", ll, [...e[0] || (e[0] = [
    o("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M8 16H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2m-6 12h8a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2"
    }, null, -1)
  ])]);
}
const an = { render: rl }, dl = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
function cl(s, e) {
  return u(), p("svg", dl, [...e[0] || (e[0] = [
    o("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3 7v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-6l-2-2H5a2 2 0 0 0-2 2"
    }, null, -1)
  ])]);
}
const Re = { render: cl }, ul = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24"
};
function vl(s, e) {
  return u(), p("svg", ul, [...e[0] || (e[0] = [
    o("path", {
      stroke: "none",
      d: "M0 0h24v24H0z"
    }, null, -1),
    o("path", { d: "M12 5v14M5 12h14" }, null, -1)
  ])]);
}
const Mt = { render: vl }, fl = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24"
};
function _l(s, e) {
  return u(), p("svg", fl, [...e[0] || (e[0] = [
    o("path", {
      stroke: "none",
      d: "M0 0h24v24H0z"
    }, null, -1),
    o("path", { d: "M5 12h14" }, null, -1)
  ])]);
}
const It = { render: _l }, pl = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  class: "h-5 w-5",
  viewBox: "0 0 24 24"
};
function ml(s, e) {
  return u(), p("svg", pl, [...e[0] || (e[0] = [
    o("path", {
      stroke: "none",
      d: "M0 0h24v24H0z"
    }, null, -1),
    o("path", { d: "m15 4.5-4 4L7 10l-1.5 1.5 7 7L14 17l1.5-4 4-4M9 15l-4.5 4.5M14.5 4 20 9.5" }, null, -1)
  ])]);
}
const yt = { render: ml }, hl = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
function gl(s, e) {
  return u(), p("svg", hl, [...e[0] || (e[0] = [
    o("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4"
    }, null, -1)
  ])]);
}
const ln = { render: gl }, yl = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function wl(s, e) {
  return u(), p("svg", yl, [...e[0] || (e[0] = [
    o("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3.75 9.776q.168-.026.344-.026h15.812q.176 0 .344.026m-16.5 0a2.25 2.25 0 0 0-1.883 2.542l.857 6a2.25 2.25 0 0 0 2.227 1.932H19.05a2.25 2.25 0 0 0 2.227-1.932l.857-6a2.25 2.25 0 0 0-1.883-2.542m-16.5 0V6A2.25 2.25 0 0 1 6 3.75h3.879a1.5 1.5 0 0 1 1.06.44l2.122 2.12a1.5 1.5 0 0 0 1.06.44H18A2.25 2.25 0 0 1 20.25 9v.776"
    }, null, -1)
  ])]);
}
const At = { render: wl }, bl = { class: "vuefinder__modal-tree__folder-item" }, kl = { class: "vuefinder__modal-tree__folder-content" }, $l = {
  key: 1,
  class: "vuefinder__modal-tree__folder-spacer"
}, xl = { class: "vuefinder__modal-tree__folder-text" }, Sl = {
  key: 0,
  class: "vuefinder__modal-tree__subfolders"
}, Cl = {
  key: 0,
  class: "vuefinder__modal-tree__more-note"
}, Fl = 300, Tl = /* @__PURE__ */ le({
  __name: "ModalTreeFolderItem",
  props: {
    folder: {},
    storage: {},
    modelValue: {},
    expandedFolders: {},
    modalTreeData: {},
    currentPath: {}
  },
  emits: ["update:modelValue", "selectAndClose", "toggleFolder"],
  setup(s, { emit: e }) {
    const t = ae(), { t: n } = t.i18n, a = t.fs, d = M({}), r = s, l = e;
    oe(a.path);
    const c = R(() => {
      const L = `${r.storage}:${r.folder.path}`;
      return r.expandedFolders[L] || !1;
    }), v = R(() => r.modelValue?.path === r.folder.path), w = R(() => r.currentPath?.path === r.folder.path), h = R(() => r.modalTreeData[r.folder.path] || []), _ = R(() => {
      const L = h.value, H = d.value[r.folder.path] || 50;
      return L.length > H ? L.slice(0, H) : L;
    }), k = R(() => h.value.length), b = R(() => d.value[r.folder.path] || 50), $ = R(() => k.value > b.value), m = () => {
      d.value[r.folder.path] = (b.value || 50) + 50;
    }, g = R(() => h.value.length > 0 || r.folder.type === "dir"), f = () => {
      l("toggleFolder", r.storage, r.folder.path);
    }, F = () => {
      l("update:modelValue", r.folder);
    }, C = () => {
      l("update:modelValue", r.folder), l("selectAndClose", r.folder);
    };
    let A = 0;
    const S = () => {
      const L = Date.now();
      L - A < Fl ? C() : F(), A = L;
    };
    return (L, H) => {
      const Y = Bn("ModalTreeFolderItem", !0);
      return u(), p("div", bl, [
        o("div", kl, [
          g.value ? (u(), p("div", {
            key: 0,
            class: "vuefinder__modal-tree__folder-toggle",
            onClick: f
          }, [
            c.value ? (u(), Z(i(It), {
              key: 1,
              class: "vuefinder__modal-tree__folder-toggle-icon"
            })) : (u(), Z(i(Mt), {
              key: 0,
              class: "vuefinder__modal-tree__folder-toggle-icon"
            }))
          ])) : (u(), p("div", $l)),
          o("div", {
            class: te(["vuefinder__modal-tree__folder-link", {
              "vuefinder__modal-tree__folder-link--selected": v.value,
              "vuefinder__modal-tree__folder-link--current": w.value
            }]),
            onClick: F,
            onDblclick: C,
            onTouchend: S
          }, [
            c.value ? (u(), Z(i(At), {
              key: 1,
              class: "vuefinder__item-icon__folder--open vuefinder__modal-tree__folder-icon"
            })) : (u(), Z(i(Re), {
              key: 0,
              class: "vuefinder__modal-tree__folder-icon vuefinder__item-icon__folder"
            })),
            o("span", xl, y(s.folder.basename), 1)
          ], 34)
        ]),
        c.value && g.value ? (u(), p("div", Sl, [
          (u(!0), p(_e, null, ge(_.value, (Q) => (u(), Z(Y, {
            key: Q.path,
            folder: Q,
            storage: s.storage,
            "model-value": s.modelValue,
            "expanded-folders": s.expandedFolders,
            "modal-tree-data": s.modalTreeData,
            "current-path": s.currentPath,
            "onUpdate:modelValue": H[0] || (H[0] = (B) => L.$emit("update:modelValue", B)),
            onSelectAndClose: H[1] || (H[1] = (B) => L.$emit("selectAndClose", B)),
            onToggleFolder: H[2] || (H[2] = (B, W) => L.$emit("toggleFolder", B, W))
          }, null, 8, ["folder", "storage", "model-value", "expanded-folders", "modal-tree-data", "current-path"]))), 128)),
          $.value ? (u(), p("div", Cl, [
            o("div", {
              class: "vuefinder__modal-tree__load-more",
              onClick: m
            }, y(i(n)("load more")), 1)
          ])) : K("", !0)
        ])) : K("", !0)
      ]);
    };
  }
}), El = { class: "vuefinder__modal-tree" }, Pl = { class: "vuefinder__modal-tree__header" }, Dl = { class: "vuefinder__modal-tree__title" }, Ml = {
  key: 0,
  class: "vuefinder__modal-tree__section"
}, Il = { class: "vuefinder__modal-tree__section-title" }, Al = { class: "vuefinder__modal-tree__list" }, Ol = ["onClick", "onDblclick", "onTouchend"], Ll = { class: "vuefinder__modal-tree__text" }, Rl = { class: "vuefinder__modal-tree__text-storage" }, Bl = { class: "vuefinder__modal-tree__section-title" }, zl = { class: "vuefinder__modal-tree__list" }, Vl = { class: "vuefinder__modal-tree__storage-item" }, Ul = { class: "vuefinder__modal-tree__storage-content" }, Nl = ["onClick"], Hl = ["onClick", "onDblclick", "onTouchend"], jl = { class: "vuefinder__modal-tree__storage-text" }, Kl = {
  key: 0,
  class: "vuefinder__modal-tree__subfolders"
}, ql = {
  key: 0,
  class: "vuefinder__modal-tree__more-note"
}, Wl = ["onClick"], Tn = 300, kt = /* @__PURE__ */ le({
  __name: "ModalTreeSelector",
  props: {
    modelValue: {},
    showPinnedFolders: { type: Boolean },
    currentPath: {}
  },
  emits: ["update:modelValue", "selectAndClose"],
  setup(s, { emit: e }) {
    const t = ae(), { t: n } = t.i18n, a = t.fs, d = t.config, r = e, l = oe(a.sortedFiles), c = oe(a.storages), v = R(() => c.value || []), w = oe(a.path), h = M(null), _ = M({}), k = M({}), b = M({});
    pe(l, (T) => {
      const D = T.filter((J) => J.type === "dir"), N = w.value?.path || "";
      N && (k.value[N] = D.map((J) => ({
        ...J,
        type: "dir"
      })));
    });
    const $ = (T, D) => {
      const N = `${T}:${D}`;
      _.value = {
        ..._.value,
        [N]: !_.value[N]
      }, _.value[N] && !k.value[D] && t.adapter.list(D).then((J) => {
        const z = (J.files || []).filter((x) => x.type === "dir");
        k.value[D] = z.map((x) => ({
          ...x,
          type: "dir"
        }));
      });
    }, m = (T) => k.value[T] || [], g = (T) => b.value[T] || 50, f = (T) => {
      const D = m(T), N = g(T);
      return D.length > N ? D.slice(0, N) : D;
    }, F = (T) => m(T).length, C = (T) => F(T) > g(T), A = (T) => {
      b.value[T] = g(T) + 50;
    }, S = (T) => {
      T && r("update:modelValue", T);
    }, L = (T) => {
      T && (r("update:modelValue", T), r("selectAndClose", T));
    }, H = (T) => {
      const D = {
        storage: T,
        path: T + "://",
        basename: T,
        type: "dir",
        extension: "",
        file_size: null,
        last_modified: null,
        mime_type: null,
        visibility: "public",
        dir: T + "://"
      };
      r("update:modelValue", D);
    }, Y = (T) => {
      const D = {
        storage: T,
        path: T + "://",
        basename: T,
        type: "dir",
        extension: "",
        file_size: null,
        last_modified: null,
        mime_type: null,
        visibility: "public",
        dir: T + "://"
      };
      r("update:modelValue", D), r("selectAndClose", D);
    };
    let Q = 0;
    const B = (T) => {
      if (!T) return;
      const D = Date.now();
      D - Q < Tn ? L(T) : S(T), Q = D;
    }, W = (T) => {
      const D = Date.now();
      D - Q < Tn ? Y(T) : H(T), Q = D;
    };
    return we(() => {
      h.value && _t(h.value, {
        overflow: {
          x: "hidden"
        },
        scrollbars: {
          theme: "vf-scrollbars-theme"
        }
      });
    }), (T, D) => (u(), p("div", El, [
      o("div", Pl, [
        o("div", Dl, y(i(n)("Select Target Folder")), 1)
      ]),
      o("div", {
        ref_key: "modalContentElement",
        ref: h,
        class: "vuefinder__modal-tree__content"
      }, [
        s.showPinnedFolders && i(t).features.pinned && i(d).get("pinnedFolders").length ? (u(), p("div", Ml, [
          o("div", Il, y(i(n)("Pinned Folders")), 1),
          o("div", Al, [
            (u(!0), p(_e, null, ge(i(d).get("pinnedFolders"), (N) => (u(), p("div", {
              key: N.path,
              class: te(["vuefinder__modal-tree__item", { "vuefinder__modal-tree__item--selected": s.modelValue?.path === N.path }]),
              onClick: (J) => S(N),
              onDblclick: (J) => L(N),
              onTouchend: (J) => B(N)
            }, [
              X(i(Re), { class: "vuefinder__modal-tree__icon vuefinder__item-icon__folder" }),
              o("div", Ll, y(N.basename), 1),
              o("div", Rl, y(N.storage), 1),
              X(i(yt), { class: "vuefinder__modal-tree__icon vuefinder__modal-tree__icon--pin" })
            ], 42, Ol))), 128))
          ])
        ])) : K("", !0),
        o("div", Bl, y(i(n)("Storages")), 1),
        (u(!0), p(_e, null, ge(v.value, (N) => (u(), p("div", {
          key: N,
          class: "vuefinder__modal-tree__section"
        }, [
          o("div", zl, [
            o("div", Vl, [
              o("div", Ul, [
                o("div", {
                  class: "vuefinder__modal-tree__storage-toggle",
                  onClick: ve((J) => $(N, N + "://"), ["stop"])
                }, [
                  _.value[`${N}:${N}://`] ? (u(), Z(i(It), {
                    key: 1,
                    class: "vuefinder__modal-tree__toggle-icon"
                  })) : (u(), Z(i(Mt), {
                    key: 0,
                    class: "vuefinder__modal-tree__toggle-icon"
                  }))
                ], 8, Nl),
                o("div", {
                  class: te(["vuefinder__modal-tree__storage-link", {
                    "vuefinder__modal-tree__storage-link--selected": s.modelValue?.path === N + "://"
                  }]),
                  onClick: (J) => H(N),
                  onDblclick: (J) => Y(N),
                  onTouchend: (J) => W(N)
                }, [
                  X(i(ln), { class: "vuefinder__modal-tree__storage-icon" }),
                  o("span", jl, y(N), 1)
                ], 42, Hl)
              ]),
              _.value[`${N}:${N}://`] ? (u(), p("div", Kl, [
                (u(!0), p(_e, null, ge(f(N + "://"), (J) => (u(), Z(Tl, {
                  key: J.path,
                  folder: J,
                  storage: N,
                  "model-value": s.modelValue,
                  "expanded-folders": _.value,
                  "modal-tree-data": k.value,
                  "current-path": s.currentPath,
                  "onUpdate:modelValue": S,
                  onSelectAndClose: L,
                  onToggleFolder: $
                }, null, 8, ["folder", "storage", "model-value", "expanded-folders", "modal-tree-data", "current-path"]))), 128)),
                C(N + "://") ? (u(), p("div", ql, [
                  o("div", {
                    class: "vuefinder__modal-tree__load-more",
                    onClick: (J) => A(N + "://")
                  }, y(i(n)("load more")), 9, Wl)
                ])) : K("", !0)
              ])) : K("", !0)
            ])
          ])
        ]))), 128))
      ], 512)
    ]));
  }
}), Gl = ["title"], Gt = /* @__PURE__ */ le({
  __name: "Message",
  props: {
    error: { type: Boolean }
  },
  emits: ["hidden"],
  setup(s, { emit: e }) {
    const t = e, n = ae(), { t: a } = n.i18n, d = M(!1), r = M(null), l = M(r.value?.innerHTML);
    pe(l, () => d.value = !1);
    const c = () => {
      t("hidden"), d.value = !0;
    };
    return (v, w) => (u(), p("div", null, [
      d.value ? K("", !0) : (u(), p("div", {
        key: 0,
        ref_key: "strMessage",
        ref: r,
        class: te(["vuefinder__message", s.error ? "vuefinder__message--error" : "vuefinder__message--success"])
      }, [
        Me(v.$slots, "default"),
        o("div", {
          class: "vuefinder__message__close",
          title: i(a)("Close"),
          onClick: c
        }, [...w[0] || (w[0] = [
          o("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24",
            "stroke-width": "1.5",
            stroke: "currentColor",
            class: "vuefinder__message__icon"
          }, [
            o("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              d: "M6 18L18 6M6 6l12 12"
            })
          ], -1)
        ])], 8, Gl)
      ], 2))
    ]));
  }
}), Yl = { class: "vuefinder__move-modal__content" }, Xl = { class: "vuefinder__move-modal__description" }, Ql = { class: "vuefinder__move-modal__files vf-scrollbar" }, Jl = { class: "vuefinder__move-modal__file-name" }, Zl = { class: "vuefinder__move-modal__target-title" }, er = { class: "vuefinder__move-modal__target-container" }, tr = { class: "vuefinder__move-modal__target-path" }, nr = { class: "vuefinder__move-modal__target-storage" }, or = {
  key: 0,
  class: "vuefinder__move-modal__destination-folder"
}, sr = { class: "vuefinder__move-modal__target-badge" }, ir = {
  key: 0,
  class: "vuefinder__move-modal__options"
}, ar = { class: "vuefinder__move-modal__checkbox-label" }, lr = { class: "vuefinder__move-modal__checkbox-text" }, rr = ["disabled"], dr = { class: "vuefinder__move-modal__selected-items" }, eo = /* @__PURE__ */ le({
  __name: "ModalTransfer",
  props: {
    copy: { type: Boolean }
  },
  setup(s) {
    const e = ae(), t = Be(e), { enabled: n } = Ve(), { t: a } = e.i18n, d = s, r = M(e.modal.data.items.from), l = M(e.modal.data.items.to), c = M(""), v = M(d.copy || !n("move")), w = R(() => v.value ? "copy" : "move"), h = M(!1), _ = oe(e.fs.path), k = R(() => v.value ? a("Copy files") : a("Move files")), b = R(
      () => v.value ? a("Are you sure you want to copy these files?") : a("Are you sure you want to move these files?")
    ), $ = R(() => v.value ? a("Yes, Copy!") : a("Yes, Move!"));
    R(() => v.value ? a("Files copied.") : a("Files moved."));
    const m = (S) => {
      S && (l.value = S);
    }, g = (S) => {
      S && (l.value = S, h.value = !1);
    }, f = R(() => {
      const S = l.value;
      return S ? r.value.some((L) => !!(S.path === L.path || L.type === "dir" && S.path.startsWith(L.path + "/"))) : !0;
    }), F = R(() => {
      if (!f.value)
        return "";
      const S = l.value;
      return S ? r.value.find((H) => S.path === H.path || H.type === "dir" && S.path.startsWith(H.path + "/")) ? a("Cannot move/copy item to itself or its own subfolder") : a("Invalid destination directory") : a("Please select a destination directory");
    }), C = () => {
      const S = l.value.path;
      if (!S) return { storage: "local", path: "" };
      if (S.endsWith("://"))
        return { storage: S.replace("://", ""), path: "" };
      const L = S.split("://");
      return {
        storage: L[0] || "local",
        path: L[1] || ""
      };
    }, A = async () => {
      if (r.value.length)
        try {
          const { files: S } = await e.adapter[w.value]({
            path: _.value.path,
            sources: r.value.map(({ path: L }) => L),
            destination: l.value.path
          });
          e.fs.setFiles(S), e.modal.close();
        } catch (S) {
          t.error(Fe(S, a("Failed to transfer files")));
        }
    };
    return (S, L) => (u(), Z(ze, null, {
      buttons: ue(() => [
        o("button", {
          type: "button",
          class: "vf-btn vf-btn-primary",
          disabled: f.value,
          onClick: A
        }, y($.value), 9, rr),
        o("button", {
          type: "button",
          class: "vf-btn vf-btn-secondary",
          onClick: L[4] || (L[4] = (H) => i(e).modal.close())
        }, y(i(a)("Cancel")), 1),
        o("div", dr, y(i(a)("%s item(s) selected.", r.value.length)), 1)
      ]),
      default: ue(() => [
        o("div", null, [
          X(He, {
            icon: v.value ? i(an) : i(al),
            title: k.value
          }, null, 8, ["icon", "title"]),
          o("div", Yl, [
            o("p", Xl, y(b.value), 1),
            o("div", Ql, [
              (u(!0), p(_e, null, ge(r.value, (H) => (u(), p("div", {
                key: H.path,
                class: "vuefinder__move-modal__file"
              }, [
                o("div", null, [
                  H.type === "dir" ? (u(), Z(i(Re), {
                    key: 0,
                    class: "vuefinder__move-modal__icon vuefinder__move-modal__icon--dir"
                  })) : (u(), Z(i(gt), {
                    key: 1,
                    class: "vuefinder__move-modal__icon"
                  }))
                ]),
                o("div", Jl, y(H.path), 1)
              ]))), 128))
            ]),
            o("h4", Zl, y(i(a)("Target Directory")), 1),
            o("div", er, [
              o("div", {
                class: "vuefinder__move-modal__target-display",
                onClick: L[0] || (L[0] = (H) => h.value = !h.value)
              }, [
                o("div", tr, [
                  o("span", nr, y(C().storage) + "://", 1),
                  C().path ? (u(), p("span", or, y(C().path), 1)) : K("", !0)
                ]),
                o("span", sr, y(i(a)("Browse")), 1)
              ])
            ]),
            o("div", {
              class: te([
                "vuefinder__move-modal__tree-selector",
                h.value ? "vuefinder__move-modal__tree-selector--expanded" : "vuefinder__move-modal__tree-selector--collapsed"
              ])
            }, [
              X(kt, {
                modelValue: l.value,
                "onUpdate:modelValue": [
                  L[1] || (L[1] = (H) => l.value = H),
                  m
                ],
                "show-pinned-folders": !0,
                onSelectAndClose: g
              }, null, 8, ["modelValue"])
            ], 2),
            i(n)("copy") && i(n)("move") ? (u(), p("div", ir, [
              o("label", ar, [
                he(o("input", {
                  "onUpdate:modelValue": L[2] || (L[2] = (H) => v.value = H),
                  type: "checkbox",
                  class: "vuefinder__move-modal__checkbox"
                }, null, 512), [
                  [lt, v.value]
                ]),
                o("span", lr, y(i(a)("Create a copy instead of moving")), 1)
              ])
            ])) : K("", !0),
            F.value ? (u(), Z(Gt, {
              key: 1,
              error: ""
            }, {
              default: ue(() => [
                ye(y(F.value), 1)
              ]),
              _: 1
            })) : K("", !0),
            c.value.length && !F.value ? (u(), Z(Gt, {
              key: 2,
              error: "",
              onHidden: L[3] || (L[3] = (H) => c.value = "")
            }, {
              default: ue(() => [
                ye(y(c.value), 1)
              ]),
              _: 1
            })) : K("", !0)
          ])
        ])
      ]),
      _: 1
    }));
  }
}), at = /* @__PURE__ */ le({
  __name: "ModalMove",
  setup(s) {
    return (e, t) => (u(), Z(eo, { copy: !1 }));
  }
}), rn = /* @__PURE__ */ le({
  __name: "ModalCopy",
  setup(s) {
    return (e, t) => (u(), Z(eo, { copy: !0 }));
  }
}), cr = (s, e = 0, t = !1) => {
  let n;
  return (...a) => {
    t && !n && s(...a), clearTimeout(n), n = setTimeout(() => {
      s(...a);
    }, e);
  };
}, to = (s, e, t) => {
  const n = M(s);
  return wo((a, d) => ({
    get() {
      return a(), n.value;
    },
    set: cr(
      (r) => {
        n.value = r, d();
      },
      e,
      !1
    )
  }));
}, ur = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function vr(s, e) {
  return u(), p("svg", ur, [...e[0] || (e[0] = [
    o("path", { d: "m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607" }, null, -1)
  ])]);
}
const dn = { render: vr }, fr = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "animate-spin p-0.5 h-5 w-5 text-white ml-auto",
  viewBox: "0 0 24 24"
};
function _r(s, e) {
  return u(), p("svg", fr, [...e[0] || (e[0] = [
    o("circle", {
      cx: "12",
      cy: "12",
      r: "10",
      stroke: "currentColor",
      "stroke-width": "4",
      class: "opacity-25 stroke-blue-900"
    }, null, -1),
    o("path", {
      fill: "currentColor",
      d: "M4 12a8 8 0 0 1 8-8V0C5.373 0 0 5.373 0 12zm2 5.291A7.96 7.96 0 0 1 4 12H0c0 3.042 1.135 5.824 3 7.938z",
      class: "opacity-75"
    }, null, -1)
  ])]);
}
const Ot = { render: _r }, pr = { class: "vuefinder__search-modal__search-input" }, mr = ["value", "placeholder", "disabled"], hr = {
  key: 0,
  class: "vuefinder__search-modal__loading"
}, gr = /* @__PURE__ */ le({
  name: "SearchInput",
  __name: "SearchInput",
  props: {
    modelValue: {},
    isSearching: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue", "keydown"],
  setup(s, { expose: e, emit: t }) {
    const n = t, a = ae(), { t: d } = a.i18n, r = M(null), l = (v) => {
      const w = v.target;
      n("update:modelValue", w.value);
    }, c = (v) => {
      n("keydown", v);
    };
    return e({
      focus: () => {
        r.value && r.value.focus();
      }
    }), (v, w) => (u(), p("div", pr, [
      X(i(dn), { class: "vuefinder__search-modal__search-icon" }),
      o("input", {
        ref_key: "searchInput",
        ref: r,
        value: s.modelValue,
        type: "text",
        placeholder: i(d)("Search files"),
        disabled: s.disabled,
        class: "vuefinder__search-modal__input",
        onKeydown: c,
        onKeyup: w[0] || (w[0] = ve(() => {
        }, ["stop"])),
        onInput: l
      }, null, 40, mr),
      s.isSearching ? (u(), p("div", hr, [
        X(i(Ot), { class: "vuefinder__search-modal__loading-icon" })
      ])) : K("", !0)
    ]));
  }
}), yr = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function wr(s, e) {
  return u(), p("svg", yr, [...e[0] || (e[0] = [
    o("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87q.11.06.22.127c.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a8 8 0 0 1 0 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a7 7 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a7 7 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.991a7 7 0 0 1 0-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124q.108-.066.22-.128c.332-.183.582-.495.644-.869z"
    }, null, -1),
    o("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
    }, null, -1)
  ])]);
}
const no = { render: wr }, br = ["disabled", "title"], kr = ["data-theme"], $r = { class: "vuefinder__search-modal__dropdown-content" }, xr = { class: "vuefinder__search-modal__dropdown-section" }, Sr = { class: "vuefinder__search-modal__dropdown-title" }, Cr = { class: "vuefinder__search-modal__dropdown-options" }, Fr = {
  key: 0,
  class: "vuefinder__search-modal__dropdown-option-check"
}, Tr = {
  key: 0,
  class: "vuefinder__search-modal__dropdown-option-check"
}, Er = {
  key: 0,
  class: "vuefinder__search-modal__dropdown-option-check"
}, Pr = {
  key: 0,
  class: "vuefinder__search-modal__dropdown-option-check"
}, Dr = { class: "vuefinder__search-modal__dropdown-section" }, Mr = { class: "vuefinder__search-modal__dropdown-title" }, Ir = { class: "vuefinder__search-modal__dropdown-options" }, Ar = ["onClick"], Or = {
  key: 0,
  class: "vuefinder__search-modal__dropdown-option-check"
}, Lr = /* @__PURE__ */ le({
  name: "SearchOptionsDropdown",
  __name: "SearchOptionsDropdown",
  props: {
    visible: { type: Boolean },
    disabled: { type: Boolean, default: !1 },
    sizeFilter: {},
    selectedOption: {},
    sortBy: {}
  },
  emits: ["update:visible", "update:sizeFilter", "update:selectedOption", "update:sortBy", "keydown"],
  setup(s, { expose: e, emit: t }) {
    const n = s, a = t, d = ae(), { t: r } = d.i18n, l = M(null), c = M(null);
    let v = null;
    const w = [
      { value: "name-asc", key: "Name (A-Z)" },
      { value: "name-desc", key: "Name (Z-A)" },
      { value: "size-asc", key: "Size (smallest)" },
      { value: "size-desc", key: "Size (largest)" },
      { value: "date-desc", key: "Date (newest)" },
      { value: "date-asc", key: "Date (oldest)" }
    ], h = (g) => {
      if (a("update:selectedOption", g), g.startsWith("size-")) {
        const f = g.split("-")[1];
        a("update:sizeFilter", f);
      }
    }, _ = (g) => {
      a("update:sortBy", g);
    }, k = async () => {
      n.disabled || (n.visible ? (a("update:visible", !1), v && (v(), v = null)) : (a("update:visible", !0), await De(), await b()));
    }, b = async () => {
      if (!(!l.value || !c.value) && (await De(), !(!l.value || !c.value))) {
        Object.assign(c.value.style, {
          position: "fixed",
          zIndex: "10001",
          opacity: "0",
          transform: "translateY(-8px)",
          transition: "opacity 150ms ease-out, transform 150ms ease-out"
        });
        try {
          const { x: g, y: f } = await it(l.value, c.value, {
            placement: "bottom-start",
            strategy: "fixed",
            middleware: [pt(8), mt({ padding: 16 }), ht({ padding: 16 })]
          });
          Object.assign(c.value.style, {
            left: `${g}px`,
            top: `${f}px`
          }), requestAnimationFrame(() => {
            c.value && Object.assign(c.value.style, {
              opacity: "1",
              transform: "translateY(0)"
            });
          });
        } catch (g) {
          console.warn("Floating UI initial positioning error:", g);
          return;
        }
        try {
          v = Qt(l.value, c.value, async () => {
            if (!(!l.value || !c.value))
              try {
                const { x: g, y: f } = await it(
                  l.value,
                  c.value,
                  {
                    placement: "bottom-start",
                    strategy: "fixed",
                    middleware: [pt(8), mt({ padding: 16 }), ht({ padding: 16 })]
                  }
                );
                Object.assign(c.value.style, {
                  left: `${g}px`,
                  top: `${f}px`
                });
              } catch (g) {
                console.warn("Floating UI positioning error:", g);
              }
          });
        } catch (g) {
          console.warn("Floating UI autoUpdate setup error:", g), v = null;
        }
      }
    }, $ = (g) => {
      if (!n.visible) return;
      const f = ["size-all", "size-small", "size-medium", "size-large"], F = f.findIndex((C) => C === n.selectedOption);
      if (g.key === "ArrowDown") {
        g.preventDefault();
        const C = (F + 1) % f.length;
        a("update:selectedOption", f[C] || null);
      } else if (g.key === "ArrowUp") {
        g.preventDefault();
        const C = F <= 0 ? f.length - 1 : F - 1;
        a("update:selectedOption", f[C] || null);
      } else g.key === "Enter" ? (g.preventDefault(), n.selectedOption?.startsWith("size-") && a(
        "update:sizeFilter",
        n.selectedOption.split("-")[1]
      )) : g.key === "Escape" && (g.preventDefault(), a("update:visible", !1), v && (v(), v = null));
    }, m = () => {
      v && (v(), v = null);
    };
    return pe(
      () => n.visible,
      (g) => {
        !g && v && (v(), v = null);
      }
    ), Pe(() => {
      m();
    }), e({
      cleanup: m
    }), (g, f) => (u(), p(_e, null, [
      o("button", {
        ref_key: "dropdownBtn",
        ref: l,
        class: te(["vuefinder__search-modal__dropdown-btn", { "vuefinder__search-modal__dropdown-btn--active": s.visible }]),
        disabled: s.disabled,
        title: i(r)("Search Options"),
        onClick: ve(k, ["stop"])
      }, [
        X(i(no), { class: "vuefinder__search-modal__dropdown-icon" })
      ], 10, br),
      (u(), Z(bt, { to: "body" }, [
        s.visible ? (u(), p("div", {
          key: 0,
          ref_key: "dropdownContent",
          ref: c,
          class: "vuefinder__themer vuefinder__search-modal__dropdown vuefinder__search-modal__dropdown--visible",
          "data-theme": i(d).theme.current,
          tabindex: "-1",
          onClick: f[4] || (f[4] = ve(() => {
          }, ["stop"])),
          onKeydown: $
        }, [
          o("div", $r, [
            o("div", xr, [
              o("div", Sr, y(i(r)("File Size")), 1),
              o("div", Cr, [
                o("div", {
                  class: te(["vuefinder__search-modal__dropdown-option", {
                    "vuefinder__search-modal__dropdown-option--selected": s.sizeFilter === "all"
                  }]),
                  onClick: f[0] || (f[0] = ve((F) => h("size-all"), ["stop"]))
                }, [
                  o("span", null, y(i(r)("All Files")), 1),
                  s.sizeFilter === "all" ? (u(), p("div", Fr, [...f[5] || (f[5] = [
                    o("svg", {
                      viewBox: "0 0 16 16",
                      fill: "currentColor"
                    }, [
                      o("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" })
                    ], -1)
                  ])])) : K("", !0)
                ], 2),
                o("div", {
                  class: te(["vuefinder__search-modal__dropdown-option", {
                    "vuefinder__search-modal__dropdown-option--selected": s.sizeFilter === "small"
                  }]),
                  onClick: f[1] || (f[1] = ve((F) => h("size-small"), ["stop"]))
                }, [
                  o("span", null, y(i(r)("Small (< 1MB)")), 1),
                  s.sizeFilter === "small" ? (u(), p("div", Tr, [...f[6] || (f[6] = [
                    o("svg", {
                      viewBox: "0 0 16 16",
                      fill: "currentColor"
                    }, [
                      o("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" })
                    ], -1)
                  ])])) : K("", !0)
                ], 2),
                o("div", {
                  class: te(["vuefinder__search-modal__dropdown-option", {
                    "vuefinder__search-modal__dropdown-option--selected": s.sizeFilter === "medium"
                  }]),
                  onClick: f[2] || (f[2] = ve((F) => h("size-medium"), ["stop"]))
                }, [
                  o("span", null, y(i(r)("Medium (1-10MB)")), 1),
                  s.sizeFilter === "medium" ? (u(), p("div", Er, [...f[7] || (f[7] = [
                    o("svg", {
                      viewBox: "0 0 16 16",
                      fill: "currentColor"
                    }, [
                      o("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" })
                    ], -1)
                  ])])) : K("", !0)
                ], 2),
                o("div", {
                  class: te(["vuefinder__search-modal__dropdown-option", {
                    "vuefinder__search-modal__dropdown-option--selected": s.sizeFilter === "large"
                  }]),
                  onClick: f[3] || (f[3] = ve((F) => h("size-large"), ["stop"]))
                }, [
                  o("span", null, y(i(r)("Large (> 10MB)")), 1),
                  s.sizeFilter === "large" ? (u(), p("div", Pr, [...f[8] || (f[8] = [
                    o("svg", {
                      viewBox: "0 0 16 16",
                      fill: "currentColor"
                    }, [
                      o("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" })
                    ], -1)
                  ])])) : K("", !0)
                ], 2)
              ])
            ]),
            o("div", Dr, [
              o("div", Mr, y(i(r)("Sort by")), 1),
              o("div", Ir, [
                (u(), p(_e, null, ge(w, (F) => o("div", {
                  key: F.value,
                  class: te(["vuefinder__search-modal__dropdown-option", {
                    "vuefinder__search-modal__dropdown-option--selected": s.sortBy === F.value
                  }]),
                  onClick: ve((C) => _(F.value), ["stop"])
                }, [
                  o("span", null, y(i(r)(F.key)), 1),
                  s.sortBy === F.value ? (u(), p("div", Or, [...f[9] || (f[9] = [
                    o("svg", {
                      viewBox: "0 0 16 16",
                      fill: "currentColor"
                    }, [
                      o("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" })
                    ], -1)
                  ])])) : K("", !0)
                ], 10, Ar)), 64))
              ])
            ])
          ])
        ], 40, kr)) : K("", !0)
      ]))
    ], 64));
  }
});
function Lt(s, e = 40) {
  const t = s.match(/^([^:]+:\/\/)(.*)$/);
  if (!t) return s;
  const n = t[1], a = t[2] ?? "", d = a.split("/").filter(Boolean), r = d.pop();
  if (!r) return n + a;
  let l = `${n}${d.join("/")}${d.length ? "/" : ""}${r}`;
  if (l.length <= e) return l;
  const c = r.split(/\.(?=[^\.]+$)/), v = c[0] ?? "", w = c[1] ?? "", h = v.length > 10 ? `${v.slice(0, 6)}...${v.slice(-5)}` : v, _ = w ? `${h}.${w}` : h;
  return l = `${n}${d.join("/")}${d.length ? "/" : ""}${_}`, l.length > e && (l = `${n}.../${_}`), l;
}
async function oo(s) {
  try {
    await navigator.clipboard.writeText(s);
  } catch {
    const e = document.createElement("textarea");
    e.value = s, document.body.appendChild(e), e.select(), document.execCommand("copy"), document.body.removeChild(e);
  }
}
async function wt(s) {
  await oo(s);
}
async function Rr(s) {
  await oo(s);
}
const Br = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 448 512"
};
function zr(s, e) {
  return u(), p("svg", Br, [...e[0] || (e[0] = [
    o("path", { d: "M8 256a56 56 0 1 1 112 0 56 56 0 1 1-112 0m160 0a56 56 0 1 1 112 0 56 56 0 1 1-112 0m216-56a56 56 0 1 1 0 112 56 56 0 1 1 0-112" }, null, -1)
  ])]);
}
const so = { render: zr }, Vr = ["title"], Ur = { class: "vuefinder__search-modal__result-icon" }, Nr = { class: "vuefinder__search-modal__result-content" }, Hr = { class: "vuefinder__search-modal__result-name" }, jr = {
  key: 1,
  class: "vuefinder__search-modal__result-size"
}, Kr = ["title"], qr = ["title"], Wr = ["data-item-dropdown", "data-theme"], Gr = { class: "vuefinder__search-modal__item-dropdown-content" }, Yr = /* @__PURE__ */ le({
  name: "SearchResultItem",
  __name: "SearchResultItem",
  props: {
    item: {},
    index: {},
    selectedIndex: {},
    expandedPaths: {},
    activeDropdown: {},
    selectedItemDropdownOption: {}
  },
  emits: ["select", "selectWithDropdown", "togglePathExpansion", "toggleItemDropdown", "update:selectedItemDropdownOption", "copyPath", "openContainingFolder", "open", "preview", "activate"],
  setup(s, { emit: e }) {
    const t = s, n = e, a = ae(), { t: d } = a.i18n, { enabled: r } = Ve(), l = oe(a.config.state), c = R(() => r("pinned")), v = R(
      () => l.value.pinnedFolders.some((T) => T.path === t.item.path)
    ), w = (T) => {
      const D = a.config.get("pinnedFolders");
      D.some((N) => N.path === T.path) ? a.config.set(
        "pinnedFolders",
        D.filter((N) => N.path !== T.path)
      ) : a.config.set("pinnedFolders", [...D, T]);
    }, h = M(null);
    let _ = null, k = null, b = [], $ = null;
    pe(
      () => t.activeDropdown,
      (T) => {
        _ && (_(), _ = null), k && (b.forEach((D) => {
          D === window ? window.removeEventListener("scroll", k, !0) : D.removeEventListener("scroll", k, !0);
        }), k = null, b = []), $ && (document.removeEventListener("mousedown", $, !0), document.removeEventListener("touchstart", $, !0), $ = null), T === t.item.path && h.value && De(() => {
          S(t.item.path, h.value), g(), f();
        });
      }
    );
    const m = (T) => {
      const D = [];
      let N = T;
      for (; N && N !== document.body && N !== document.documentElement; ) {
        const J = window.getComputedStyle(N), ce = J.overflow + J.overflowX + J.overflowY;
        (ce.includes("scroll") || ce.includes("auto")) && D.push(N), N = N.parentElement;
      }
      return D;
    }, g = () => {
      if (t.activeDropdown !== t.item.path) return;
      const T = m(h.value);
      b = [window, ...T], k = () => {
        t.activeDropdown === t.item.path && n("toggleItemDropdown", t.item.path, new MouseEvent("click"));
      };
      const D = k;
      D && b.forEach((N) => {
        N === window ? window.addEventListener("scroll", D, !0) : N.addEventListener("scroll", D, !0);
      });
    }, f = () => {
      t.activeDropdown === t.item.path && ($ = (T) => {
        if (t.activeDropdown !== t.item.path) return;
        const D = T.target;
        if (!D) return;
        const N = document.querySelector(
          `[data-item-dropdown="${t.item.path}"]`
        );
        if (N && N.contains(D) || h.value && h.value.contains(D))
          return;
        const J = a.root;
        if (J && J.contains(D)) {
          n("toggleItemDropdown", t.item.path, new MouseEvent("click"));
          return;
        }
        const ce = document.querySelector(".vuefinder__modal-layout");
        if (ce && ce.contains(D)) {
          n("toggleItemDropdown", t.item.path, new MouseEvent("click"));
          return;
        }
        n("toggleItemDropdown", t.item.path, new MouseEvent("click"));
      }, setTimeout(() => {
        $ && (document.addEventListener("mousedown", $, !0), document.addEventListener("touchstart", $, !0));
      }, 100));
    };
    Pe(() => {
      _ && (_(), _ = null), k && (b.forEach((T) => {
        T === window ? window.removeEventListener("scroll", k, !0) : T.removeEventListener("scroll", k, !0);
      }), k = null, b = []), $ && (document.removeEventListener("mousedown", $, !0), document.removeEventListener("touchstart", $, !0), $ = null);
    });
    const F = (T) => t.expandedPaths.has(T), C = (T) => T.type === "dir" || !T.file_size ? "" : Zt(T.file_size), A = (T, D) => {
      D.stopPropagation(), n("toggleItemDropdown", T, D);
    }, S = async (T, D) => {
      const N = document.querySelector(
        `[data-item-dropdown="${T}"]`
      );
      if (!(!N || !D) && (await De(), !(!N || !D))) {
        Object.assign(N.style, {
          position: "fixed",
          zIndex: "10001",
          opacity: "0",
          transform: "translateY(-8px)",
          transition: "opacity 150ms ease-out, transform 150ms ease-out"
        });
        try {
          const { x: J, y: ce } = await it(D, N, {
            placement: "left-start",
            strategy: "fixed",
            middleware: [pt(8), mt({ padding: 16 }), ht({ padding: 16 })]
          });
          Object.assign(N.style, {
            left: `${J}px`,
            top: `${ce}px`
          }), requestAnimationFrame(() => {
            N && Object.assign(N.style, {
              opacity: "1",
              transform: "translateY(0)"
            });
          });
        } catch (J) {
          console.warn("Floating UI initial positioning error:", J);
          return;
        }
        try {
          _ = Qt(D, N, async () => {
            if (!(!D || !N))
              try {
                const { x: J, y: ce } = await it(D, N, {
                  placement: "left-start",
                  strategy: "fixed",
                  middleware: [pt(8), mt({ padding: 16 }), ht({ padding: 16 })]
                });
                Object.assign(N.style, {
                  left: `${J}px`,
                  top: `${ce}px`
                });
              } catch (J) {
                console.warn("Floating UI positioning error:", J);
              }
          });
        } catch (J) {
          console.warn("Floating UI autoUpdate setup error:", J), _ = null;
        }
      }
    }, L = (T) => {
      n("update:selectedItemDropdownOption", T);
    }, H = async (T) => {
      await wt(T.path), n("copyPath", T);
    }, Y = (T) => {
      n("openContainingFolder", T);
    }, Q = (T) => {
      n("preview", T);
    }, B = (T) => {
      n("open", T);
    }, W = (T) => {
      if (!t.activeDropdown) return;
      const D = ["copy-path", "open-folder", "preview"], N = t.selectedItemDropdownOption, J = D.findIndex((ce) => N?.includes(ce));
      if (T.key === "ArrowDown") {
        T.preventDefault();
        const ce = (J + 1) % D.length;
        n(
          "update:selectedItemDropdownOption",
          `${D[ce] || ""}-${t.activeDropdown}`
        );
      } else if (T.key === "ArrowUp") {
        T.preventDefault();
        const ce = J <= 0 ? D.length - 1 : J - 1;
        n(
          "update:selectedItemDropdownOption",
          `${D[ce] || ""}-${t.activeDropdown}`
        );
      } else T.key === "Enter" ? (T.preventDefault(), N && (N.includes("copy-path") ? H(t.item) : N.includes("open-folder") ? Y(t.item) : N.includes("preview") && Q(t.item))) : T.key === "Escape" && (T.preventDefault(), n("update:selectedItemDropdownOption", null));
    };
    return (T, D) => (u(), p("div", {
      class: te(["vuefinder__search-modal__result-item", { "vuefinder__search-modal__result-item--selected": s.index === s.selectedIndex }]),
      title: s.item.basename,
      onClick: D[13] || (D[13] = (N) => n("select", s.index)),
      onDblclick: D[14] || (D[14] = ve((N) => n("activate", s.item), ["stop"]))
    }, [
      o("div", Ur, [
        s.item.type === "dir" ? (u(), Z(i(Re), { key: 0 })) : (u(), Z(i(gt), { key: 1 }))
      ]),
      o("div", Nr, [
        o("div", Hr, [
          s.item.type === "dir" && c.value && v.value ? (u(), Z(i(yt), {
            key: 0,
            class: "vuefinder__search-modal__result-pin",
            title: i(d)("Pinned")
          }, null, 8, ["title"])) : K("", !0),
          ye(" " + y(s.item.basename) + " ", 1),
          C(s.item) ? (u(), p("span", jr, y(C(s.item)), 1)) : K("", !0)
        ]),
        o("div", {
          class: "vuefinder__search-modal__result-path",
          title: s.item.path,
          onClick: D[0] || (D[0] = ve((N) => {
            n("select", s.index), n("togglePathExpansion", s.item.path);
          }, ["stop"]))
        }, y(F(s.item.path) ? s.item.path : i(Lt)(s.item.path)), 9, Kr)
      ]),
      o("button", {
        ref_key: "buttonElementRef",
        ref: h,
        class: "vuefinder__search-modal__result-actions",
        title: i(d)("More actions"),
        onClick: D[1] || (D[1] = (N) => {
          n("selectWithDropdown", s.index), A(s.item.path, N);
        })
      }, [
        X(i(so), { class: "vuefinder__search-modal__result-actions-icon" })
      ], 8, qr),
      (u(), Z(bt, { to: "body" }, [
        s.activeDropdown === s.item.path ? (u(), p("div", {
          key: 0,
          "data-item-dropdown": s.item.path,
          class: "vuefinder__themer vuefinder__search-modal__item-dropdown vuefinder__search-modal__item-dropdown--visible",
          "data-theme": i(a).theme.current,
          tabindex: "-1",
          onClick: D[12] || (D[12] = ve(() => {
          }, ["stop"])),
          onKeydown: W
        }, [
          o("div", Gr, [
            o("div", {
              class: te(["vuefinder__search-modal__item-dropdown-option", {
                "vuefinder__search-modal__item-dropdown-option--selected": s.selectedItemDropdownOption === `copy-path-${s.item.path}`
              }]),
              onClick: D[2] || (D[2] = (N) => {
                L(`copy-path-${s.item.path}`), H(s.item);
              }),
              onFocus: D[3] || (D[3] = (N) => L(`copy-path-${s.item.path}`))
            }, [
              X(i(an), { class: "vuefinder__search-modal__item-dropdown-icon" }),
              o("span", null, y(i(d)("Copy Path")), 1)
            ], 34),
            o("div", {
              class: te(["vuefinder__search-modal__item-dropdown-option", {
                "vuefinder__search-modal__item-dropdown-option--selected": s.selectedItemDropdownOption === `open-folder-${s.item.path}`
              }]),
              onClick: D[4] || (D[4] = (N) => {
                L(`open-folder-${s.item.path}`), Y(s.item);
              }),
              onFocus: D[5] || (D[5] = (N) => L(`open-folder-${s.item.path}`))
            }, [
              X(i(Re), { class: "vuefinder__search-modal__item-dropdown-icon" }),
              o("span", null, y(i(d)("Open Containing Folder")), 1)
            ], 34),
            s.item.type === "dir" ? (u(), p("div", {
              key: 0,
              class: te(["vuefinder__search-modal__item-dropdown-option", {
                "vuefinder__search-modal__item-dropdown-option--selected": s.selectedItemDropdownOption === `open-${s.item.path}`
              }]),
              onClick: D[6] || (D[6] = (N) => {
                L(`open-${s.item.path}`), B(s.item);
              }),
              onFocus: D[7] || (D[7] = (N) => L(`open-${s.item.path}`))
            }, [
              X(i(Re), { class: "vuefinder__search-modal__item-dropdown-icon" }),
              o("span", null, y(i(d)("Open")), 1)
            ], 34)) : K("", !0),
            s.item.type === "dir" && c.value ? (u(), p("div", {
              key: 1,
              class: te(["vuefinder__search-modal__item-dropdown-option", {
                "vuefinder__search-modal__item-dropdown-option--selected": s.selectedItemDropdownOption === `pin-${s.item.path}`
              }]),
              onClick: D[8] || (D[8] = (N) => {
                L(`pin-${s.item.path}`), w(s.item);
              }),
              onFocus: D[9] || (D[9] = (N) => L(`pin-${s.item.path}`))
            }, [
              X(i(yt), { class: "vuefinder__search-modal__item-dropdown-icon" }),
              o("span", null, y(v.value ? i(d)("Unpin Folder") : i(d)("Pin Folder")), 1)
            ], 34)) : (u(), p("div", {
              key: 2,
              class: te(["vuefinder__search-modal__item-dropdown-option", {
                "vuefinder__search-modal__item-dropdown-option--selected": s.selectedItemDropdownOption === `preview-${s.item.path}`
              }]),
              onClick: D[10] || (D[10] = (N) => {
                L(`preview-${s.item.path}`), Q(s.item);
              }),
              onFocus: D[11] || (D[11] = (N) => L(`preview-${s.item.path}`))
            }, [
              X(i(gt), { class: "vuefinder__search-modal__item-dropdown-icon" }),
              o("span", null, y(i(d)("Preview")), 1)
            ], 34))
          ])
        ], 40, Wr)) : K("", !0)
      ]))
    ], 42, Vr));
  }
}), Xr = {
  key: 0,
  class: "vuefinder__search-modal__searching"
}, Qr = { class: "vuefinder__search-modal__loading-icon" }, Jr = {
  key: 1,
  class: "vuefinder__search-modal__no-results"
}, Zr = {
  key: 2,
  class: "vuefinder__search-modal__results-list"
}, ed = { class: "vuefinder__search-modal__results-header" }, Je = 60, En = 5, td = /* @__PURE__ */ le({
  name: "SearchResultsList",
  __name: "SearchResultsList",
  props: {
    searchResults: {},
    isSearching: { type: Boolean },
    selectedIndex: {},
    expandedPaths: {},
    activeDropdown: {},
    selectedItemDropdownOption: {},
    resultsEnter: { type: Boolean }
  },
  emits: ["selectResultItem", "selectResultItemWithDropdown", "togglePathExpansion", "toggleItemDropdown", "update:selectedItemDropdownOption", "copyPath", "openContainingFolder", "open", "preview", "activate"],
  setup(s, { expose: e, emit: t }) {
    const n = s, a = t, d = ae(), { t: r } = d.i18n, l = st("scrollableContainer"), c = R(() => n.searchResults.length > 0), v = R(() => n.searchResults.length), w = M(0), h = M(600), _ = R(() => n.searchResults.length * Je), k = R(() => {
      const F = Math.max(0, Math.floor(w.value / Je) - En), C = Math.min(
        n.searchResults.length,
        Math.ceil((w.value + h.value) / Je) + En
      );
      return { start: F, end: C };
    }), b = R(() => {
      const { start: F, end: C } = k.value;
      return n.searchResults.slice(F, C).map((A, S) => ({
        item: A,
        index: F + S,
        top: (F + S) * Je
      }));
    }), $ = (F) => {
      const C = F.target;
      w.value = C.scrollTop;
    }, m = () => {
      l.value && (h.value = l.value.clientHeight);
    }, g = () => {
      if (n.selectedIndex >= 0 && l.value) {
        const F = n.selectedIndex * Je, C = F + Je, A = l.value.scrollTop, S = l.value.clientHeight, L = A + S;
        let H = A;
        F < A ? H = F : C > L && (H = C - S), H !== A && l.value.scrollTo({
          top: H,
          behavior: "smooth"
        });
      }
    }, f = () => {
      l.value && (l.value.scrollTop = 0, w.value = 0);
    };
    return we(() => {
      m(), window.addEventListener("resize", m);
    }), Pe(() => {
      window.removeEventListener("resize", m);
    }), pe(
      () => l.value,
      () => {
        m();
      }
    ), e({
      scrollSelectedIntoView: g,
      resetScroll: f,
      getContainerHeight: () => h.value,
      scrollTop: () => w.value
    }), (F, C) => (u(), p("div", {
      class: te(["vuefinder__search-modal__results", { "vuefinder__search-modal__results--enter": s.resultsEnter }])
    }, [
      s.isSearching ? (u(), p("div", Xr, [
        o("div", Qr, [
          X(i(Ot), { class: "vuefinder__search-modal__loading-icon" })
        ]),
        o("span", null, y(i(r)("Searching...")), 1)
      ])) : c.value ? (u(), p("div", Zr, [
        o("div", ed, [
          o("span", null, y(i(r)("Found %s results", v.value)), 1)
        ]),
        o("div", {
          ref_key: "scrollableContainer",
          ref: l,
          class: "vuefinder__search-modal__results-scrollable",
          onScroll: $
        }, [
          o("div", {
            class: "vuefinder__search-modal__results-items",
            style: Ee({ height: `${_.value}px`, position: "relative" })
          }, [
            (u(!0), p(_e, null, ge(b.value, (A) => (u(), p("div", {
              key: A.item.path,
              style: Ee({
                position: "absolute",
                top: `${A.top}px`,
                left: "0",
                width: "100%",
                height: `${Je}px`
              })
            }, [
              X(Yr, {
                item: A.item,
                index: A.index,
                "selected-index": s.selectedIndex,
                "expanded-paths": s.expandedPaths,
                "active-dropdown": s.activeDropdown,
                "selected-item-dropdown-option": s.selectedItemDropdownOption,
                onSelect: C[0] || (C[0] = (S) => a("selectResultItem", S)),
                onSelectWithDropdown: C[1] || (C[1] = (S) => a("selectResultItemWithDropdown", S)),
                onTogglePathExpansion: C[2] || (C[2] = (S) => a("togglePathExpansion", S)),
                onToggleItemDropdown: C[3] || (C[3] = (S, L) => a("toggleItemDropdown", S, L)),
                "onUpdate:selectedItemDropdownOption": C[4] || (C[4] = (S) => a("update:selectedItemDropdownOption", S)),
                onCopyPath: C[5] || (C[5] = (S) => a("copyPath", S)),
                onOpenContainingFolder: C[6] || (C[6] = (S) => a("openContainingFolder", S)),
                onOpen: C[7] || (C[7] = (S) => a("open", S)),
                onPreview: C[8] || (C[8] = (S) => a("preview", S)),
                onActivate: C[9] || (C[9] = (S) => a("activate", S))
              }, null, 8, ["item", "index", "selected-index", "expanded-paths", "active-dropdown", "selected-item-dropdown-option"])
            ], 4))), 128))
          ], 4)
        ], 544)
      ])) : (u(), p("div", Jr, [
        o("span", null, y(i(r)("No results found")), 1)
      ]))
    ], 2));
  }
}), nd = { class: "vuefinder__search-modal" }, od = { class: "vuefinder__search-modal__content" }, sd = { class: "vuefinder__search-modal__search-bar" }, id = { class: "vuefinder__search-modal__search-location" }, ad = ["title"], ld = ["disabled"], rd = {
  key: 0,
  class: "vuefinder__search-modal__folder-selector"
}, dd = { class: "vuefinder__search-modal__folder-selector-content" }, cd = {
  key: 1,
  class: "vuefinder__search-modal__instructions"
}, ud = { class: "vuefinder__search-modal__instructions-text" }, cn = /* @__PURE__ */ le({
  name: "ModalSearch",
  __name: "ModalSearch",
  setup(s) {
    const e = ae(), t = Be(e), { t: n } = e.i18n, a = e.fs, d = M(null), r = M(null), l = M(null), c = to("", 300), v = M([]), w = M(!1), h = M(-1);
    let _ = null;
    const k = M(!1), b = M(!1), $ = M(null), m = M("all"), g = M(!1), f = M("name-asc"), F = {
      "name-asc": { column: "basename", direction: 1 },
      "name-desc": { column: "basename", direction: -1 },
      "size-asc": { column: "file_size", direction: 1 },
      "size-desc": { column: "file_size", direction: -1 },
      "date-asc": { column: "last_modified", direction: 1 },
      "date-desc": { column: "last_modified", direction: -1 }
    }, C = R(() => {
      const { column: P, direction: j } = F[f.value];
      return v.value.slice().sort((de, me) => Kn(de[P], me[P]) * j);
    }), A = M(`size-${m.value}`), S = M(null), L = M(/* @__PURE__ */ new Set()), H = M(null), Y = oe(a.path), Q = (P) => {
      L.value.has(P) ? L.value.delete(P) : L.value.add(P);
    }, B = (P, j) => {
      j && typeof j.stopPropagation == "function" && j.stopPropagation(), H.value === P ? H.value = null : H.value = P;
    }, W = () => {
      H.value = null;
    }, T = (P) => {
      try {
        const j = P.dir || `${P.storage}://`;
        e.adapter.open(j), e.modal.close(), W();
      } catch {
        t.error(n("Failed to open containing folder"));
      }
    }, D = (P) => {
      e.modal.open(Xe, {
        storage: Y?.value?.storage ?? "local",
        item: P
      }), W();
    }, N = (P) => {
      e.adapter.open(P.path), e.modal.close(), W();
    }, J = (P) => {
      P.type === "dir" ? N(P) : D(P);
    }, ce = (P) => {
      h.value = P, W();
    }, z = (P) => {
      h.value = P;
    }, x = async (P) => {
      await wt(P.path), W();
    };
    pe(c, async (P) => {
      P.trim() ? (await E(P.trim()), h.value = 0) : (_ && (_.abort(), _ = null), v.value = [], w.value = !1, h.value = -1);
    }), pe(m, async (P) => {
      A.value = `size-${P}`, c.value.trim() && !b.value && (await E(c.value.trim()), h.value = 0);
    }), pe(g, async () => {
      c.value.trim() && !b.value && (await E(c.value.trim()), h.value = 0);
    });
    const U = (P) => {
      if (!P || typeof P != "object") return !1;
      const j = P.name;
      return j === "AbortError" || j === "CanceledError";
    }, E = async (P) => {
      if (!P) return;
      _ && _.abort();
      const j = new AbortController();
      _ = j, w.value = !0;
      try {
        const de = $.value?.path || Y?.value?.path, me = await e.adapter.search({
          path: de,
          filter: P,
          deep: g.value,
          size: m.value,
          signal: j.signal
        });
        if (j.signal.aborted) return;
        v.value = me || [], w.value = !1;
      } catch (de) {
        if (U(de) || j.signal.aborted) return;
        t.error(Fe(de, n("Search failed"))), v.value = [], w.value = !1;
      }
    };
    we(() => {
      document.addEventListener("click", q), A.value = `size-${m.value}`;
    });
    const V = () => {
      b.value ? (b.value = !1, c.value.trim() && (E(c.value.trim()), h.value = 0)) : (k.value = !1, b.value = !0);
    }, I = (P) => {
      P && ($.value = P);
    }, O = (P) => {
      P && (I(P), b.value = !1, c.value.trim() && (E(c.value.trim()), h.value = 0));
    };
    Pe(() => {
      document.removeEventListener("click", q), _ && (_.abort(), _ = null), r.value && r.value.cleanup();
    });
    const q = (P) => {
      const j = P.target;
      if (k.value && (j.closest(".vuefinder__search-modal__dropdown") || (k.value = !1, De(() => {
        d.value && d.value.focus();
      }))), H.value) {
        const de = j.closest(".vuefinder__search-modal__item-dropdown"), me = j.closest(".vuefinder__search-modal__result-item");
        !de && !me && W();
      }
    };
    return (P, j) => (u(), Z(ze, { class: "vuefinder__search-modal-layout" }, {
      default: ue(() => [
        o("div", nd, [
          X(He, {
            icon: i(dn),
            title: i(n)("Search files")
          }, null, 8, ["icon", "title"]),
          o("div", od, [
            o("div", sd, [
              X(gr, {
                ref_key: "searchInputRef",
                ref: d,
                modelValue: i(c),
                "onUpdate:modelValue": j[0] || (j[0] = (de) => bo(c) ? c.value = de : null),
                "is-searching": w.value,
                disabled: b.value
              }, null, 8, ["modelValue", "is-searching", "disabled"]),
              X(Lr, {
                ref_key: "searchOptionsDropdownRef",
                ref: r,
                visible: k.value,
                "onUpdate:visible": j[1] || (j[1] = (de) => k.value = de),
                "size-filter": m.value,
                "onUpdate:sizeFilter": j[2] || (j[2] = (de) => m.value = de),
                "selected-option": A.value,
                "onUpdate:selectedOption": j[3] || (j[3] = (de) => A.value = de),
                "sort-by": f.value,
                "onUpdate:sortBy": j[4] || (j[4] = (de) => f.value = de),
                disabled: b.value
              }, null, 8, ["visible", "size-filter", "selected-option", "sort-by", "disabled"])
            ]),
            o("div", {
              class: "vuefinder__search-modal__options",
              onClick: j[8] || (j[8] = ve(() => {
              }, ["stop"]))
            }, [
              o("div", id, [
                o("button", {
                  class: te(["vuefinder__search-modal__location-btn", { "vuefinder__search-modal__location-btn--open": b.value }]),
                  onClick: ve(V, ["stop"])
                }, [
                  X(i(Re), { class: "vuefinder__search-modal__location-icon" }),
                  o("span", {
                    class: "vuefinder__search-modal__location-text",
                    title: $.value?.path || i(Y).path
                  }, y(i(Lt)($.value?.path || i(Y).path)), 9, ad),
                  j[11] || (j[11] = o("svg", {
                    class: "vuefinder__search-modal__location-arrow",
                    viewBox: "0 0 16 16",
                    fill: "currentColor"
                  }, [
                    o("path", { d: "M4.427 7.427l3.396 3.396a.25.25 0 00.354 0l3.396-3.396A.25.25 0 0011.396 7H4.604a.25.25 0 00-.177.427z" })
                  ], -1))
                ], 2)
              ]),
              o("label", {
                class: "vuefinder__search-modal__deep-search",
                onClick: j[7] || (j[7] = ve(() => {
                }, ["stop"]))
              }, [
                he(o("input", {
                  "onUpdate:modelValue": j[5] || (j[5] = (de) => g.value = de),
                  type: "checkbox",
                  disabled: b.value,
                  class: "vuefinder__search-modal__checkbox",
                  onClick: j[6] || (j[6] = ve(() => {
                  }, ["stop"]))
                }, null, 8, ld), [
                  [lt, g.value]
                ]),
                o("span", null, y(i(n)("Include subfolders")), 1)
              ])
            ]),
            b.value ? (u(), p("div", rd, [
              o("div", dd, [
                X(kt, {
                  modelValue: $.value,
                  "onUpdate:modelValue": [
                    j[9] || (j[9] = (de) => $.value = de),
                    I
                  ],
                  "show-pinned-folders": !0,
                  "current-path": i(Y),
                  onSelectAndClose: O
                }, null, 8, ["modelValue", "current-path"])
              ])
            ])) : K("", !0),
            !i(c).trim() && !b.value ? (u(), p("div", cd, [
              o("p", ud, y(i(n)("Start typing to search files. Use options to filter or include subfolders.")), 1)
            ])) : K("", !0),
            i(c).trim() && !b.value ? (u(), Z(td, {
              key: 2,
              ref_key: "searchResultsListRef",
              ref: l,
              "search-results": C.value,
              "is-searching": w.value,
              "selected-index": h.value,
              "expanded-paths": L.value,
              "active-dropdown": H.value,
              "selected-item-dropdown-option": S.value,
              "results-enter": !0,
              onSelectResultItem: ce,
              onSelectResultItemWithDropdown: z,
              onTogglePathExpansion: Q,
              onToggleItemDropdown: B,
              "onUpdate:selectedItemDropdownOption": j[10] || (j[10] = (de) => S.value = de),
              onCopyPath: x,
              onOpenContainingFolder: T,
              onOpen: N,
              onPreview: D,
              onActivate: J
            }, null, 8, ["search-results", "is-searching", "selected-index", "expanded-paths", "active-dropdown", "selected-item-dropdown-option"])) : K("", !0)
          ])
        ])
      ]),
      _: 1
    }));
  }
}), vd = {
  props: {
    on: { type: String, required: !0 }
  },
  setup(s, { emit: e, slots: t }) {
    const n = ae(), a = M(!1), { t: d } = n.i18n;
    let r = null;
    const l = () => {
      r && clearTimeout(r), a.value = !0, r = setTimeout(() => {
        a.value = !1;
      }, 2e3);
    };
    return we(() => {
      n.emitter.on(s.on, l);
    }), Pe(() => {
      r && clearTimeout(r);
    }), {
      shown: a,
      t: d
    };
  }
}, fd = (s, e) => {
  const t = s.__vccOpts || s;
  for (const [n, a] of e)
    t[n] = a;
  return t;
}, _d = { key: 1 };
function pd(s, e, t, n, a, d) {
  return u(), p("div", {
    class: te(["vuefinder__action-message", { "vuefinder__action-message--hidden": !n.shown }])
  }, [
    s.$slots.default ? Me(s.$slots, "default", {}, void 0, void 0, 0) : (u(), p("span", _d, y(n.t("Saved.")), 1))
  ], 2);
}
const Pn = /* @__PURE__ */ fd(vd, [["render", pd]]), md = [
  { name: "silver", displayName: "Silver" },
  { name: "valorite", displayName: "Valorite" },
  { name: "midnight", displayName: "Midnight" },
  { name: "latte", displayName: "Latte" },
  { name: "rose", displayName: "Rose" },
  { name: "mythril", displayName: "Mythril" },
  { name: "lime", displayName: "lime" },
  { name: "sky", displayName: "Sky" },
  { name: "ocean", displayName: "Oceanic" },
  { name: "palenight", displayName: "Palenight" },
  { name: "arctic", displayName: "Arctic" },
  { name: "code", displayName: "Code" }
], hd = { class: "vuefinder__settings-modal__content" }, gd = { class: "vuefinder__settings-modal__main" }, yd = { class: "vuefinder__settings-modal__sections" }, wd = {
  key: 0,
  class: "vuefinder__settings-modal__section"
}, bd = {
  for: "theme",
  class: "vuefinder__settings-modal__label"
}, kd = { class: "vuefinder__settings-modal__input-group" }, $d = ["value"], xd = ["value"], Sd = {
  key: 1,
  class: "vuefinder__settings-modal__section"
}, Cd = {
  for: "language",
  class: "vuefinder__settings-modal__label"
}, Fd = { class: "vuefinder__settings-modal__input-group" }, Td = ["value"], Ed = { class: "vuefinder__settings-modal__reset-section" }, Pd = { class: "vuefinder__settings-modal__reset-content" }, Dd = { class: "vuefinder__settings-modal__reset-title" }, Md = { class: "vuefinder__settings-modal__reset-description" }, io = /* @__PURE__ */ le({
  __name: "ModalSettings",
  setup(s) {
    const e = ae(), { enabled: t } = Ve(), n = e.config, { clearStore: a } = e.storage, { t: d, localeAtom: r } = e.i18n, l = oe(r), c = R({
      get: () => String(l.value || "en"),
      set: (m) => r.set(m || "en")
    }), v = oe(n.state), w = R(() => v.value.theme || "silver"), h = async () => {
      n.reset(), a(), localStorage.removeItem("vuefinder_locale"), localStorage.removeItem("vuefinder_translations"), location.reload();
    }, _ = (m) => {
      n.set("theme", m), e.emitter.emit("vf-theme-saved");
    }, { i18n: k } = Ct("VueFinderOptions"), $ = Object.fromEntries(
      Object.entries({
        ar: "Arabic (العربيّة)",
        zhCN: "Chinese-Simplified (简体中文)",
        zhTW: "Chinese-Traditional (繁體中文)",
        nl: "Dutch (Nederlands)",
        en: "English",
        fr: "French (Français)",
        de: "German (Deutsch)",
        he: "Hebrew (עִברִית)",
        hi: "Hindi (हिंदी)",
        it: "Italian (Italiano)",
        ja: "Japanese (日本語)",
        fa: "Persian (فارسی)",
        pl: "Polish (Polski)",
        pt: "Portuguese (Português)",
        ru: "Russian (Pусский)",
        es: "Spanish (Español)",
        sv: "Swedish (Svenska)",
        tr: "Turkish (Türkçe)"
      }).filter(([m]) => Object.keys(k).includes(m))
    );
    return (m, g) => (u(), Z(ze, null, {
      buttons: ue(() => [
        o("button", {
          type: "button",
          class: "vf-btn vf-btn-secondary",
          onClick: g[2] || (g[2] = (f) => i(e).modal.close())
        }, y(i(d)("Close")), 1)
      ]),
      default: ue(() => [
        o("div", hd, [
          X(He, {
            icon: i(no),
            title: i(d)("Settings")
          }, null, 8, ["icon", "title"]),
          o("div", gd, [
            o("div", yd, [
              i(t)("theme") ? (u(), p("div", wd, [
                o("label", bd, [
                  ye(y(i(d)("Theme")) + " ", 1),
                  X(Pn, {
                    class: "vuefinder__settings-modal__message",
                    on: "vf-theme-saved"
                  }, {
                    default: ue(() => [
                      ye(y(i(d)("Saved.")), 1)
                    ]),
                    _: 1
                  })
                ]),
                o("div", kd, [
                  o("select", {
                    id: "theme",
                    value: w.value,
                    class: "vuefinder__settings-modal__select",
                    onChange: g[0] || (g[0] = (f) => _(f.target?.value))
                  }, [
                    (u(!0), p(_e, null, ge(i(md), (f) => (u(), p("option", {
                      key: f.name,
                      value: f.name
                    }, y(f.displayName), 9, xd))), 128))
                  ], 40, $d)
                ])
              ])) : K("", !0),
              Object.keys(i($)).length > 1 ? (u(), p("div", Sd, [
                o("label", Cd, [
                  ye(y(i(d)("Language")) + " ", 1),
                  X(Pn, {
                    class: "vuefinder__settings-modal__message",
                    on: "vf-language-saved"
                  }, {
                    default: ue(() => [
                      ye(y(i(d)("Saved.")), 1)
                    ]),
                    _: 1
                  })
                ]),
                o("div", Fd, [
                  he(o("select", {
                    id: "language",
                    "onUpdate:modelValue": g[1] || (g[1] = (f) => c.value = f),
                    class: "vuefinder__settings-modal__select"
                  }, [
                    (u(!0), p(_e, null, ge(i($), (f, F) => (u(), p("option", {
                      key: F,
                      value: F
                    }, y(f), 9, Td))), 128))
                  ], 512), [
                    [Kt, c.value]
                  ])
                ])
              ])) : K("", !0)
            ]),
            o("div", Ed, [
              o("div", Pd, [
                o("div", Dd, y(i(d)("Reset")), 1),
                o("div", Md, y(i(d)("Reset all settings to default")), 1)
              ]),
              o("button", {
                type: "button",
                class: "vuefinder__settings-modal__reset-button",
                onClick: h
              }, y(i(d)("Reset Settings")), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }));
  }
}), Oe = {
  ESCAPE: "Escape",
  DELETE: "Delete",
  ENTER: "Enter",
  BACKSLASH: "Backslash",
  KEY_A: "KeyA",
  KEY_E: "KeyE",
  KEY_F: "KeyF",
  SPACE: "Space",
  KEY_C: "KeyC",
  KEY_X: "KeyX",
  KEY_V: "KeyV",
  KEY_S: "KeyS",
  KEY_R: "KeyR"
};
function Id() {
  const s = ae(), e = Be(s), t = s.fs, n = s.config, { enabled: a } = Ve(), d = oe(t.path), r = oe(t.selectedItems), l = (c) => {
    if (c.code === Oe.ESCAPE && (s.modal.close(), s.root.focus()), !s.modal.visible) {
      if (c.metaKey && c.code === Oe.KEY_R && !c.shiftKey && (s.adapter.invalidateListQuery(d.value.path), s.adapter.open(d.value.path), c.preventDefault()), c.metaKey && c.shiftKey && c.code === Oe.KEY_R && a("rename") && r.value.length === 1 && (s.modal.open(Dt, { items: r.value }), c.preventDefault()), c.code === Oe.DELETE && r.value.length !== 0 && s.modal.open(Pt, { items: r.value }), c.metaKey && c.code === Oe.BACKSLASH && s.modal.open(Wn), c.metaKey && c.code === Oe.KEY_F && a("search") && (s.modal.open(cn), c.preventDefault()), c.metaKey && c.code === Oe.KEY_E && (n.toggle("showTreeView"), c.preventDefault()), c.metaKey && c.code === Oe.KEY_S && (s.modal.open(io), c.preventDefault()), c.metaKey && c.code === Oe.ENTER && (n.toggle("fullScreen"), s.root.focus()), c.metaKey && c.code === Oe.KEY_A && (t.selectAll(s.selectionMode || "multiple", s), c.preventDefault()), c.code === Oe.SPACE && r.value.length === 1 && r.value[0]?.type !== "dir" && s.modal.open(Xe, {
        storage: t.path.get().storage,
        item: r.value[0]
      }), c.metaKey && c.code === Oe.KEY_C && a("copy")) {
        if (r.value.length === 0) {
          e.error(s.i18n.t("No items selected"));
          return;
        }
        t.setClipboard("copy", new Set(r.value.map((v) => ke(v)))), e.success(
          r.value.length === 1 ? s.i18n.t("Item copied to clipboard") : s.i18n.t("%s items copied to clipboard", r.value.length)
        ), c.preventDefault();
      }
      if (c.metaKey && c.code === Oe.KEY_X && a("copy")) {
        if (r.value.length === 0) {
          e.error(s.i18n.t("No items selected"));
          return;
        }
        t.setClipboard("cut", new Set(r.value.map((v) => ke(v)))), e.success(
          r.value.length === 1 ? s.i18n.t("Item cut to clipboard") : s.i18n.t("%s items cut to clipboard", r.value.length)
        ), c.preventDefault();
      }
      if (c.metaKey && c.code === Oe.KEY_V && a("copy")) {
        if (t.getClipboard().items.size === 0) {
          e.error(s.i18n.t("No items in clipboard"));
          return;
        }
        if (t.getClipboard().path === t.path.get().path) {
          e.error(s.i18n.t("Cannot paste items to the same directory"));
          return;
        }
        if (t.getClipboard().type === "cut") {
          s.modal.open(at, {
            items: { from: Array.from(t.getClipboard().items), to: t.path.get() }
          }), t.clearClipboard();
          return;
        }
        if (t.getClipboard().type === "copy") {
          s.modal.open(rn, {
            items: { from: Array.from(t.getClipboard().items), to: t.path.get() }
          });
          return;
        }
        c.preventDefault();
      }
    }
  };
  we(async () => {
    if (await De(), !s.root) {
      console.warn("app.root is not available. Event listeners will not be attached.");
      return;
    }
    s.root.addEventListener("keydown", l);
  }), rt(() => {
    s.root && s.root.removeEventListener("keydown", l);
  });
}
function Ad() {
  const s = M(!1), e = M([]);
  return {
    isDraggingExternal: s,
    externalFiles: e,
    handleDragEnter: (l) => {
      l.preventDefault(), l.stopPropagation();
      const c = l.dataTransfer?.items;
      c && Array.from(c).some((w) => w.kind === "file") && (s.value = !0, l.isExternalDrag = !0);
    },
    handleDragOver: (l) => {
      s.value && l.dataTransfer && (l.dataTransfer.dropEffect = "copy", l.preventDefault(), l.stopPropagation());
    },
    handleDragLeave: (l) => {
      l.preventDefault();
      const c = l.currentTarget.getBoundingClientRect(), v = l.clientX, w = l.clientY;
      (v < c.left || v > c.right || w < c.top || w > c.bottom) && (s.value = !1);
    },
    handleDrop: async (l) => {
      l.preventDefault(), l.stopPropagation(), s.value = !1;
      const c = l.dataTransfer?.items;
      if (c) {
        const v = Array.from(c).filter((w) => w.kind === "file");
        if (v.length > 0) {
          e.value = [];
          for (const w of v) {
            const h = w.webkitGetAsEntry?.();
            if (h)
              await on((_, k) => {
                e.value.push({
                  name: k.name,
                  size: k.size,
                  type: k.type,
                  lastModified: new Date(k.lastModified),
                  file: k
                });
              }, h);
            else {
              const _ = w.getAsFile();
              _ && e.value.push({
                name: _.name,
                size: _.size,
                type: _.type,
                lastModified: new Date(_.lastModified),
                file: _
              });
            }
          }
          return e.value;
        }
      }
      return [];
    },
    clearExternalFiles: () => {
      e.value = [];
    }
  };
}
const Od = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "stroke-width": "1.5",
  class: "h-6 w-6 md:h-8 md:w-8 m-auto vf-toolbar-icon",
  viewBox: "0 0 24 24"
};
function Ld(s, e) {
  return u(), p("svg", Od, [...e[0] || (e[0] = [
    o("path", { d: "M12 10.5v6m3-3H9m4.06-7.19-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44z" }, null, -1)
  ])]);
}
const ao = { render: Ld }, Rd = { class: "vuefinder__new-folder-modal__content" }, Bd = { class: "vuefinder__new-folder-modal__form" }, zd = { class: "vuefinder__new-folder-modal__description" }, Vd = ["placeholder"], un = /* @__PURE__ */ le({
  __name: "ModalNewFolder",
  setup(s) {
    const e = ae(), t = Be(e), { t: n } = e.i18n, a = e.fs, d = oe(a.path), r = M(""), l = () => {
      r.value !== "" && e.adapter.createFolder({
        path: d.value.path,
        name: r.value
      }).then((c) => {
        t.success(n("%s is created.", r.value)), e.fs.setFiles(c.files), e.modal.close();
      }).catch((c) => {
        t.error(Fe(c, n("Failed to create folder")));
      });
    };
    return (c, v) => (u(), Z(ze, null, {
      buttons: ue(() => [
        o("button", {
          type: "button",
          class: "vf-btn vf-btn-primary",
          onClick: l
        }, y(i(n)("Create")), 1),
        o("button", {
          type: "button",
          class: "vf-btn vf-btn-secondary",
          onClick: v[1] || (v[1] = (w) => i(e).modal.close())
        }, y(i(n)("Cancel")), 1)
      ]),
      default: ue(() => [
        o("div", null, [
          X(He, {
            icon: i(ao),
            title: i(n)("New Folder")
          }, null, 8, ["icon", "title"]),
          o("div", Rd, [
            o("div", Bd, [
              o("p", zd, y(i(n)("Create a new folder")), 1),
              he(o("input", {
                "onUpdate:modelValue": v[0] || (v[0] = (w) => r.value = w),
                class: "vuefinder__new-folder-modal__input",
                placeholder: i(n)("Folder Name"),
                type: "text",
                autofocus: "",
                onKeyup: je(l, ["enter"])
              }, null, 40, Vd), [
                [Ke, r.value]
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }));
  }
}), Ud = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "stroke-width": "1.5",
  class: "h-6 w-6 md:h-8 md:w-8 m-auto vf-toolbar-icon",
  viewBox: "0 0 24 24"
};
function Nd(s, e) {
  return u(), p("svg", Ud, [...e[0] || (e[0] = [
    o("path", { d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m3.75 9v6m3-3H9m1.5-12H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9" }, null, -1)
  ])]);
}
const lo = { render: Nd }, Hd = { class: "vuefinder__new-file-modal__content" }, jd = { class: "vuefinder__new-file-modal__form" }, Kd = { class: "vuefinder__new-file-modal__description" }, qd = ["placeholder"], ro = /* @__PURE__ */ le({
  __name: "ModalNewFile",
  setup(s) {
    const e = ae(), t = Be(e), { t: n } = e.i18n, a = e.fs, d = oe(a.path), r = M(""), l = () => {
      r.value !== "" && e.adapter.createFile({
        path: d.value.path,
        name: r.value
      }).then((c) => {
        t.success(n("%s is created.", r.value)), e.fs.setFiles(c.files), e.modal.close();
      }).catch((c) => {
        t.error(Fe(c, n("Failed to create file")));
      });
    };
    return (c, v) => (u(), Z(ze, null, {
      buttons: ue(() => [
        o("button", {
          type: "button",
          class: "vf-btn vf-btn-primary",
          onClick: l
        }, y(i(n)("Create")), 1),
        o("button", {
          type: "button",
          class: "vf-btn vf-btn-secondary",
          onClick: v[1] || (v[1] = (w) => i(e).modal.close())
        }, y(i(n)("Cancel")), 1)
      ]),
      default: ue(() => [
        o("div", null, [
          X(He, {
            icon: i(lo),
            title: i(n)("New File")
          }, null, 8, ["icon", "title"]),
          o("div", Hd, [
            o("div", jd, [
              o("p", Kd, y(i(n)("Create a new file")), 1),
              he(o("input", {
                "onUpdate:modelValue": v[0] || (v[0] = (w) => r.value = w),
                class: "vuefinder__new-file-modal__input",
                placeholder: i(n)("File Name"),
                type: "text",
                onKeyup: je(l, ["enter"])
              }, null, 40, qd), [
                [Ke, r.value]
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }));
  }
}), Wd = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "stroke-width": "1.5",
  class: "h-6 w-6 md:h-8 md:w-8 m-auto vf-toolbar-icon",
  viewBox: "0 0 24 24"
};
function Gd(s, e) {
  return u(), p("svg", Wd, [...e[0] || (e[0] = [
    o("path", { d: "M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5m-13.5-9L12 3m0 0 4.5 4.5M12 3v13.5" }, null, -1)
  ])]);
}
const co = { render: Gd };
function Yt(s, e = 14) {
  const t = `((?=([\\w\\W]{0,${e}}))([\\w\\W]{${e + 1},})([\\w\\W]{8,}))`;
  return s.replace(new RegExp(t), "$2..$4");
}
const Yd = { class: "vuefinder__upload-modal__content relative" }, Xd = { class: "vuefinder__upload-modal__target-section" }, Qd = { class: "vuefinder__upload-modal__target-label" }, Jd = { class: "vuefinder__upload-modal__target-container" }, Zd = { class: "vuefinder__upload-modal__target-path" }, ec = { class: "vuefinder__upload-modal__target-storage" }, tc = {
  key: 0,
  class: "vuefinder__upload-modal__target-folder"
}, nc = { class: "vuefinder__upload-modal__target-badge" }, oc = { class: "vuefinder__upload-modal__drag-hint" }, sc = { class: "vuefinder__upload-modal__file-list vf-scrollbar" }, ic = ["textContent"], ac = { class: "vuefinder__upload-modal__file-info" }, lc = {
  key: 0,
  class: "vuefinder__upload-modal__file-rename"
}, rc = ["placeholder", "onKeyup"], dc = ["title", "onClick"], cc = ["title"], uc = { class: "vuefinder__upload-modal__file-name hidden md:block" }, vc = { class: "vuefinder__upload-modal__file-name md:hidden" }, fc = {
  key: 0,
  class: "ml-auto"
}, _c = ["title", "disabled", "onClick"], pc = ["title", "disabled", "onClick"], mc = {
  key: 0,
  class: "py-2"
}, hc = ["aria-expanded"], gc = {
  key: 0,
  class: "vuefinder__upload-actions__menu absolute right-0 bottom-full left-0 mb-2"
}, yc = ["disabled"], wc = ["aria-expanded"], bc = {
  key: 0,
  class: "vuefinder__upload-actions__menu"
}, vn = /* @__PURE__ */ le({
  __name: "ModalUpload",
  setup(s) {
    const e = ae(), { t } = e.i18n, n = e.fs, a = oe(n.path), d = M(a.value), r = M(!1), l = () => {
      const q = d.value.path;
      if (!q) return { storage: "local", path: "" };
      if (q.endsWith("://"))
        return { storage: q.replace("://", ""), path: "" };
      const P = q.split("://");
      return {
        storage: P[0] || "local",
        path: P[1] || ""
      };
    }, c = (q) => {
      q && (d.value = q);
    }, v = (q) => {
      q && (d.value = q, r.value = !1);
    }, {
      container: w,
      internalFileInput: h,
      internalFolderInput: _,
      pickFiles: k,
      queue: b,
      message: $,
      uploading: m,
      hasFilesInDropArea: g,
      definitions: f,
      openFileSelector: F,
      upload: C,
      cancel: A,
      remove: S,
      clear: L,
      close: H,
      getClassNameForEntry: Y,
      getIconForEntry: Q,
      addExternalFiles: B,
      renameEntry: W
    } = Qn(e.customUploader), T = M(null), D = M(""), N = M(null), J = (q) => {
      const P = q.lastIndexOf("/");
      return P === -1 ? q : q.slice(P + 1);
    }, ce = (q) => {
      m.value || q.status !== f.value.QUEUE_ENTRY_STATUS.UPLOADING && (T.value = q.id, D.value = J(q.name), De(() => {
        const P = N.value;
        if (P) {
          P.focus();
          const j = D.value.lastIndexOf(".");
          j > 0 ? P.setSelectionRange(0, j) : P.select();
        }
      }));
    }, z = () => {
      T.value = null, D.value = "";
    }, x = async (q) => {
      const P = D.value.trim();
      if (!P || P === J(q.name)) {
        z();
        return;
      }
      await W(q, P), z();
    }, U = () => {
      C(d.value);
    };
    we(() => {
      e.emitter.on("vf-external-files-dropped", (q) => {
        B(q);
      });
    }), Pe(() => {
      e.emitter.off("vf-external-files-dropped");
    });
    const E = M(!1), V = M(null), I = M(null), O = (q) => {
      if (!E.value) return;
      const P = q.target, j = V.value?.contains(P) ?? !1, de = I.value?.contains(P) ?? !1;
      !j && !de && (E.value = !1);
    };
    return we(() => document.addEventListener("click", O)), Pe(() => document.removeEventListener("click", O)), (q, P) => (u(), Z(ze, {
      "show-drag-overlay": i(g),
      "drag-overlay-text": i(t)("Drag and drop the files/folders to here.")
    }, {
      buttons: ue(() => [
        o("div", {
          ref_key: "actionsMenuMobileRef",
          ref: V,
          class: "relative mb-2 w-full sm:hidden"
        }, [
          o("div", {
            class: te([
              "vuefinder__upload-actions",
              "vuefinder__upload-actions--block",
              E.value ? "vuefinder__upload-actions--ring" : ""
            ])
          }, [
            o("button", {
              type: "button",
              class: "vuefinder__upload-actions__main",
              onClick: P[4] || (P[4] = (j) => i(F)())
            }, y(i(t)("Select Files")), 1),
            o("button", {
              type: "button",
              class: "vuefinder__upload-actions__trigger",
              "aria-haspopup": "menu",
              "aria-expanded": E.value ? "true" : "false",
              onClick: P[5] || (P[5] = ve((j) => E.value = !E.value, ["stop"]))
            }, [...P[21] || (P[21] = [
              o("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "h-4 w-4",
                viewBox: "0 0 20 20",
                fill: "currentColor"
              }, [
                o("path", {
                  "fill-rule": "evenodd",
                  d: "M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z",
                  "clip-rule": "evenodd"
                })
              ], -1)
            ])], 8, hc)
          ], 2),
          E.value ? (u(), p("div", gc, [
            o("div", {
              class: "vuefinder__upload-actions__item",
              onClick: P[6] || (P[6] = (j) => {
                i(F)(), E.value = !1;
              })
            }, y(i(t)("Select Files")), 1),
            o("div", {
              class: "vuefinder__upload-actions__item",
              onClick: P[7] || (P[7] = (j) => {
                i(_)?.click(), E.value = !1;
              })
            }, y(i(t)("Select Folders")), 1),
            P[22] || (P[22] = o("div", { class: "vuefinder__upload-actions__separator" }, null, -1)),
            o("div", {
              class: te(["vuefinder__upload-actions__item", i(m) ? "disabled" : ""]),
              onClick: P[8] || (P[8] = (j) => i(m) ? null : (i(L)(!1), E.value = !1))
            }, y(i(t)("Clear all")), 3),
            o("div", {
              class: te(["vuefinder__upload-actions__item", i(m) ? "disabled" : ""]),
              onClick: P[9] || (P[9] = (j) => i(m) ? null : (i(L)(!0), E.value = !1))
            }, y(i(t)("Clear only successful")), 3)
          ])) : K("", !0)
        ], 512),
        o("button", {
          type: "button",
          class: "vf-btn vf-btn-primary",
          disabled: i(m) || !i(b).length,
          onClick: ve(U, ["prevent"])
        }, y(i(t)("Upload")), 9, yc),
        i(m) ? (u(), p("button", {
          key: 0,
          type: "button",
          class: "vf-btn vf-btn-secondary",
          onClick: P[10] || (P[10] = ve(
            //@ts-ignore
            (...j) => i(A) && i(A)(...j),
            ["prevent"]
          ))
        }, y(i(t)("Cancel")), 1)) : (u(), p("button", {
          key: 1,
          type: "button",
          class: "vf-btn vf-btn-secondary",
          onClick: P[11] || (P[11] = ve(
            //@ts-ignore
            (...j) => i(H) && i(H)(...j),
            ["prevent"]
          ))
        }, y(i(t)("Close")), 1)),
        o("div", {
          ref_key: "actionsMenuDesktopRef",
          ref: I,
          class: "relative mr-auto hidden sm:block"
        }, [
          o("div", {
            class: te(["vuefinder__upload-actions", E.value ? "vuefinder__upload-actions--ring" : ""])
          }, [
            o("button", {
              ref_key: "pickFiles",
              ref: k,
              type: "button",
              class: "vuefinder__upload-actions__main"
            }, y(i(t)("Select Files")), 513),
            o("button", {
              type: "button",
              class: "vuefinder__upload-actions__trigger",
              "aria-haspopup": "menu",
              "aria-expanded": E.value ? "true" : "false",
              onClick: P[12] || (P[12] = ve((j) => E.value = !E.value, ["stop"]))
            }, [...P[23] || (P[23] = [
              o("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "h-4 w-4",
                viewBox: "0 0 20 20",
                fill: "currentColor"
              }, [
                o("path", {
                  "fill-rule": "evenodd",
                  d: "M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z",
                  "clip-rule": "evenodd"
                })
              ], -1)
            ])], 8, wc)
          ], 2),
          E.value ? (u(), p("div", bc, [
            o("div", {
              class: "vuefinder__upload-actions__item",
              onClick: P[13] || (P[13] = (j) => {
                i(F)(), E.value = !1;
              })
            }, y(i(t)("Select Files")), 1),
            o("div", {
              class: "vuefinder__upload-actions__item",
              onClick: P[14] || (P[14] = (j) => {
                i(_)?.click(), E.value = !1;
              })
            }, y(i(t)("Select Folders")), 1),
            P[24] || (P[24] = o("div", { class: "vuefinder__upload-actions__separator" }, null, -1)),
            o("div", {
              class: te(["vuefinder__upload-actions__item", i(m) ? "disabled" : ""]),
              onClick: P[15] || (P[15] = (j) => i(m) ? null : (i(L)(!1), E.value = !1))
            }, y(i(t)("Clear all")), 3),
            o("div", {
              class: te(["vuefinder__upload-actions__item", i(m) ? "disabled" : ""]),
              onClick: P[16] || (P[16] = (j) => i(m) ? null : (i(L)(!0), E.value = !1))
            }, y(i(t)("Clear only successful")), 3)
          ])) : K("", !0)
        ], 512)
      ]),
      default: ue(() => [
        o("div", null, [
          X(He, {
            icon: i(co),
            title: i(t)("Upload Files")
          }, null, 8, ["icon", "title"]),
          o("div", Yd, [
            o("div", Xd, [
              o("div", Qd, y(i(t)("Target Directory")), 1),
              o("div", Jd, [
                o("div", {
                  class: "vuefinder__upload-modal__target-display",
                  onClick: P[0] || (P[0] = (j) => r.value = !r.value)
                }, [
                  o("div", Zd, [
                    o("span", ec, y(l().storage) + "://", 1),
                    l().path ? (u(), p("span", tc, y(l().path), 1)) : K("", !0)
                  ]),
                  o("span", nc, y(i(t)("Browse")), 1)
                ])
              ]),
              o("div", {
                class: te([
                  "vuefinder__upload-modal__tree-selector",
                  r.value ? "vuefinder__upload-modal__tree-selector--expanded" : "vuefinder__upload-modal__tree-selector--collapsed"
                ])
              }, [
                X(kt, {
                  modelValue: d.value,
                  "onUpdate:modelValue": [
                    P[1] || (P[1] = (j) => d.value = j),
                    c
                  ],
                  "show-pinned-folders": !0,
                  onSelectAndClose: v
                }, null, 8, ["modelValue"])
              ], 2)
            ]),
            o("div", oc, y(i(t)("You can drag & drop files anywhere while this modal is open.")), 1),
            o("div", {
              ref_key: "container",
              ref: w,
              class: "hidden"
            }, null, 512),
            o("div", sc, [
              (u(!0), p(_e, null, ge(i(b), (j) => (u(), p("div", {
                key: j.id,
                class: "vuefinder__upload-modal__file-entry"
              }, [
                o("span", {
                  class: te(["vuefinder__upload-modal__file-icon", i(Y)(j)])
                }, [
                  o("span", {
                    class: "vuefinder__upload-modal__file-icon-text",
                    textContent: y(i(Q)(j))
                  }, null, 8, ic)
                ], 2),
                o("div", ac, [
                  T.value === j.id ? (u(), p("div", lc, [
                    he(o("input", {
                      ref_for: !0,
                      ref_key: "renameInputRef",
                      ref: N,
                      "onUpdate:modelValue": P[2] || (P[2] = (de) => D.value = de),
                      type: "text",
                      class: "vuefinder__upload-modal__file-rename-input",
                      placeholder: i(t)("Rename"),
                      onKeyup: [
                        je((de) => x(j), ["enter"]),
                        je(z, ["esc"])
                      ]
                    }, null, 40, rc), [
                      [Ke, D.value]
                    ]),
                    o("button", {
                      type: "button",
                      class: "vuefinder__upload-modal__file-rename-btn vuefinder__upload-modal__file-rename-btn--save",
                      title: i(t)("Save"),
                      onClick: (de) => x(j)
                    }, [...P[17] || (P[17] = [
                      o("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        "stroke-width": "2",
                        stroke: "currentColor",
                        class: "vuefinder__upload-modal__file-rename-icon"
                      }, [
                        o("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          d: "M4.5 12.75l6 6 9-13.5"
                        })
                      ], -1)
                    ])], 8, dc),
                    o("button", {
                      type: "button",
                      class: "vuefinder__upload-modal__file-rename-btn",
                      title: i(t)("Cancel"),
                      onClick: z
                    }, [...P[18] || (P[18] = [
                      o("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        "stroke-width": "2",
                        stroke: "currentColor",
                        class: "vuefinder__upload-modal__file-rename-icon"
                      }, [
                        o("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          d: "M6 18L18 6M6 6l12 12"
                        })
                      ], -1)
                    ])], 8, cc)
                  ])) : (u(), p(_e, { key: 1 }, [
                    o("div", uc, y(i(Yt)(j.name, 40)) + " (" + y(j.size) + ") ", 1),
                    o("div", vc, y(i(Yt)(j.name, 16)) + " (" + y(j.size) + ") ", 1),
                    o("div", {
                      class: te(["vuefinder__upload-modal__file-status", i(Y)(j)])
                    }, [
                      ye(y(j.statusName) + " ", 1),
                      j.status === i(f).QUEUE_ENTRY_STATUS.UPLOADING ? (u(), p("b", fc, y(j.percent), 1)) : K("", !0)
                    ], 2)
                  ], 64))
                ]),
                T.value !== j.id ? (u(), p("button", {
                  key: 0,
                  type: "button",
                  class: te([
                    "vuefinder__upload-modal__file-rename-action",
                    i(m) || j.status === i(f).QUEUE_ENTRY_STATUS.UPLOADING ? "disabled" : ""
                  ]),
                  title: i(t)("Rename"),
                  disabled: i(m) || j.status === i(f).QUEUE_ENTRY_STATUS.UPLOADING,
                  onClick: (de) => ce(j)
                }, [...P[19] || (P[19] = [
                  o("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    "stroke-width": "1.5",
                    stroke: "currentColor",
                    class: "vuefinder__upload-modal__file-rename-icon"
                  }, [
                    o("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      d: "M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125"
                    })
                  ], -1)
                ])], 10, _c)) : K("", !0),
                T.value !== j.id ? (u(), p("button", {
                  key: 1,
                  type: "button",
                  class: te(["vuefinder__upload-modal__file-remove", i(m) ? "disabled" : ""]),
                  title: i(t)("Delete"),
                  disabled: i(m),
                  onClick: (de) => i(S)(j)
                }, [...P[20] || (P[20] = [
                  o("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    "stroke-width": "1.5",
                    stroke: "currentColor",
                    class: "vuefinder__upload-modal__file-remove-icon"
                  }, [
                    o("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      d: "M6 18L18 6M6 6l12 12"
                    })
                  ], -1)
                ])], 10, pc)) : K("", !0)
              ]))), 128)),
              i(b).length ? K("", !0) : (u(), p("div", mc, y(i(t)("No files selected!")), 1))
            ]),
            i($).length ? (u(), Z(Gt, {
              key: 0,
              error: "",
              onHidden: P[3] || (P[3] = (j) => $.value = "")
            }, {
              default: ue(() => [
                ye(y(i($)), 1)
              ]),
              _: 1
            })) : K("", !0)
          ])
        ]),
        o("input", {
          ref_key: "internalFileInput",
          ref: h,
          type: "file",
          multiple: "",
          class: "hidden"
        }, null, 512),
        o("input", {
          ref_key: "internalFolderInput",
          ref: _,
          type: "file",
          multiple: "",
          webkitdirectory: "",
          class: "hidden"
        }, null, 512)
      ]),
      _: 1
    }, 8, ["show-drag-overlay", "drag-overlay-text"]));
  }
}), kc = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "stroke-width": "1.5",
  class: "h-6 w-6 md:h-8 md:w-8 m-auto",
  viewBox: "0 0 24 24"
};
function $c(s, e) {
  return u(), p("svg", kc, [...e[0] || (e[0] = [
    o("path", { d: "m20.25 7.5-.625 10.632a2.25 2.25 0 0 1-2.247 2.118H6.622a2.25 2.25 0 0 1-2.247-2.118L3.75 7.5m6 4.125 2.25 2.25m0 0 2.25 2.25M12 13.875l2.25-2.25M12 13.875l-2.25 2.25M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125" }, null, -1)
  ])]);
}
const uo = { render: $c }, xc = { class: "vuefinder__unarchive-modal__content" }, Sc = { class: "vuefinder__unarchive-modal__items" }, Cc = {
  key: 0,
  class: "vuefinder__unarchive-modal__icon vuefinder__unarchive-modal__icon--dir",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "1"
}, Fc = {
  key: 1,
  class: "vuefinder__unarchive-modal__icon vuefinder__unarchive-modal__icon--file",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "1"
}, Tc = { class: "vuefinder__unarchive-modal__item-name" }, Ec = { class: "vuefinder__unarchive-modal__info" }, Pc = { class: "vuefinder__unarchive-modal__target" }, Dc = { class: "vuefinder__unarchive-modal__target-label" }, Mc = ["title"], Ic = {
  key: 0,
  class: "vuefinder__unarchive-modal__target-selector"
}, fn = /* @__PURE__ */ le({
  __name: "ModalUnarchive",
  setup(s) {
    const e = ae(), t = Be(e), n = e.fs, a = oe(n.path), { t: d } = e.i18n, r = M(e.modal.data.items[0]), l = M([]), c = M(null), v = M(!1), w = R(() => c.value?.path || a.value.path), h = () => {
      v.value = !v.value;
    }, _ = ($) => {
      $ && (c.value = $);
    }, k = ($) => {
      $ && (c.value = $, v.value = !1);
    }, b = () => {
      const $ = c.value?.path;
      e.adapter.unarchive({
        item: r.value.path,
        path: a.value.path,
        // Optional. Sent when the user explicitly picks a different folder.
        ...$ && $ !== a.value.path ? { destination: $ } : {}
      }).then((m) => {
        t.success(d("The file unarchived.")), e.fs.setFiles(m.files), e.modal.close();
      }).catch((m) => {
        t.error(Fe(m, d("Failed to unarchive")));
      });
    };
    return ($, m) => (u(), Z(ze, null, {
      buttons: ue(() => [
        o("button", {
          type: "button",
          class: "vf-btn vf-btn-primary",
          onClick: b
        }, y(i(d)("Unarchive")), 1),
        o("button", {
          type: "button",
          class: "vf-btn vf-btn-secondary",
          onClick: m[1] || (m[1] = (g) => i(e).modal.close())
        }, y(i(d)("Cancel")), 1)
      ]),
      default: ue(() => [
        o("div", null, [
          X(He, {
            icon: i(uo),
            title: i(d)("Unarchive")
          }, null, 8, ["icon", "title"]),
          o("div", xc, [
            o("div", Sc, [
              (u(!0), p(_e, null, ge(l.value, (g) => (u(), p("p", {
                key: g.path,
                class: "vuefinder__unarchive-modal__item"
              }, [
                g.type === "dir" ? (u(), p("svg", Cc, [...m[2] || (m[2] = [
                  o("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
                  }, null, -1)
                ])])) : (u(), p("svg", Fc, [...m[3] || (m[3] = [
                  o("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                  }, null, -1)
                ])])),
                o("span", Tc, y(g.basename), 1)
              ]))), 128)),
              o("p", Ec, y(i(d)("The archive will be unarchived at")) + " (" + y(w.value) + ") ", 1),
              o("div", Pc, [
                o("div", Dc, y(i(d)("Target folder")), 1),
                o("button", {
                  type: "button",
                  class: te(["vuefinder__unarchive-modal__target-btn", { "vuefinder__unarchive-modal__target-btn--open": v.value }]),
                  onClick: h
                }, [
                  X(i(Re), { class: "vuefinder__unarchive-modal__target-icon" }),
                  o("span", {
                    class: "vuefinder__unarchive-modal__target-text",
                    title: w.value
                  }, y(i(Lt)(w.value)), 9, Mc),
                  m[4] || (m[4] = o("svg", {
                    class: "vuefinder__unarchive-modal__target-arrow",
                    viewBox: "0 0 16 16",
                    fill: "currentColor"
                  }, [
                    o("path", { d: "M4.427 7.427l3.396 3.396a.25.25 0 00.354 0l3.396-3.396A.25.25 0 0011.396 7H4.604a.25.25 0 00-.177.427z" })
                  ], -1))
                ], 2),
                v.value ? (u(), p("div", Ic, [
                  X(kt, {
                    modelValue: c.value,
                    "onUpdate:modelValue": [
                      m[0] || (m[0] = (g) => c.value = g),
                      _
                    ],
                    "show-pinned-folders": !0,
                    "current-path": i(a),
                    onSelectAndClose: k
                  }, null, 8, ["modelValue", "current-path"])
                ])) : K("", !0)
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }));
  }
}), Ac = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function Oc(s, e) {
  return u(), p("svg", Ac, [...e[0] || (e[0] = [
    o("path", { d: "m20.25 7.5-.625 10.632a2.25 2.25 0 0 1-2.247 2.118H6.622a2.25 2.25 0 0 1-2.247-2.118L3.75 7.5M10 11.25h4M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125" }, null, -1)
  ])]);
}
const vo = { render: Oc }, Lc = { class: "vuefinder__archive-modal__content" }, Rc = { class: "vuefinder__archive-modal__form" }, Bc = { class: "vuefinder__archive-modal__files vf-scrollbar" }, zc = {
  key: 0,
  class: "vuefinder__archive-modal__icon vuefinder__archive-modal__icon--dir",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "1"
}, Vc = {
  key: 1,
  class: "vuefinder__archive-modal__icon",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "1"
}, Uc = { class: "vuefinder__archive-modal__file-name" }, Nc = ["placeholder"], Hc = { class: "vuefinder__archive-modal__target" }, jc = { class: "vuefinder__archive-modal__target-label" }, Kc = ["title"], qc = {
  key: 0,
  class: "vuefinder__archive-modal__target-selector"
}, _n = /* @__PURE__ */ le({
  __name: "ModalArchive",
  setup(s) {
    const e = ae(), t = Be(e), { t: n } = e.i18n, a = e.fs, d = oe(a.path), r = M(""), l = M(e.modal.data.items), c = M(null), v = M(!1), w = R(() => c.value?.path || d.value.path), h = () => {
      v.value = !v.value;
    }, _ = ($) => {
      $ && (c.value = $);
    }, k = ($) => {
      $ && (c.value = $, v.value = !1);
    }, b = () => {
      if (l.value.length) {
        const $ = c.value?.path;
        e.adapter.archive({
          path: d.value.path,
          items: l.value.map(({ path: m, type: g }) => ({
            path: m,
            type: g
          })),
          name: r.value,
          // Optional. Sent when the user explicitly picks a different folder.
          ...$ && $ !== d.value.path ? { destination: $ } : {}
        }).then((m) => {
          t.success(n("The file(s) archived.")), e.fs.setFiles(m.files), e.modal.close();
        }).catch((m) => {
          t.error(Fe(m, n("Failed to archive files")));
        });
      }
    };
    return ($, m) => (u(), Z(ze, null, {
      buttons: ue(() => [
        o("button", {
          type: "button",
          class: "vf-btn vf-btn-primary",
          onClick: b
        }, y(i(n)("Archive")), 1),
        o("button", {
          type: "button",
          class: "vf-btn vf-btn-secondary",
          onClick: m[2] || (m[2] = (g) => i(e).modal.close())
        }, y(i(n)("Cancel")), 1)
      ]),
      default: ue(() => [
        o("div", null, [
          X(He, {
            icon: i(vo),
            title: i(n)("Archive the files")
          }, null, 8, ["icon", "title"]),
          o("div", Lc, [
            o("div", Rc, [
              o("div", Bc, [
                (u(!0), p(_e, null, ge(l.value, (g) => (u(), p("p", {
                  key: g.path,
                  class: "vuefinder__archive-modal__file"
                }, [
                  g.type === "dir" ? (u(), p("svg", zc, [...m[3] || (m[3] = [
                    o("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      d: "M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
                    }, null, -1)
                  ])])) : (u(), p("svg", Vc, [...m[4] || (m[4] = [
                    o("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      d: "M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                    }, null, -1)
                  ])])),
                  o("span", Uc, y(g.basename), 1)
                ]))), 128))
              ]),
              he(o("input", {
                "onUpdate:modelValue": m[0] || (m[0] = (g) => r.value = g),
                class: "vuefinder__archive-modal__input",
                placeholder: i(n)("Archive name. (.zip file will be created)"),
                type: "text",
                onKeyup: je(b, ["enter"])
              }, null, 40, Nc), [
                [Ke, r.value]
              ]),
              o("div", Hc, [
                o("div", jc, y(i(n)("Target folder")), 1),
                o("button", {
                  type: "button",
                  class: te(["vuefinder__archive-modal__target-btn", { "vuefinder__archive-modal__target-btn--open": v.value }]),
                  onClick: h
                }, [
                  X(i(Re), { class: "vuefinder__archive-modal__target-icon" }),
                  o("span", {
                    class: "vuefinder__archive-modal__target-text",
                    title: w.value
                  }, y(i(Lt)(w.value)), 9, Kc),
                  m[5] || (m[5] = o("svg", {
                    class: "vuefinder__archive-modal__target-arrow",
                    viewBox: "0 0 16 16",
                    fill: "currentColor"
                  }, [
                    o("path", { d: "M4.427 7.427l3.396 3.396a.25.25 0 00.354 0l3.396-3.396A.25.25 0 0011.396 7H4.604a.25.25 0 00-.177.427z" })
                  ], -1))
                ], 2),
                v.value ? (u(), p("div", qc, [
                  X(kt, {
                    modelValue: c.value,
                    "onUpdate:modelValue": [
                      m[1] || (m[1] = (g) => c.value = g),
                      _
                    ],
                    "show-pinned-folders": !0,
                    "current-path": i(d),
                    onSelectAndClose: k
                  }, null, 8, ["modelValue", "current-path"])
                ])) : K("", !0)
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }));
  }
}), Wc = { class: "vuefinder__about-modal__content" }, Gc = { class: "vuefinder__about-modal__main" }, Yc = { class: "vuefinder__about-modal__shortcuts" }, Xc = { class: "vuefinder__about-modal__shortcut" }, Qc = {
  key: 0,
  class: "vuefinder__about-modal__shortcut"
}, Jc = {
  key: 1,
  class: "vuefinder__about-modal__shortcut"
}, Zc = { class: "vuefinder__about-modal__shortcut" }, eu = { class: "vuefinder__about-modal__shortcut" }, tu = {
  key: 2,
  class: "vuefinder__about-modal__shortcut"
}, nu = {
  key: 3,
  class: "vuefinder__about-modal__shortcut"
}, ou = {
  key: 4,
  class: "vuefinder__about-modal__shortcut"
}, su = {
  key: 5,
  class: "vuefinder__about-modal__shortcut"
}, iu = { class: "vuefinder__about-modal__shortcut" }, au = { class: "vuefinder__about-modal__shortcut" }, lu = {
  key: 6,
  class: "vuefinder__about-modal__shortcut"
}, ru = {
  key: 7,
  class: "vuefinder__about-modal__shortcut"
}, du = /* @__PURE__ */ le({
  __name: "ModalShortcuts",
  setup(s) {
    const e = ae(), { enabled: t } = Ve(), { t: n } = e.i18n;
    return (a, d) => (u(), Z(ze, null, {
      buttons: ue(() => [
        o("button", {
          type: "button",
          class: "vf-btn vf-btn-secondary",
          onClick: d[0] || (d[0] = (r) => i(e).modal.close())
        }, y(i(n)("Close")), 1)
      ]),
      default: ue(() => [
        o("div", Wc, [
          X(He, {
            icon: i(tn),
            title: i(n)("Shortcuts")
          }, null, 8, ["icon", "title"]),
          o("div", Gc, [
            o("div", Yc, [
              o("div", Xc, [
                o("div", null, y(i(n)("Refresh")), 1),
                d[1] || (d[1] = o("div", null, [
                  o("kbd", null, "⌘"),
                  ye(" + "),
                  o("kbd", null, "R")
                ], -1))
              ]),
              i(t)("rename") ? (u(), p("div", Qc, [
                o("div", null, y(i(n)("Rename")), 1),
                d[2] || (d[2] = o("div", null, [
                  o("kbd", null, "⌘"),
                  ye(" + "),
                  o("kbd", null, "Shift"),
                  ye(" + "),
                  o("kbd", null, "R")
                ], -1))
              ])) : K("", !0),
              i(t)("delete") ? (u(), p("div", Jc, [
                o("div", null, y(i(n)("Delete")), 1),
                d[3] || (d[3] = o("kbd", null, "Del", -1))
              ])) : K("", !0),
              o("div", Zc, [
                o("div", null, y(i(n)("Escape")), 1),
                d[4] || (d[4] = o("kbd", null, "Esc", -1))
              ]),
              o("div", eu, [
                o("div", null, y(i(n)("Select All")), 1),
                d[5] || (d[5] = o("div", null, [
                  o("kbd", null, "⌘"),
                  ye(" + "),
                  o("kbd", null, "A")
                ], -1))
              ]),
              i(t)("copy") ? (u(), p("div", tu, [
                o("div", null, y(i(n)("Cut")), 1),
                d[6] || (d[6] = o("div", null, [
                  o("kbd", null, "⌘"),
                  ye(" + "),
                  o("kbd", null, "X")
                ], -1))
              ])) : K("", !0),
              i(t)("copy") ? (u(), p("div", nu, [
                o("div", null, y(i(n)("Copy")), 1),
                d[7] || (d[7] = o("div", null, [
                  o("kbd", null, "⌘"),
                  ye(" + "),
                  o("kbd", null, "C")
                ], -1))
              ])) : K("", !0),
              i(t)("copy") ? (u(), p("div", ou, [
                o("div", null, y(i(n)("Paste")), 1),
                d[8] || (d[8] = o("div", null, [
                  o("kbd", null, "⌘"),
                  ye(" + "),
                  o("kbd", null, "V")
                ], -1))
              ])) : K("", !0),
              i(t)("search") ? (u(), p("div", su, [
                o("div", null, y(i(n)("Search")), 1),
                d[9] || (d[9] = o("div", null, [
                  o("kbd", null, "⌘"),
                  ye(" + "),
                  o("kbd", null, "F")
                ], -1))
              ])) : K("", !0),
              o("div", iu, [
                o("div", null, y(i(n)("Toggle Sidebar")), 1),
                d[10] || (d[10] = o("div", null, [
                  o("kbd", null, "⌘"),
                  ye(" + "),
                  o("kbd", null, "E")
                ], -1))
              ]),
              o("div", au, [
                o("div", null, y(i(n)("Open Settings")), 1),
                d[11] || (d[11] = o("div", null, [
                  o("kbd", null, "⌘"),
                  ye(" + "),
                  o("kbd", null, "S")
                ], -1))
              ]),
              i(t)("fullscreen") ? (u(), p("div", lu, [
                o("div", null, y(i(n)("Toggle Full Screen")), 1),
                d[12] || (d[12] = o("div", null, [
                  o("kbd", null, "⌘"),
                  ye(" + "),
                  o("kbd", null, "Enter")
                ], -1))
              ])) : K("", !0),
              i(t)("preview") ? (u(), p("div", ru, [
                o("div", null, y(i(n)("Preview")), 1),
                d[13] || (d[13] = o("kbd", null, "Space", -1))
              ])) : K("", !0)
            ])
          ])
        ])
      ]),
      _: 1
    }));
  }
}), cu = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  class: "h-6 w-6 p-0.5 rounded",
  viewBox: "0 0 20 20"
};
function uu(s, e) {
  return u(), p("svg", cu, [...e[0] || (e[0] = [
    o("path", {
      "fill-rule": "evenodd",
      d: "M5.293 9.707a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414L11 7.414V15a1 1 0 1 1-2 0V7.414L6.707 9.707a1 1 0 0 1-1.414 0",
      class: "pointer-events-none",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const fo = { render: uu }, pn = "vuefinder:recent-paths", _o = 4, mn = typeof window < "u" && typeof window.localStorage < "u";
function hn() {
  if (!mn) return [];
  try {
    const s = window.localStorage.getItem(pn);
    if (!s) return [];
    const e = JSON.parse(s);
    return Array.isArray(e) ? e.filter((t) => typeof t == "string").slice(0, _o) : [];
  } catch {
    return [];
  }
}
function vu(s) {
  if (!(!mn || !s))
    try {
      const e = hn().filter((t) => t !== s);
      e.unshift(s), window.localStorage.setItem(pn, JSON.stringify(e.slice(0, _o)));
    } catch {
    }
}
function fu(s) {
  if (!(!mn || !s))
    try {
      const e = hn().filter((t) => t !== s);
      window.localStorage.setItem(pn, JSON.stringify(e));
    } catch {
    }
}
const _u = { class: "vuefinder__go-to-folder-modal" }, pu = { class: "vuefinder__go-to-folder-modal__content" }, mu = ["placeholder", "onKeydown"], hu = {
  key: 0,
  class: "vuefinder__go-to-folder-modal__error"
}, gu = ["onMouseenter", "onClick", "onDblclick"], yu = { class: "vuefinder__go-to-folder-modal__suggestion-label" }, wu = {
  key: 0,
  class: "vuefinder__go-to-folder-modal__suggestion-tag"
}, bu = ["title", "onClick"], ku = ["title", "onClick"], $u = {
  key: 2,
  class: "vuefinder__go-to-folder-modal__empty"
}, xu = {
  key: 3,
  class: "vuefinder__go-to-folder-modal__loading"
}, Su = ["disabled"], Cu = /* @__PURE__ */ le({
  name: "ModalGoToFolder",
  __name: "ModalGoToFolder",
  setup(s) {
    const e = ae(), { t } = e.i18n, n = e.fs, a = oe(n.storages), d = M(""), r = M([]), l = M(0), c = M(!1), v = M(!1), w = M(""), h = M(null), _ = M(null);
    let k = 0;
    const b = R(() => a.value ?? []), $ = (z) => {
      const x = z ?? "", U = x.indexOf("://");
      if (U === -1)
        return { storage: null, parent: "", filter: x.trim(), hasProtocol: !1 };
      const E = x.slice(0, U), V = x.slice(U + 3), I = V.lastIndexOf("/"), O = I === -1 ? `${E}://` : `${E}://${V.slice(0, I).replace(/^\/+/, "")}`, q = I === -1 ? V : V.slice(I + 1);
      return { storage: E, parent: O, filter: q, hasProtocol: !0 };
    }, m = (z) => {
      const x = z.toLowerCase();
      r.value = b.value.filter((U) => !x || U.toLowerCase().includes(x)).map((U) => ({
        path: `${U}://`,
        label: `${U}://`,
        kind: "storage"
      })), l.value = r.value.length ? 0 : -1, w.value = "";
    }, g = () => {
      const z = hn();
      r.value = z.map((x) => ({
        path: x,
        label: x,
        kind: "recent"
      })), l.value = r.value.length ? 0 : -1, w.value = "";
    }, f = async (z, x) => {
      const U = ++k;
      c.value = !0, w.value = "";
      try {
        const E = await e.adapter.list(z);
        if (U !== k) return;
        const V = x.toLowerCase(), I = (E?.files ?? []).filter(
          (O) => O.type === "dir" && (!V || O.basename.toLowerCase().startsWith(V))
        );
        r.value = I.map(
          (O) => ({
            path: O.path,
            label: O.basename,
            kind: "dir"
          })
        ), l.value = r.value.length ? 0 : -1;
      } catch (E) {
        if (U !== k) return;
        r.value = [], l.value = -1, w.value = Fe(E, t("Folder not found"));
      } finally {
        U === k && (c.value = !1);
      }
    };
    let F = null;
    const C = (z) => {
      F && clearTimeout(F), F = setTimeout(() => A(z), 150);
    }, A = (z) => {
      const x = z.trim();
      if (!x) {
        k++, c.value = !1, g();
        return;
      }
      const { hasProtocol: U, parent: E, filter: V } = $(x);
      if (!U) {
        k++, c.value = !1, m(x);
        return;
      }
      f(E, V);
    };
    pe(d, (z) => C(z)), we(() => {
      g(), De(() => h.value?.focus());
    });
    const S = () => {
      De(() => {
        const z = _.value;
        if (!z) return;
        const x = z.children[l.value];
        if (!x) return;
        const U = z.scrollTop, E = U + z.clientHeight, V = x.offsetTop, I = V + x.offsetHeight;
        V < U ? z.scrollTop = V : I > E && (z.scrollTop = I - z.clientHeight);
      });
    }, L = (z) => {
      if (!r.value.length) return;
      const x = r.value.length;
      l.value = ((l.value + z) % x + x) % x, S();
    }, H = (z) => {
      d.value = z.kind === "dir" ? `${z.path}/` : z.path, De(() => {
        h.value?.setSelectionRange(d.value.length, d.value.length);
      });
    }, Y = (z) => {
      if (!z.includes("://"))
        return {
          ok: !1,
          reason: t("Invalid path format. Path must be in format: storage://path/to/folder")
        };
      const x = z.slice(0, z.indexOf("://"));
      return b.value.includes(x) ? { ok: !0 } : { ok: !1, reason: t('Invalid storage. Storage "%s" is not available.', x) };
    }, Q = async (z) => {
      if (v.value) return;
      const x = z.trim();
      if (!x) return;
      const U = Y(x);
      if (!U.ok) {
        w.value = U.reason ?? "";
        return;
      }
      v.value = !0;
      try {
        if (await e.adapter.open(x) === void 0)
          return;
        vu(x), e.modal.close();
      } catch (E) {
        w.value = Fe(E, t("Failed to navigate to folder")), n.setLoading(!1);
      } finally {
        v.value = !1;
      }
    }, B = () => {
      const z = r.value[l.value];
      Q(z ? z.path : d.value);
    }, W = (z) => {
      if (!r.value.length) return;
      z.preventDefault();
      const x = r.value[l.value];
      x && H(x);
    }, T = (z) => {
      if (z.kind === "dir") {
        H(z);
        return;
      }
      Q(z.path);
    }, D = (z) => {
      Q(z.path);
    }, N = (z, x) => {
      z.stopPropagation(), z.preventDefault(), fu(x), g();
    }, J = (z, x) => {
      z.stopPropagation(), z.preventDefault(), d.value = x, De(() => {
        h.value?.focus(), h.value?.setSelectionRange(d.value.length, d.value.length);
      });
    }, ce = R(() => {
      const z = b.value[0];
      return z ? `${z}://path/to/folder` : "storage://path/to/folder";
    });
    return (z, x) => (u(), Z(ze, null, {
      buttons: ue(() => [
        o("button", {
          type: "button",
          class: "vf-btn vf-btn-primary",
          disabled: v.value,
          onClick: B
        }, y(i(t)("Go")), 9, Su),
        o("button", {
          type: "button",
          class: "vf-btn vf-btn-secondary",
          onClick: x[3] || (x[3] = (U) => i(e).modal.close())
        }, y(i(t)("Cancel")), 1)
      ]),
      default: ue(() => [
        o("div", _u, [
          X(He, {
            icon: i(At),
            title: i(t)("Go to Folder")
          }, null, 8, ["icon", "title"]),
          o("div", pu, [
            he(o("input", {
              ref_key: "inputRef",
              ref: h,
              "onUpdate:modelValue": x[0] || (x[0] = (U) => d.value = U),
              class: "vuefinder__go-to-folder-modal__input",
              type: "text",
              autocomplete: "off",
              spellcheck: "false",
              placeholder: ce.value,
              onKeydown: [
                x[1] || (x[1] = je(ve((U) => L(1), ["prevent"]), ["down"])),
                x[2] || (x[2] = je(ve((U) => L(-1), ["prevent"]), ["up"])),
                je(ve(B, ["prevent"]), ["enter"]),
                je(W, ["tab"])
              ]
            }, null, 40, mu), [
              [Ke, d.value]
            ]),
            w.value ? (u(), p("div", hu, y(w.value), 1)) : K("", !0),
            r.value.length ? (u(), p("div", {
              key: 1,
              ref_key: "suggestionListRef",
              ref: _,
              class: "vuefinder__go-to-folder-modal__suggestions"
            }, [
              (u(!0), p(_e, null, ge(r.value, (U, E) => (u(), p("div", {
                key: `${U.kind}:${U.path}`,
                class: te(["vuefinder__go-to-folder-modal__suggestion", {
                  "vuefinder__go-to-folder-modal__suggestion--active": E === l.value
                }]),
                onMouseenter: (V) => l.value = E,
                onClick: (V) => T(U),
                onDblclick: (V) => D(U)
              }, [
                X(i(Re), { class: "vuefinder__go-to-folder-modal__suggestion-icon" }),
                o("span", yu, y(U.label), 1),
                U.kind === "recent" ? (u(), p("span", wu, y(i(t)("Recent")), 1)) : K("", !0),
                U.kind === "recent" ? (u(), p("button", {
                  key: 1,
                  type: "button",
                  class: "vuefinder__go-to-folder-modal__suggestion-fill",
                  title: i(t)("Edit this path"),
                  onClick: (V) => J(V, U.path)
                }, [
                  X(i(fo), { class: "vuefinder__go-to-folder-modal__suggestion-fill-icon" })
                ], 8, bu)) : K("", !0),
                U.kind === "recent" ? (u(), p("button", {
                  key: 2,
                  type: "button",
                  class: "vuefinder__go-to-folder-modal__suggestion-remove",
                  title: i(t)("Remove from recent"),
                  onClick: (V) => N(V, U.path)
                }, " × ", 8, ku)) : K("", !0)
              ], 42, gu))), 128))
            ], 512)) : c.value ? K("", !0) : (u(), p("div", $u, [
              d.value.trim() ? (u(), p(_e, { key: 1 }, [
                ye(y(i(t)("No matching folders.")), 1)
              ], 64)) : (u(), p(_e, { key: 0 }, [
                ye(y(i(t)("No recent folders yet.")), 1)
              ], 64))
            ])),
            c.value ? (u(), p("div", xu, y(i(t)("Loading…")), 1)) : K("", !0)
          ])
        ])
      ]),
      _: 1
    }));
  }
}), Fu = { class: "vuefinder__menubar__container" }, Tu = ["onClick", "onMouseenter"], Eu = { class: "vuefinder__menubar__label" }, Pu = ["onMouseenter"], Du = ["onClick"], Mu = {
  key: 0,
  class: "vuefinder__menubar__dropdown__label"
}, Iu = {
  key: 1,
  class: "vuefinder__menubar__dropdown__checkmark"
}, Au = {
  key: 2,
  class: "vuefinder__menubar__dropdown__chevron",
  viewBox: "0 0 16 16",
  fill: "currentColor",
  "aria-hidden": "true"
}, Ou = {
  key: 3,
  class: "vuefinder__menubar__dropdown__submenu"
}, Lu = ["onClick"], Ru = { class: "vuefinder__menubar__dropdown__label" }, Bu = /* @__PURE__ */ le({
  __name: "MenuBar",
  setup(s) {
    const e = ae(), { enabled: t } = Ve(), { t: n } = e?.i18n || { t: (f) => f }, a = e?.fs, d = e?.config, r = oe(d.state), l = oe(a.selectedItems), c = oe(a?.storages || []), v = M(null), w = M(!1), h = R(() => window.opener !== null || window.name !== "" || window.history.length <= 1), _ = R(() => [
      {
        id: "file",
        label: n("File"),
        items: [
          {
            id: "new-folder",
            label: n("New Folder"),
            action: () => e?.modal?.open(un, { items: l.value }),
            hidden: () => !t("newfolder")
          },
          {
            id: "new-file",
            label: n("New File"),
            action: () => e?.modal?.open(ro, { items: l.value }),
            hidden: () => !t("newfile")
          },
          {
            type: "separator",
            hidden: () => !t("newfolder") && !t("newfile") || !t("upload")
          },
          {
            id: "upload",
            label: n("Upload"),
            action: () => e?.modal?.open(vn, { items: l.value }),
            hidden: () => !t("upload")
          },
          { type: "separator", hidden: () => !t("search") },
          {
            id: "search",
            label: n("Search"),
            action: () => e.modal.open(cn),
            hidden: () => !t("search")
          },
          { type: "separator", hidden: () => !t("archive") && !t("unarchive") },
          {
            id: "archive",
            label: n("Archive"),
            action: () => {
              l.value.length > 0 && e?.modal?.open(_n, { items: l.value });
            },
            enabled: () => l.value.length > 0,
            hidden: () => !t("archive")
          },
          {
            id: "unarchive",
            label: n("Unarchive"),
            action: () => {
              l.value.length === 1 && l.value[0]?.mime_type === "application/zip" && e?.modal?.open(fn, { items: l.value });
            },
            enabled: () => l.value.length === 1 && l.value[0]?.mime_type === "application/zip",
            hidden: () => !t("unarchive")
          },
          { type: "separator", hidden: () => !t("preview") },
          {
            id: "preview",
            label: n("Preview"),
            action: () => {
              l.value.length === 1 && l.value[0]?.type !== "dir" && e?.modal?.open(Xe, {
                storage: a?.path?.get()?.storage,
                item: l.value[0]
              });
            },
            enabled: () => l.value.length === 1 && l.value[0]?.type !== "dir",
            hidden: () => !t("preview")
          },
          {
            id: "open-as",
            label: n("Preview as"),
            items: [
              {
                id: "open-as-text",
                label: n("Text"),
                action: () => e?.modal?.open(Xe, {
                  storage: a?.path?.get()?.storage,
                  item: l.value[0],
                  forceType: "text"
                }),
                enabled: () => l.value.length === 1 && l.value[0]?.type !== "dir"
              },
              {
                id: "open-as-image",
                label: n("Image"),
                action: () => e?.modal?.open(Xe, {
                  storage: a?.path?.get()?.storage,
                  item: l.value[0],
                  forceType: "image"
                }),
                enabled: () => l.value.length === 1 && l.value[0]?.type !== "dir"
              }
            ],
            enabled: () => l.value.length === 1 && l.value[0]?.type !== "dir",
            hidden: () => !t("preview")
          },
          // Only show exit option if we can actually close the window
          ...h.value ? [
            { type: "separator" },
            {
              id: "exit",
              label: n("Exit"),
              action: () => {
                try {
                  window.close();
                } catch {
                }
              },
              enabled: () => !0
            }
          ] : []
        ]
      },
      {
        id: "edit",
        label: n("Edit"),
        items: [
          // Only show Select All and Deselect All in multiple selection mode
          ...e?.selectionMode === "multiple" ? [
            {
              id: "select-all",
              label: n("Select All"),
              action: () => a?.selectAll(e?.selectionMode || "multiple", e),
              enabled: () => !0
            },
            {
              id: "deselect",
              label: n("Deselect All"),
              action: () => a?.clearSelection(),
              enabled: () => l.value.length > 0
            },
            { type: "separator" }
          ] : [],
          ...t("copy") ? [
            {
              id: "cut",
              label: n("Cut"),
              action: () => {
                l.value.length > 0 && a?.setClipboard(
                  "cut",
                  new Set(l.value.map((f) => ke(f)))
                );
              },
              enabled: () => l.value.length > 0
            },
            {
              id: "copy",
              label: n("Copy"),
              action: () => {
                l.value.length > 0 && a?.setClipboard(
                  "copy",
                  new Set(l.value.map((f) => ke(f)))
                );
              },
              enabled: () => l.value.length > 0
            },
            {
              id: "paste",
              label: n("Paste"),
              action: () => {
                const f = a?.getClipboard();
                f?.items?.size > 0 && e?.modal?.open(f.type === "cut" ? at : rn, {
                  items: { from: Array.from(f.items), to: a?.path?.get() }
                });
              },
              enabled: () => a?.getClipboard()?.items?.size > 0
            }
          ] : [],
          ...t("move") ? [
            {
              id: "move",
              label: n("Move files"),
              action: () => {
                if (l.value.length > 0) {
                  const f = e?.fs, F = {
                    storage: f?.path?.get()?.storage || "",
                    path: f?.path?.get()?.path || "",
                    type: "dir"
                  };
                  e?.modal?.open(at, { items: { from: l.value, to: F } });
                }
              },
              enabled: () => l.value.length > 0
            },
            { type: "separator" }
          ] : [],
          {
            id: "copy-path",
            label: n("Copy Path"),
            action: async () => {
              if (l.value.length === 1) {
                const f = l.value[0];
                await wt(f.path);
              } else {
                const f = a?.path?.get();
                f?.path && await wt(f.path);
              }
            },
            enabled: () => !0
            // Her zaman aktif
          },
          {
            id: "copy-download-url",
            label: n("Copy Download URL"),
            action: async () => {
              if (l.value.length === 1) {
                const f = l.value[0];
                a?.path?.get()?.storage;
                const F = e?.adapter?.getDownloadUrl({ path: f.path });
                F && await Rr(F);
              }
            },
            enabled: () => l.value.length === 1 && l.value[0]?.type !== "dir"
          },
          { type: "separator", hidden: () => !t("rename") && !t("delete") },
          {
            id: "rename",
            label: n("Rename"),
            action: () => {
              l.value.length === 1 && e?.modal?.open(Dt, { items: l.value });
            },
            enabled: () => l.value.length === 1,
            hidden: () => !t("rename")
          },
          {
            id: "delete",
            label: n("Delete"),
            action: () => {
              l.value.length > 0 && e?.modal?.open(Pt, { items: l.value });
            },
            enabled: () => l.value.length > 0,
            hidden: () => !t("delete")
          }
        ]
      },
      {
        id: "view",
        label: n("View"),
        items: [
          {
            id: "refresh",
            label: n("Refresh"),
            action: () => {
              e.adapter.invalidateListQuery(a.path.get().path), e.adapter.open(a.path.get().path);
            },
            enabled: () => !0
          },
          { type: "separator" },
          {
            id: "grid-view",
            label: n("Grid View"),
            action: () => d?.set("view", "grid"),
            enabled: () => !0,
            checked: () => r.value?.view === "grid"
          },
          {
            id: "list-view",
            label: n("List View"),
            action: () => d?.set("view", "list"),
            enabled: () => !0,
            checked: () => r.value?.view === "list"
          },
          { type: "separator" },
          {
            id: "tree-view",
            label: n("Tree View"),
            action: () => d?.toggle("showTreeView"),
            enabled: () => !0,
            checked: () => r.value?.showTreeView
          },
          {
            id: "thumbnails",
            label: n("Show Thumbnails"),
            action: () => d?.toggle("showThumbnails"),
            enabled: () => !0,
            checked: () => r.value?.showThumbnails
          },
          {
            id: "show-hidden-files",
            label: n("Show Hidden Files"),
            action: () => d?.toggle("showHiddenFiles"),
            enabled: () => !0,
            checked: () => r.value?.showHiddenFiles
          },
          { type: "separator", hidden: () => !t("fullscreen") },
          {
            id: "fullscreen",
            label: n("Full Screen"),
            action: () => d?.toggle("fullScreen"),
            enabled: () => t("fullscreen"),
            checked: () => r.value?.fullScreen,
            hidden: () => !t("fullscreen")
          },
          { type: "separator" },
          {
            id: "persist-path",
            label: n("Persist Path"),
            action: () => {
              d?.toggle("persist"), e.emitter.emit("vf-persist-path-saved");
            },
            enabled: () => !0,
            checked: () => r.value?.persist
          },
          {
            id: "metric-units",
            label: n("Metric Units"),
            action: () => {
              d?.toggle("metricUnits"), e.filesize = d?.get("metricUnits") ? Hn : Zt, e.emitter.emit("vf-metric-units-saved");
            },
            enabled: () => !0,
            checked: () => r.value?.metricUnits
          }
        ]
      },
      {
        id: "go",
        label: n("Go"),
        items: [
          ...t("history") ? [
            {
              id: "forward",
              label: n("Forward"),
              action: () => {
                a?.goForward();
                const f = a?.path?.get();
                f?.path && e?.adapter.open(f.path);
              },
              enabled: () => a?.canGoForward?.get() ?? !1
            },
            {
              id: "back",
              label: n("Back"),
              action: () => {
                a?.goBack();
                const f = a?.path?.get();
                f?.path && e?.adapter.open(f.path);
              },
              enabled: () => a?.canGoBack?.get() ?? !1
            }
          ] : [],
          {
            id: "open-containing-folder",
            label: n("Open containing folder"),
            action: () => {
              const f = a?.path?.get();
              if (f?.breadcrumb && f.breadcrumb.length > 1) {
                const C = f.breadcrumb[f.breadcrumb.length - 2]?.path ?? `${f.storage}://`;
                e?.adapter.open(C);
              }
            },
            enabled: () => {
              const f = a?.path?.get();
              return f?.breadcrumb && f.breadcrumb.length > 1;
            }
          },
          { type: "separator" },
          // Dynamic storage list items will be added here
          ...(c.value || []).map((f) => ({
            id: `storage-${f}`,
            label: f,
            action: () => {
              const F = `${f}://`;
              e?.adapter.open(F);
            },
            enabled: () => !0
          })),
          { type: "separator" },
          {
            id: "go-to-folder",
            label: n("Go to Folder"),
            action: () => e?.modal?.open(Cu),
            enabled: () => !0
          }
        ]
      },
      {
        id: "help",
        label: n("Help"),
        items: [
          {
            id: "settings",
            label: n("Settings"),
            action: () => e?.modal?.open(io),
            enabled: () => !0
          },
          {
            id: "shortcuts",
            label: n("Shortcuts"),
            action: () => e?.modal?.open(du),
            enabled: () => !0
          },
          {
            id: "about",
            label: n("About"),
            action: () => e?.modal?.open(Wn),
            enabled: () => !0
          }
        ]
      }
    ]), k = (f) => {
      v.value === f ? $() : (v.value = f, w.value = !0);
    }, b = (f) => {
      w.value && (v.value = f);
    }, $ = () => {
      v.value = null, w.value = !1;
    }, m = (f) => {
      $(), f();
    }, g = (f) => {
      f.target.closest(".vuefinder__menubar") || $();
    };
    return we(() => {
      document.addEventListener("click", g);
    }), Pe(() => {
      document.removeEventListener("click", g);
    }), (f, F) => (u(), p("div", {
      class: "vuefinder__menubar",
      onClick: F[0] || (F[0] = ve(() => {
      }, ["stop"]))
    }, [
      o("div", Fu, [
        (u(!0), p(_e, null, ge(_.value, (C) => (u(), p("div", {
          key: C.id,
          class: te(["vuefinder__menubar__item", { "vuefinder__menubar__item--active": v.value === C.id }]),
          onClick: (A) => k(C.id),
          onMouseenter: (A) => b(C.id)
        }, [
          o("span", Eu, y(C.label), 1),
          v.value === C.id ? (u(), p("div", {
            key: 0,
            class: "vuefinder__menubar__dropdown",
            onMouseenter: (A) => b(C.id)
          }, [
            (u(!0), p(_e, null, ge(C.items, (A) => (u(), p("div", {
              key: A.id || A.type,
              class: te(["vuefinder__menubar__dropdown__item", {
                "vuefinder__menubar__dropdown__item--separator": A.type === "separator",
                "vuefinder__menubar__dropdown__item--disabled": A.enabled && !A.enabled(),
                "vuefinder__menubar__dropdown__item--checked": A.checked && A.checked(),
                "vuefinder__menubar__dropdown__item--hidden": A.hidden && A.hidden(),
                "vuefinder__menubar__dropdown__item--has-children": A.items?.length
              }]),
              onClick: ve((S) => A.type !== "separator" && !A.items?.length && (!A.enabled || A.enabled()) ? m(A.action) : null, ["stop"])
            }, [
              A.type !== "separator" ? (u(), p("span", Mu, y(A.label), 1)) : K("", !0),
              A.checked && A.checked() ? (u(), p("span", Iu, " ✓ ")) : K("", !0),
              A.items?.length ? (u(), p("svg", Au, [...F[1] || (F[1] = [
                o("path", { d: "M6 4l4 4-4 4z" }, null, -1)
              ])])) : K("", !0),
              A.items?.length ? (u(), p("div", Ou, [
                (u(!0), p(_e, null, ge(A.items, (S) => (u(), p("div", {
                  key: S.id,
                  class: te(["vuefinder__menubar__dropdown__item", {
                    "vuefinder__menubar__dropdown__item--disabled": S.enabled && !S.enabled()
                  }]),
                  onClick: ve((L) => !S.enabled || S.enabled() ? m(S.action) : null, ["stop"])
                }, [
                  o("span", Ru, y(S.label), 1)
                ], 10, Lu))), 128))
              ])) : K("", !0)
            ], 10, Du))), 128))
          ], 40, Pu)) : K("", !0)
        ], 42, Tu))), 128))
      ])
    ]));
  }
}), zu = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function Vu(s, e) {
  return u(), p("svg", zu, [...e[0] || (e[0] = [
    o("path", { d: "M3.75 3.75v4.5m0-4.5h4.5m-4.5 0L9 9M3.75 20.25v-4.5m0 4.5h4.5m-4.5 0L9 15M20.25 3.75h-4.5m4.5 0v4.5m0-4.5L15 9m5.25 11.25h-4.5m4.5 0v-4.5m0 4.5L15 15" }, null, -1)
  ])]);
}
const Uu = { render: Vu }, Nu = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "stroke-width": "1.5",
  class: "h-6 w-6 md:h-8 md:w-8 m-auto vf-toolbar-icon",
  viewBox: "0 0 24 24"
};
function Hu(s, e) {
  return u(), p("svg", Nu, [...e[0] || (e[0] = [
    o("path", { d: "M9 9V4.5M9 9H4.5M9 9 3.75 3.75M9 15v4.5M9 15H4.5M9 15l-5.25 5.25M15 9h4.5M15 9V4.5M15 9l5.25-5.25M15 15h4.5M15 15v4.5m0-4.5 5.25 5.25" }, null, -1)
  ])]);
}
const ju = { render: Hu }, Ku = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "stroke-width": "1.5",
  class: "h-6 w-6 md:h-8 md:w-8 m-auto",
  viewBox: "0 0 24 24"
};
function qu(s, e) {
  return u(), p("svg", Ku, [...e[0] || (e[0] = [
    o("path", { d: "M3.75 6A2.25 2.25 0 0 1 6 3.75h2.25A2.25 2.25 0 0 1 10.5 6v2.25a2.25 2.25 0 0 1-2.25 2.25H6a2.25 2.25 0 0 1-2.25-2.25zm0 9.75A2.25 2.25 0 0 1 6 13.5h2.25a2.25 2.25 0 0 1 2.25 2.25V18a2.25 2.25 0 0 1-2.25 2.25H6A2.25 2.25 0 0 1 3.75 18zM13.5 6a2.25 2.25 0 0 1 2.25-2.25H18A2.25 2.25 0 0 1 20.25 6v2.25A2.25 2.25 0 0 1 18 10.5h-2.25a2.25 2.25 0 0 1-2.25-2.25zm0 9.75a2.25 2.25 0 0 1 2.25-2.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-2.25A2.25 2.25 0 0 1 13.5 18z" }, null, -1)
  ])]);
}
const Wu = { render: qu }, Gu = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "stroke-width": "1.5",
  class: "h-6 w-6 md:h-8 md:w-8 m-auto",
  viewBox: "0 0 24 24"
};
function Yu(s, e) {
  return u(), p("svg", Gu, [...e[0] || (e[0] = [
    o("path", { d: "M3.75 12h16.5m-16.5 3.75h16.5M3.75 19.5h16.5M5.625 4.5h12.75a1.875 1.875 0 0 1 0 3.75H5.625a1.875 1.875 0 0 1 0-3.75" }, null, -1)
  ])]);
}
const Xu = { render: Yu }, Qu = {
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
function Ju(s, e) {
  return u(), p("svg", Qu, [...e[0] || (e[0] = [
    o("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M3 4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v2.586a1 1 0 0 1-.293.707l-6.414 6.414a1 1 0 0 0-.293.707V17l-4 4v-6.586a1 1 0 0 0-.293-.707L3.293 7.293A1 1 0 0 1 3 6.586z"
    }, null, -1)
  ])]);
}
const Zu = { render: Ju }, ev = { class: "vuefinder__toolbar" }, tv = { class: "vuefinder__toolbar__actions" }, nv = ["title"], ov = ["title"], sv = ["title"], iv = ["title"], av = ["title"], lv = ["title"], rv = ["title"], dv = { class: "vuefinder__toolbar__controls" }, cv = ["title"], uv = { class: "vuefinder__toolbar__control vuefinder__toolbar__dropdown-container" }, vv = ["title"], fv = { class: "relative" }, _v = {
  key: 0,
  class: "vuefinder__toolbar__filter-indicator"
}, pv = {
  key: 0,
  class: "vuefinder__toolbar__dropdown"
}, mv = { class: "vuefinder__toolbar__dropdown-content" }, hv = { class: "vuefinder__toolbar__dropdown-section" }, gv = { class: "vuefinder__toolbar__dropdown-label" }, yv = { class: "vuefinder__toolbar__dropdown-row" }, wv = { value: "name" }, bv = { value: "size" }, kv = { value: "modified" }, $v = { value: "" }, xv = { value: "asc" }, Sv = { value: "desc" }, Cv = { class: "vuefinder__toolbar__dropdown-section" }, Fv = { class: "vuefinder__toolbar__dropdown-label" }, Tv = { class: "vuefinder__toolbar__dropdown-options" }, Ev = { class: "vuefinder__toolbar__dropdown-option" }, Pv = { class: "vuefinder__toolbar__option-text" }, Dv = { class: "vuefinder__toolbar__dropdown-option" }, Mv = { class: "vuefinder__toolbar__option-text" }, Iv = { class: "vuefinder__toolbar__dropdown-option" }, Av = { class: "vuefinder__toolbar__option-text" }, Ov = { class: "vuefinder__toolbar__dropdown-toggle" }, Lv = {
  for: "showHidden",
  class: "vuefinder__toolbar__toggle-label"
}, Rv = { class: "vuefinder__toolbar__dropdown-reset" }, Bv = ["title"], zv = ["title"], Vv = /* @__PURE__ */ le({
  name: "VfToolbar",
  __name: "Toolbar",
  setup(s) {
    const e = ae(), { enabled: t } = Ve(), { t: n } = e.i18n, a = e.fs, d = e.config, r = oe(d.state), l = oe(a.selectedItems), c = oe(a.sort), v = oe(a.filter);
    pe(
      () => r.value.fullScreen,
      () => {
        const m = document.querySelector("body");
        m && (m.style.overflow = r.value.fullScreen ? "hidden" : "");
      },
      { immediate: !0 }
    );
    const w = M(!1), h = (m) => {
      m.target.closest(".vuefinder__toolbar__dropdown-container") || (w.value = !1);
    };
    we(() => {
      const m = document.querySelector("body");
      m && r.value.fullScreen && setTimeout(() => m.style.overflow = "hidden"), document.addEventListener("click", h);
    }), Pe(() => {
      document.removeEventListener("click", h);
    });
    const _ = M({
      sortBy: "name",
      // name | size | type | modified
      sortOrder: "",
      // '' | asc | desc (empty means no sorting)
      filterKind: "all",
      // all | files | folders
      showHidden: r.value.showHiddenFiles
      // Initialize with config store default
    });
    pe(
      () => _.value.sortBy,
      (m) => {
        if (!_.value.sortOrder) {
          a.clearSort();
          return;
        }
        m === "name" ? a.setSort("basename", _.value.sortOrder) : m === "size" ? a.setSort("file_size", _.value.sortOrder) : m === "modified" && a.setSort("last_modified", _.value.sortOrder);
      }
    ), pe(
      () => _.value.sortOrder,
      (m) => {
        if (!m) {
          a.clearSort();
          return;
        }
        _.value.sortBy === "name" ? a.setSort("basename", m) : _.value.sortBy === "size" ? a.setSort("file_size", m) : _.value.sortBy === "modified" && a.setSort("last_modified", m);
      }
    ), pe(
      c,
      (m) => {
        m.active ? (m.column === "basename" ? _.value.sortBy = "name" : m.column === "file_size" ? _.value.sortBy = "size" : m.column === "last_modified" && (_.value.sortBy = "modified"), _.value.sortOrder = m.order) : _.value.sortOrder = "";
      },
      { immediate: !0 }
    ), pe(
      () => _.value.filterKind,
      (m) => {
        a.setFilter(m, r.value.showHiddenFiles);
      }
    ), pe(
      () => _.value.showHidden,
      (m) => {
        d.set("showHiddenFiles", m), a.setFilter(_.value.filterKind, m);
      }
    ), pe(
      v,
      (m) => {
        _.value.filterKind = m.kind;
      },
      { immediate: !0 }
    ), pe(
      () => r.value.showHiddenFiles,
      (m) => {
        _.value.showHidden = m, a.setFilter(_.value.filterKind, m);
      },
      { immediate: !0 }
    );
    const k = () => d.set("view", r.value.view === "grid" ? "list" : "grid"), b = R(() => v.value.kind !== "all" || !r.value.showHiddenFiles || c.value.active), $ = () => {
      _.value = {
        sortBy: "name",
        sortOrder: "",
        // No sorting by default
        filterKind: "all",
        showHidden: !0
        // Reset to default value
      }, d.set("showHiddenFiles", !0), a.clearSort(), a.clearFilter();
    };
    return (m, g) => (u(), p("div", ev, [
      o("div", tv, [
        i(t)("newfolder") ? (u(), p("div", {
          key: 0,
          class: "mx-1.5",
          title: i(n)("New Folder"),
          onClick: g[0] || (g[0] = (f) => i(e).modal.open(un, { items: i(l) }))
        }, [
          X(i(ao))
        ], 8, nv)) : K("", !0),
        i(t)("newfile") ? (u(), p("div", {
          key: 1,
          class: "mx-1.5",
          title: i(n)("New File"),
          onClick: g[1] || (g[1] = (f) => i(e).modal.open(ro, { items: i(l) }))
        }, [
          X(i(lo))
        ], 8, ov)) : K("", !0),
        i(t)("rename") ? (u(), p("div", {
          key: 2,
          class: "mx-1.5",
          title: i(n)("Rename"),
          onClick: g[2] || (g[2] = (f) => i(l).length !== 1 || i(e).modal.open(Dt, { items: i(l) }))
        }, [
          X(i(Yn), {
            class: te(i(l).length === 1 ? "vf-toolbar-icon" : "vf-toolbar-icon-disabled")
          }, null, 8, ["class"])
        ], 8, sv)) : K("", !0),
        i(t)("delete") ? (u(), p("div", {
          key: 3,
          class: "mx-1.5",
          title: i(n)("Delete"),
          onClick: g[3] || (g[3] = (f) => !i(l).length || i(e).modal.open(Pt, { items: i(l) }))
        }, [
          X(i(Gn), {
            class: te(i(l).length ? "vf-toolbar-icon" : "vf-toolbar-icon-disabled")
          }, null, 8, ["class"])
        ], 8, iv)) : K("", !0),
        i(t)("upload") ? (u(), p("div", {
          key: 4,
          class: "mx-1.5",
          title: i(n)("Upload"),
          onClick: g[4] || (g[4] = (f) => i(e).modal.open(vn, { items: i(l) }))
        }, [
          X(i(co))
        ], 8, av)) : K("", !0),
        i(t)("unarchive") && i(l).length === 1 && i(l)[0].mime_type === "application/zip" ? (u(), p("div", {
          key: 5,
          class: "mx-1.5",
          title: i(n)("Unarchive"),
          onClick: g[5] || (g[5] = (f) => !i(l).length || i(e).modal.open(fn, { items: i(l) }))
        }, [
          X(i(uo), {
            class: te(i(l).length ? "vf-toolbar-icon" : "vf-toolbar-icon-disabled")
          }, null, 8, ["class"])
        ], 8, lv)) : K("", !0),
        i(t)("archive") ? (u(), p("div", {
          key: 6,
          class: "mx-1.5",
          title: i(n)("Archive"),
          onClick: g[6] || (g[6] = (f) => !i(l).length || i(e).modal.open(_n, { items: i(l) }))
        }, [
          X(i(vo), {
            class: te(i(l).length ? "vf-toolbar-icon" : "vf-toolbar-icon-disabled")
          }, null, 8, ["class"])
        ], 8, rv)) : K("", !0)
      ]),
      o("div", dv, [
        i(t)("search") ? (u(), p("div", {
          key: 0,
          class: "mx-1.5",
          title: i(n)("Search Files"),
          onClick: g[7] || (g[7] = (f) => i(e).modal.open(cn))
        }, [
          X(i(dn), { class: "vf-toolbar-icon text-(--vf-bg-primary)" })
        ], 8, cv)) : K("", !0),
        o("div", uv, [
          o("div", {
            title: i(n)("Filter"),
            class: "vuefinder__toolbar__dropdown-trigger",
            onClick: g[8] || (g[8] = (f) => w.value = !w.value)
          }, [
            o("div", fv, [
              X(i(Zu), { class: "vf-toolbar-icon vuefinder__toolbar__icon h-6 w-6" }),
              b.value ? (u(), p("div", _v)) : K("", !0)
            ])
          ], 8, vv),
          w.value ? (u(), p("div", pv, [
            o("div", mv, [
              o("div", hv, [
                o("div", gv, y(i(n)("Sorting")), 1),
                o("div", yv, [
                  he(o("select", {
                    "onUpdate:modelValue": g[9] || (g[9] = (f) => _.value.sortBy = f),
                    class: "vuefinder__toolbar__dropdown-select"
                  }, [
                    o("option", wv, y(i(n)("Name")), 1),
                    o("option", bv, y(i(n)("Size")), 1),
                    o("option", kv, y(i(n)("Date")), 1)
                  ], 512), [
                    [Kt, _.value.sortBy]
                  ]),
                  he(o("select", {
                    "onUpdate:modelValue": g[10] || (g[10] = (f) => _.value.sortOrder = f),
                    class: "vuefinder__toolbar__dropdown-select"
                  }, [
                    o("option", $v, y(i(n)("None")), 1),
                    o("option", xv, y(i(n)("Asc")), 1),
                    o("option", Sv, y(i(n)("Desc")), 1)
                  ], 512), [
                    [Kt, _.value.sortOrder]
                  ])
                ])
              ]),
              o("div", Cv, [
                o("div", Fv, y(i(n)("Show")), 1),
                o("div", Tv, [
                  o("label", Ev, [
                    he(o("input", {
                      "onUpdate:modelValue": g[11] || (g[11] = (f) => _.value.filterKind = f),
                      type: "radio",
                      name: "filterKind",
                      value: "all",
                      class: "vuefinder__toolbar__radio"
                    }, null, 512), [
                      [zt, _.value.filterKind]
                    ]),
                    o("span", Pv, y(i(n)("All items")), 1)
                  ]),
                  o("label", Dv, [
                    he(o("input", {
                      "onUpdate:modelValue": g[12] || (g[12] = (f) => _.value.filterKind = f),
                      type: "radio",
                      name: "filterKind",
                      value: "files",
                      class: "vuefinder__toolbar__radio"
                    }, null, 512), [
                      [zt, _.value.filterKind]
                    ]),
                    o("span", Mv, y(i(n)("Files only")), 1)
                  ]),
                  o("label", Iv, [
                    he(o("input", {
                      "onUpdate:modelValue": g[13] || (g[13] = (f) => _.value.filterKind = f),
                      type: "radio",
                      name: "filterKind",
                      value: "folders",
                      class: "vuefinder__toolbar__radio"
                    }, null, 512), [
                      [zt, _.value.filterKind]
                    ]),
                    o("span", Av, y(i(n)("Folders only")), 1)
                  ])
                ])
              ]),
              o("div", Ov, [
                o("label", Lv, y(i(n)("Show hidden files")), 1),
                he(o("input", {
                  id: "showHidden",
                  "onUpdate:modelValue": g[14] || (g[14] = (f) => _.value.showHidden = f),
                  type: "checkbox",
                  class: "vuefinder__toolbar__checkbox"
                }, null, 512), [
                  [lt, _.value.showHidden]
                ])
              ]),
              o("div", Rv, [
                o("button", {
                  class: "vuefinder__toolbar__reset-button",
                  onClick: $
                }, y(i(n)("Reset")), 1)
              ])
            ])
          ])) : K("", !0)
        ]),
        i(t)("fullscreen") ? (u(), p("div", {
          key: 1,
          class: "mx-1.5",
          title: i(n)("Toggle Full Screen"),
          onClick: g[15] || (g[15] = (f) => i(d).toggle("fullScreen"))
        }, [
          i(r).fullScreen ? (u(), Z(i(ju), {
            key: 0,
            class: "vf-toolbar-icon"
          })) : (u(), Z(i(Uu), {
            key: 1,
            class: "vf-toolbar-icon"
          }))
        ], 8, Bv)) : K("", !0),
        o("div", {
          class: "mx-1.5",
          title: i(n)("Change View"),
          onClick: g[16] || (g[16] = (f) => k())
        }, [
          i(r).view === "grid" ? (u(), Z(i(Wu), {
            key: 0,
            class: "vf-toolbar-icon"
          })) : K("", !0),
          i(r).view === "list" ? (u(), Z(i(Xu), {
            key: 1,
            class: "vf-toolbar-icon"
          })) : K("", !0)
        ], 8, zv)
      ])
    ]));
  }
}), Uv = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  class: "vuefinder__breadcrumb__refresh-icon",
  viewBox: "-40 -40 580 580"
};
function Nv(s, e) {
  return u(), p("svg", Uv, [...e[0] || (e[0] = [
    o("path", { d: "M463.5 224h8.5c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2S461.9 48.1 455 55l-41.6 41.6c-87.6-86.5-228.7-86.2-315.8 1-87.5 87.5-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2S334.3 224 344 224z" }, null, -1)
  ])]);
}
const Hv = { render: Nv }, jv = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Kv(s, e) {
  return u(), p("svg", jv, [...e[0] || (e[0] = [
    o("path", {
      d: "M10.707 2.293a1 1 0 0 0-1.414 0l-7 7a1 1 0 0 0 1.414 1.414L4 10.414V17a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-6.586l.293.293a1 1 0 0 0 1.414-1.414z",
      class: "pointer-events-none"
    }, null, -1)
  ])]);
}
const qv = { render: Kv }, Wv = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.5",
  class: "w-6 h-6 cursor-pointer",
  viewBox: "0 0 24 24"
};
function Gv(s, e) {
  return u(), p("svg", Wv, [...e[0] || (e[0] = [
    o("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6 18 18 6M6 6l12 12"
    }, null, -1)
  ])]);
}
const Yv = { render: Gv }, Xv = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24"
};
function Qv(s, e) {
  return u(), p("svg", Xv, [...e[0] || (e[0] = [
    o("path", {
      stroke: "none",
      d: "M0 0h24v24H0z"
    }, null, -1),
    o("path", { d: "M9 6h11M12 12h8M15 18h5M5 6v.01M8 12v.01M11 18v.01" }, null, -1)
  ])]);
}
const Jv = { render: Qv }, Zv = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
function ef(s, e) {
  return u(), p("svg", Zv, [...e[0] || (e[0] = [
    o("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M8 7h12m0 0-4-4m4 4-4 4m0 6H4m0 0 4 4m-4-4 4-4"
    }, null, -1)
  ])]);
}
const tf = { render: ef };
function $t(s, e = []) {
  const t = "vfDragEnterCounter", n = s.fs, a = oe(n.selectedItems);
  function d(h, _) {
    return !!(!h || h.type !== "dir" || h.path === _ || h.path.startsWith(`${_}/`) || a.value.some((b) => b.path === _ ? !1 : !!(h.path === b.path || h.path.startsWith(`${b.path}/`))));
  }
  function r(h, _) {
    if (h.isExternalDrag)
      return;
    if (!(s.features?.move ?? !1)) {
      h.dataTransfer && (h.dataTransfer.dropEffect = "none", h.dataTransfer.effectAllowed = "none");
      return;
    }
    h.preventDefault();
    const b = n.getDraggedItem(), $ = n.sortedFiles.get().find((m) => ke(m) === b)?.path ?? "";
    d(_, $) ? h.dataTransfer && (h.dataTransfer.dropEffect = "none", h.dataTransfer.effectAllowed = "none") : (h.dataTransfer && (h.dataTransfer.dropEffect = "copy", h.dataTransfer.effectAllowed = "all"), h.currentTarget.classList.add(...e));
  }
  function l(h) {
    if (h.isExternalDrag || !(s.features?.move ?? !1))
      return;
    h.preventDefault();
    const k = h.currentTarget, b = Number(k.dataset[t] || 0);
    k.dataset[t] = String(b + 1);
  }
  function c(h) {
    if (h.isExternalDrag || !(s.features?.move ?? !1))
      return;
    h.preventDefault();
    const k = h.currentTarget, $ = Number(k.dataset[t] || 0) - 1;
    $ <= 0 ? (delete k.dataset[t], k.classList.remove(...e)) : k.dataset[t] = String($);
  }
  function v(h, _) {
    if (h.isExternalDrag || !(s.features?.move ?? !1) || !_) return;
    h.preventDefault();
    const b = h.currentTarget;
    delete b.dataset[t], b.classList.remove(...e);
    const $ = h.dataTransfer?.getData("items") || "[]", g = JSON.parse($).map((f) => n.sortedFiles.get().find((F) => ke(F) === f)).filter((f) => !!f);
    n.clearDraggedItem(), s.modal.open(at, { items: { from: g, to: _ } });
  }
  function w(h) {
    return {
      dragover: (_) => r(_, h),
      dragenter: l,
      dragleave: c,
      drop: (_) => v(_, h)
    };
  }
  return { events: w };
}
const nf = { class: "vuefinder__breadcrumb__container" }, of = ["title"], sf = ["title"], af = ["title"], lf = ["title"], rf = { class: "vuefinder__breadcrumb__path-container" }, df = { class: "vuefinder__breadcrumb__list" }, cf = {
  key: 0,
  class: "vuefinder__breadcrumb__hidden-list"
}, uf = { class: "relative" }, vf = ["title", "onClick"], ff = ["title"], _f = { class: "vuefinder__breadcrumb__path-mode" }, pf = { class: "vuefinder__breadcrumb__path-mode-content" }, mf = ["title"], hf = { class: "vuefinder__breadcrumb__path-text" }, gf = ["title"], yf = ["data-theme"], wf = ["onClick"], bf = { class: "vuefinder__breadcrumb__hidden-item-content" }, kf = { class: "vuefinder__breadcrumb__hidden-item-text" }, ut = 5, Dn = 1, $f = 40, xf = /* @__PURE__ */ le({
  __name: "Breadcrumb",
  setup(s) {
    const e = ae(), t = Be(e), { t: n } = e.i18n, a = e.fs, d = e.config, r = oe(d.state), l = oe(a.path), c = oe(a.loading), v = M(null), w = to(0, 100), h = M(5), _ = M(!1), k = M(!1), b = R(() => l.value?.breadcrumb ?? []), $ = /* @__PURE__ */ new Map();
    function m(E, V) {
      return E.length > V ? [E.slice(-V), E.slice(0, -V)] : [E, []];
    }
    const g = R(
      () => m(b.value, h.value)[0]
    ), f = R(
      () => m(b.value, h.value)[1]
    );
    function F() {
      const E = b.value, V = w.value;
      if (!E.length || V <= 0) return null;
      let I = 0, O = 0;
      for (let q = E.length - 1; q >= 0; q--) {
        const P = E[q]?.name;
        if (!P) continue;
        const j = $.get(P);
        if (j === void 0) return null;
        if (I + j > V - $f || (I += j, O++, O >= ut)) break;
      }
      return O < Dn && (O = Dn), O > ut && (O = ut), O;
    }
    function C() {
      if (!v.value) return;
      const E = v.value.children, V = g.value;
      for (let I = 0; I < E.length; I++) {
        const O = V[I]?.name;
        if (!O) continue;
        const q = E[I].offsetWidth;
        q > 0 && $.set(O, q);
      }
    }
    async function A() {
      if (!b.value.length) {
        h.value = ut;
        return;
      }
      const E = F();
      if (E !== null) {
        h.value = E;
        return;
      }
      h.value = ut, await De(), C();
      const V = F();
      V !== null && (h.value = V);
    }
    pe(w, A), pe(b, A, { immediate: !0 });
    const S = () => {
      v.value && (w.value = v.value.offsetWidth);
    }, L = M(null);
    we(() => {
      L.value = new ResizeObserver(S), v.value && L.value.observe(v.value);
    }), Pe(() => {
      L.value && L.value.disconnect();
    });
    const H = $t(e, ["vuefinder__drag-over"]);
    function Y(E = null) {
      E ??= b.value.length - 2;
      const V = {
        basename: l.value?.storage ?? "local",
        extension: "",
        path: (l.value?.storage ?? "local") + "://",
        storage: l.value?.storage ?? "local",
        type: "dir",
        file_size: null,
        last_modified: null,
        mime_type: null,
        visibility: ""
      };
      return b.value[E] ?? V;
    }
    const Q = () => {
      e.adapter.invalidateListQuery(l.value.path), e.adapter.open(l.value.path);
    }, B = () => {
      g.value.length > 0 && e.adapter.open(
        b.value[b.value.length - 2]?.path ?? (l.value?.storage ?? "local") + "://"
      );
    }, W = (E) => {
      e.adapter.open(E.path), _.value = !1;
    }, T = () => {
      _.value && (_.value = !1);
    }, D = {
      mounted(E, V) {
        E.clickOutsideEvent = function(I) {
          E === I.target || E.contains(I.target) || V.value();
        }, document.body.addEventListener("click", E.clickOutsideEvent);
      },
      beforeUnmount(E) {
        document.body.removeEventListener("click", E.clickOutsideEvent);
      }
    }, N = () => {
      d.toggle("showTreeView");
    }, J = M({
      x: 0,
      y: 0
    }), ce = (E, V = null) => {
      if (E.currentTarget instanceof HTMLElement) {
        const { x: I, y: O, height: q } = E.currentTarget.getBoundingClientRect();
        J.value = { x: I, y: O + q };
      }
      _.value = V ?? !_.value;
    }, z = () => {
      k.value = !k.value;
    }, x = async () => {
      await wt(l.value?.path || ""), t.success(n("Path copied to clipboard"));
    }, U = () => {
      k.value = !1;
    };
    return (E, V) => (u(), p("div", nf, [
      o("span", {
        title: i(n)("Toggle Tree View")
      }, [
        X(i(Jv), {
          class: te(["vuefinder__breadcrumb__toggle-tree", i(r).showTreeView ? "vuefinder__breadcrumb__toggle-tree--active" : ""]),
          onClick: N
        }, null, 8, ["class"])
      ], 8, of),
      o("span", {
        title: i(n)("Go up a directory")
      }, [
        X(i(fo), Ne({
          class: b.value.length ? "vuefinder__breadcrumb__go-up--active" : "vuefinder__breadcrumb__go-up--inactive"
        }, Ye(b.value.length ? i(H).events(Y()) : {}), { onClick: B }), null, 16, ["class"])
      ], 8, sf),
      i(a).isLoading() ? (u(), p("span", {
        key: 1,
        title: i(n)("Cancel")
      }, [
        X(i(Xn), {
          onClick: V[0] || (V[0] = (I) => i(e).emitter.emit("vf-fetch-abort"))
        })
      ], 8, lf)) : (u(), p("span", {
        key: 0,
        title: i(n)("Refresh")
      }, [
        X(i(Hv), { onClick: Q })
      ], 8, af)),
      he(o("div", rf, [
        o("div", null, [
          X(i(qv), Ne({ class: "vuefinder__breadcrumb__home-icon" }, Ye(i(H).events(Y(-1))), {
            onClick: V[1] || (V[1] = ve((I) => i(e).adapter.open(i(l).storage + "://"), ["stop"]))
          }), null, 16)
        ]),
        o("div", df, [
          f.value.length ? he((u(), p("div", cf, [
            V[3] || (V[3] = o("div", { class: "vuefinder__breadcrumb__separator" }, "/", -1)),
            o("div", uf, [
              o("span", {
                class: "vuefinder__breadcrumb__hidden-toggle",
                onDragenter: V[2] || (V[2] = (I) => ce(I, !0)),
                onClick: ve(ce, ["stop"])
              }, [
                X(i(so), { class: "vuefinder__breadcrumb__hidden-toggle-icon" })
              ], 32)
            ])
          ])), [
            [D, T]
          ]) : K("", !0)
        ]),
        o("div", {
          ref_key: "breadcrumbContainer",
          ref: v,
          class: "vuefinder__breadcrumb__visible-list pointer-events-none"
        }, [
          (u(!0), p(_e, null, ge(g.value, (I, O) => (u(), p("div", { key: O }, [
            V[4] || (V[4] = o("span", { class: "vuefinder__breadcrumb__separator" }, "/", -1)),
            o("span", Ne({
              class: "vuefinder__breadcrumb__item pointer-events-auto",
              title: I.basename
            }, Ye(i(H).events(I), !0), {
              onClick: ve((q) => i(e).adapter.open(I.path), ["stop"])
            }), y(I.name), 17, vf)
          ]))), 128))
        ], 512),
        i(d).get("loadingIndicator") === "circular" && i(c) ? (u(), Z(i(Ot), { key: 0 })) : K("", !0),
        o("span", {
          title: i(n)("Toggle Path Copy Mode"),
          onClick: z
        }, [
          X(i(tf), { class: "vuefinder__breadcrumb__toggle-icon" })
        ], 8, ff)
      ], 512), [
        [qe, !k.value]
      ]),
      he(o("div", _f, [
        o("div", pf, [
          o("div", {
            title: i(n)("Copy Path")
          }, [
            X(i(an), {
              class: "vuefinder__breadcrumb__copy-icon",
              onClick: x
            })
          ], 8, mf),
          o("div", hf, y(i(l).path), 1),
          o("div", {
            title: i(n)("Exit")
          }, [
            X(i(Yv), {
              class: "vuefinder__breadcrumb__exit-icon",
              onClick: U
            })
          ], 8, gf)
        ])
      ], 512), [
        [qe, k.value]
      ]),
      (u(), Z(bt, { to: "body" }, [
        o("div", null, [
          he(o("div", {
            style: Ee({
              position: "absolute",
              top: J.value.y + "px",
              left: J.value.x + "px"
            }),
            class: "vuefinder__themer vuefinder__breadcrumb__hidden-dropdown",
            "data-theme": i(e).theme.current
          }, [
            (u(!0), p(_e, null, ge(f.value, (I, O) => (u(), p("div", Ne({
              key: O,
              class: "vuefinder__breadcrumb__hidden-item"
            }, Ye(i(H).events(I), !0), {
              onClick: (q) => W(I)
            }), [
              o("div", bf, [
                o("span", null, [
                  X(i(Re), { class: "vuefinder__breadcrumb__hidden-item-icon" })
                ]),
                o("span", kf, y(I.name), 1)
              ])
            ], 16, wf))), 128))
          ], 12, yf), [
            [qe, _.value]
          ])
        ])
      ]))
    ]));
  }
}), Sf = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
function Cf(s, e) {
  return u(), p("svg", Sf, [...e[0] || (e[0] = [
    o("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M7 21h10a2 2 0 0 0 2-2V9.414a1 1 0 0 0-.293-.707l-5.414-5.414A1 1 0 0 0 12.586 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2"
    }, null, -1)
  ])]);
}
const Mn = { render: Cf }, Ff = { class: "vuefinder__drag-item__container" }, Tf = { class: "vuefinder__drag-item__count" }, Ef = /* @__PURE__ */ le({
  __name: "DragItem",
  props: {
    count: {}
  },
  setup(s) {
    const e = s;
    return (t, n) => (u(), p("div", Ff, [
      e.count > 1 ? (u(), Z(i(Mn), {
        key: 0,
        class: "vuefinder__drag-item__icon translate-x-1 translate-y-1"
      })) : K("", !0),
      X(i(Mn), { class: "vuefinder__drag-item__icon" }),
      o("div", Tf, y(e.count), 1)
    ]));
  }
}), Pf = {
  key: 2,
  class: "vuefinder__item-icon__extension"
}, Xt = /* @__PURE__ */ le({
  __name: "ItemIcon",
  props: {
    item: {},
    ext: { type: Boolean },
    small: { type: Boolean },
    view: {}
  },
  setup(s) {
    const e = s, t = ae(), n = oe(t.config.state), a = R(() => e.small !== void 0 ? e.small ? "small" : "large" : e.view === "list" ? "small" : "large"), d = R(() => {
      const l = a.value, c = n.value?.listIconSize, v = n.value?.gridIconSize;
      return n.value?.gridItemWidth, n.value?.gridItemHeight, e.view === "list" || l === "small" ? {
        "--vf-icon-size": `${c ?? 16}px`
      } : {
        "--vf-icon-size": `${v ?? 48}px`
      };
    }), r = {
      app: t,
      config: n.value,
      item: e.item,
      view: e.view
    };
    return (l, c) => (u(), p("div", {
      class: te(["vuefinder__item-icon", {
        "vuefinder__item-icon--small": a.value === "small",
        "vuefinder__item-icon--large": a.value === "large",
        "vuefinder__item-icon--grid": s.view === "grid",
        "vuefinder__item-icon--list": s.view === "list"
      }]),
      style: Ee(d.value)
    }, [
      Me(l.$slots, "icon", Ze(et(r)), () => [
        s.item.type === "dir" ? (u(), Z(i(Re), {
          key: 0,
          class: "vuefinder__item-icon__folder"
        })) : (u(), Z(i(gt), {
          key: 1,
          class: "vuefinder__item-icon__file"
        })),
        s.ext && s.item.type !== "dir" && s.item.extension ? (u(), p("div", Pf, y(s.item.extension.substring(0, 3)), 1)) : K("", !0)
      ])
    ], 6));
  }
}), Df = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
function Mf(s, e) {
  return u(), p("svg", Df, [...e[0] || (e[0] = [
    o("path", {
      fill: "none",
      d: "M0 0h24v24H0z"
    }, null, -1),
    o("path", { d: "M12 2a5 5 0 0 1 5 5v3a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3v-6a3 3 0 0 1 3-3V7a5 5 0 0 1 5-5m0 12a2 2 0 0 0-1.995 1.85L10 16a2 2 0 1 0 2-2m0-10a3 3 0 0 0-3 3v3h6V7a3 3 0 0 0-3-3" }, null, -1)
  ])]);
}
const In = { render: Mf }, If = ["data-key", "data-row", "data-col", "draggable"], Af = { key: 0 }, Of = { class: "vuefinder__explorer__item-grid-content" }, Lf = ["data-src", "alt"], Rf = { class: "vuefinder__explorer__item-title" }, Bf = {
  key: 1,
  class: "vuefinder__explorer__item-list-content"
}, zf = { class: "vuefinder__explorer__item-list-name" }, Vf = { class: "vuefinder__explorer__item-list-icon" }, Uf = { class: "vuefinder__explorer__item-name" }, Nf = {
  key: 0,
  class: "vuefinder__explorer__item-path"
}, Hf = {
  key: 1,
  class: "vuefinder__explorer__item-size"
}, jf = { key: 0 }, Kf = {
  key: 2,
  class: "vuefinder__explorer__item-date"
}, qf = /* @__PURE__ */ le({
  __name: "FileItem",
  props: {
    item: {},
    view: {},
    showThumbnails: { type: Boolean },
    isSelected: { type: Boolean },
    isDragging: { type: Boolean },
    rowIndex: {},
    colIndex: {},
    showPath: { type: Boolean },
    explorerId: {}
  },
  emits: ["click", "dblclick", "contextmenu", "dragstart", "dragend"],
  setup(s, { emit: e }) {
    const t = s, n = e, a = ae(), d = a.fs, r = a.config, l = R(() => {
      const W = a.selectionFilterType;
      return !W || W === "both" ? !0 : W === "files" && t.item.type === "file" || W === "dirs" && t.item.type === "dir";
    }), c = R(() => {
      const W = a.selectionFilterMimeIncludes;
      return !W || !W.length || t.item.type === "dir" ? !0 : t.item.mime_type ? W.some((T) => t.item.mime_type?.startsWith(T)) : !1;
    }), v = R(() => l.value && c.value), w = R(() => t.item.type === "dir" || v.value), h = R(() => [
      "file-item-" + t.explorerId,
      t.view === "grid" ? "vf-explorer-item-grid" : "vf-explorer-item-list",
      t.isSelected ? "vf-explorer-selected" : "",
      // Disabled appearance: only for items the user cannot interact with at all.
      w.value ? "" : "vf-explorer-item--unselectable",
      // Excluded from rectangle selection but otherwise interactive (e.g. a
      // folder while selectionFilterType is 'files' — user can still navigate).
      w.value && !v.value ? "vf-explorer-item--no-select" : ""
    ]), _ = R(() => ({
      opacity: t.isDragging || d.isCut(ke(t.item)) || !w.value ? 0.5 : ""
    })), k = M(null);
    let b = !1, $ = null, m = null, g = !1;
    const { enabled: f } = Ve(), F = typeof window < "u" && ("ontouchstart" in window || navigator.maxTouchPoints > 0), C = R(() => F ? !1 : f("move")), A = () => {
      $ && (clearTimeout($), $ = null), m = null;
    }, S = (W) => {
      A(), m = W, g = !1, W.stopPropagation(), $ = setTimeout(() => {
        !m || $ === null || (g = !0, m.cancelable && m.preventDefault(), m.stopPropagation(), n("contextmenu", m), A());
      }, 500);
    }, L = (W) => {
      if (g) {
        W.preventDefault(), W.stopPropagation(), A();
        return;
      }
      setTimeout(() => {
        g || (A(), B(W));
      }, 100);
    }, H = (W) => {
      if (!m) return;
      const T = m.touches[0] || m.changedTouches[0], D = W.touches[0] || W.changedTouches[0];
      if (T && D) {
        const N = Math.abs(D.clientX - T.clientX), J = Math.abs(D.clientY - T.clientY);
        (N > 15 || J > 15) && A();
      }
    }, Y = (W) => {
      F && W.type !== "click" || n("click", W);
    }, Q = (W) => {
      if (g)
        return W.preventDefault(), W.stopPropagation(), !1;
      n("dragstart", W);
    }, B = (W) => {
      if (!b)
        b = !0, n("click", W), k.value = setTimeout(() => {
          b = !1;
        }, 300);
      else
        return b = !1, n("dblclick", W), !1;
    };
    return (W, T) => (u(), p("div", {
      class: te(h.value),
      style: Ee(_.value),
      "data-key": i(ke)(s.item),
      "data-row": s.rowIndex,
      "data-col": s.colIndex,
      draggable: C.value,
      onTouchstartCapture: T[1] || (T[1] = (D) => S(D)),
      onTouchendCapture: T[2] || (T[2] = (D) => L(D)),
      onTouchmoveCapture: H,
      onTouchcancelCapture: T[3] || (T[3] = () => A()),
      onClick: Y,
      onDblclick: T[4] || (T[4] = (D) => n("dblclick", D)),
      onContextmenu: T[5] || (T[5] = ve((D) => n("contextmenu", D), ["prevent", "stop"])),
      onDragstart: Q,
      onDragend: T[6] || (T[6] = (D) => n("dragend", D))
    }, [
      s.view === "grid" ? (u(), p("div", Af, [
        i(d).isReadOnly(s.item) ? (u(), Z(i(In), {
          key: 0,
          class: "vuefinder__item--readonly vuefinder__item--readonly--left",
          title: "Read Only"
        })) : K("", !0),
        o("div", Of, [
          (s.item.mime_type ?? "").startsWith("image") && s.showThumbnails ? (u(), p("img", {
            key: 0,
            src: "data:image/png;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",
            class: "vuefinder__explorer__item-thumbnail lazy",
            "data-src": s.item.previewUrl ?? i(a).adapter.getPreviewUrl({ path: s.item.path }),
            alt: s.item.basename,
            onTouchstart: T[0] || (T[0] = (D) => D.preventDefault())
          }, null, 40, Lf)) : (u(), Z(Xt, {
            key: 1,
            item: s.item,
            ext: !0,
            view: s.view
          }, {
            icon: ue((D) => [
              Me(W.$slots, "icon", Ze(et(D)))
            ]),
            _: 3
          }, 8, ["item", "view"]))
        ]),
        o("span", Rf, y(i(Yt)(s.item.basename)), 1)
      ])) : (u(), p("div", Bf, [
        o("div", zf, [
          o("div", Vf, [
            X(Xt, {
              item: s.item,
              view: s.view
            }, {
              icon: ue((D) => [
                Me(W.$slots, "icon", Ze(et(D)))
              ]),
              _: 3
            }, 8, ["item", "view"])
          ]),
          o("span", Uf, y(s.item.basename), 1),
          o("div", null, [
            i(d).isReadOnly(s.item) ? (u(), Z(i(In), {
              key: 0,
              class: "vuefinder__item--readonly vuefinder__item--readonly--list",
              title: "Read Only"
            })) : K("", !0)
          ])
        ]),
        s.showPath ? (u(), p("div", Nf, y(s.item.path), 1)) : K("", !0),
        s.showPath ? K("", !0) : (u(), p("div", Hf, [
          s.item.file_size ? (u(), p("div", jf, y(i(a).filesize(s.item.file_size)), 1)) : K("", !0)
        ])),
        !s.showPath && s.item.last_modified ? (u(), p("div", Kf, y(new Date(s.item.last_modified * 1e3).toLocaleString()), 1)) : K("", !0)
      ])),
      i(f)("pinned") && i(r).get("pinnedFolders").find((D) => D.path === s.item.path) ? (u(), Z(i(yt), {
        key: 2,
        class: "vuefinder__item--pinned"
      })) : K("", !0)
    ], 46, If));
  }
}), Wf = ["data-row"], An = /* @__PURE__ */ le({
  __name: "FileRow",
  props: {
    rowIndex: {},
    rowHeight: {},
    view: {},
    itemsPerRow: {},
    items: {},
    showThumbnails: { type: Boolean },
    showPath: { type: Boolean },
    isDraggingItem: { type: Function },
    isSelected: { type: Function },
    dragNDropEvents: { type: Function },
    explorerId: {}
  },
  emits: ["click", "dblclick", "contextmenu", "dragstart", "dragend"],
  setup(s, { emit: e }) {
    const t = s, n = e, a = R(() => [
      t.view === "grid" ? "vf-explorer-item-grid-row" : "vf-explorer-item-list-row",
      "pointer-events-none"
    ]), d = R(() => ({
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: `${t.rowHeight}px`,
      transform: `translateY(${t.rowIndex * t.rowHeight}px)`
    })), r = R(() => t.view === "grid" ? {
      gridTemplateColumns: `repeat(${t.itemsPerRow || 1}, 1fr)`
    } : {
      gridTemplateColumns: "1fr"
    });
    return (l, c) => (u(), p("div", {
      class: te(a.value),
      "data-row": s.rowIndex,
      style: Ee(d.value)
    }, [
      o("div", {
        class: te(["grid justify-self-start", { "w-full": s.view === "list" }]),
        style: Ee(r.value)
      }, [
        (u(!0), p(_e, null, ge(s.items, (v, w) => (u(), Z(qf, Ne({
          key: i(ke)(v),
          item: v,
          view: s.view,
          "show-thumbnails": s.showThumbnails,
          "show-path": s.showPath,
          "is-selected": s.isSelected(i(ke)(v)),
          "is-dragging": s.isDraggingItem(i(ke)(v)),
          "row-index": s.rowIndex,
          "col-index": w,
          "explorer-id": s.explorerId
        }, Ye(s.dragNDropEvents(v)), {
          onClick: c[0] || (c[0] = (h) => n("click", h)),
          onDblclick: c[1] || (c[1] = (h) => n("dblclick", h)),
          onContextmenu: c[2] || (c[2] = (h) => n("contextmenu", h)),
          onDragstart: c[3] || (c[3] = (h) => n("dragstart", h)),
          onDragend: c[4] || (c[4] = (h) => n("dragend", h))
        }), {
          icon: ue((h) => [
            Me(l.$slots, "icon", Ne({ ref_for: !0 }, h))
          ]),
          _: 3
        }, 16, ["item", "view", "show-thumbnails", "show-path", "is-selected", "is-dragging", "row-index", "col-index", "explorer-id"]))), 128))
      ], 6)
    ], 14, Wf));
  }
}), Gf = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Yf(s, e) {
  return u(), p("svg", Gf, [...e[0] || (e[0] = [
    o("path", {
      "fill-rule": "evenodd",
      d: "M5.293 7.293a1 1 0 0 1 1.414 0L10 10.586l3.293-3.293a1 1 0 1 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 0-1.414",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const Xf = { render: Yf }, Qf = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function Jf(s, e) {
  return u(), p("svg", Qf, [...e[0] || (e[0] = [
    o("path", {
      "fill-rule": "evenodd",
      d: "M14.707 12.707a1 1 0 0 1-1.414 0L10 9.414l-3.293 3.293a1 1 0 0 1-1.414-1.414l4-4a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const Zf = { render: Jf }, jt = /* @__PURE__ */ le({
  __name: "SortIcon",
  props: {
    direction: {}
  },
  setup(s) {
    return (e, t) => (u(), p("div", null, [
      s.direction === "asc" ? (u(), Z(i(Xf), {
        key: 0,
        class: "vuefinder__explorer__sort-icon"
      })) : K("", !0),
      s.direction === "desc" ? (u(), Z(i(Zf), {
        key: 1,
        class: "vuefinder__explorer__sort-icon"
      })) : K("", !0)
    ]));
  }
}), e_ = { class: "vuefinder__explorer__header" }, t_ = /* @__PURE__ */ le({
  __name: "ExplorerHeader",
  setup(s) {
    const e = ae(), t = e.fs, { t: n } = e.i18n, a = oe(t.sort);
    return (d, r) => (u(), p("div", e_, [
      o("div", {
        class: "vuefinder__explorer__sort-button vuefinder__explorer__sort-button--name vf-sort-button",
        onClick: r[0] || (r[0] = (l) => i(t).toggleSort("basename"))
      }, [
        ye(y(i(n)("Name")) + " ", 1),
        he(X(jt, {
          direction: i(a).order
        }, null, 8, ["direction"]), [
          [qe, i(a).active && i(a).column === "basename"]
        ])
      ]),
      o("div", {
        class: "vuefinder__explorer__sort-button vuefinder__explorer__sort-button--size vf-sort-button",
        onClick: r[1] || (r[1] = (l) => i(t).toggleSort("file_size"))
      }, [
        ye(y(i(n)("Size")) + " ", 1),
        he(X(jt, {
          direction: i(a).order
        }, null, 8, ["direction"]), [
          [qe, i(a).active && i(a).column === "file_size"]
        ])
      ]),
      o("div", {
        class: "vuefinder__explorer__sort-button vuefinder__explorer__sort-button--date vf-sort-button",
        onClick: r[2] || (r[2] = (l) => i(t).toggleSort("last_modified"))
      }, [
        ye(y(i(n)("Date")) + " ", 1),
        he(X(jt, {
          direction: i(a).order
        }, null, 8, ["direction"]), [
          [qe, i(a).active && i(a).column === "last_modified"]
        ])
      ])
    ]));
  }
});
function n_(s, e) {
  const {
    scrollContainer: t,
    itemWidth: n = 100,
    rowHeight: a,
    overscan: d = 2,
    containerPadding: r = 48,
    lockItemsPerRow: l
  } = e, c = s, v = () => typeof a == "number" ? a : a.value, w = () => n ? typeof n == "number" ? n : n.value : 100, h = () => r ? typeof r == "number" ? r : r.value : 0, _ = M(0), k = M(6), b = M(600);
  let $ = null;
  const m = R(() => Math.ceil(c.value.length / k.value)), g = R(() => m.value * v()), f = R(() => {
    const B = v(), W = Math.max(0, Math.floor(_.value / B) - d), T = Math.min(
      m.value,
      Math.ceil((_.value + b.value) / B) + d
    );
    return { start: W, end: T };
  }), F = R(() => {
    const { start: B, end: W } = f.value;
    return Array.from({ length: W - B }, (T, D) => B + D);
  }), C = () => b.value, A = () => typeof l == "object" ? l.value : !1, S = () => {
    if (A()) {
      k.value = 1;
      return;
    }
    if (t.value) {
      const B = h(), W = t.value.clientWidth - B, T = w();
      T > 0 && (k.value = Math.max(Math.floor(W / T), 2));
    }
  }, L = (B) => {
    const W = B.target;
    _.value = W.scrollTop;
  };
  pe(
    () => c.value.length,
    () => {
      S();
    }
  ), n && typeof n != "number" && pe(n, () => {
    S();
  }), r && typeof r != "number" && pe(r, () => {
    S();
  }), a && typeof a != "number" && pe(a, () => {
  });
  const H = (B, W) => {
    if (!B || !Array.isArray(B))
      return [];
    const T = W * k.value;
    return B.slice(T, T + k.value);
  }, Y = (B, W, T, D, N) => {
    if (!B || !Array.isArray(B))
      return [];
    const J = [];
    for (let ce = W; ce <= T; ce++)
      for (let z = D; z <= N; z++) {
        const x = ce * k.value + z;
        x < B.length && B[x] && J.push(B[x]);
      }
    return J;
  }, Q = (B) => ({
    row: Math.floor(B / k.value),
    col: B % k.value
  });
  return we(async () => {
    await De(), t.value && (b.value = t.value.clientHeight || 600), S(), window.addEventListener("resize", () => {
      t.value && (b.value = t.value.clientHeight || 600), S();
    }), t.value && "ResizeObserver" in window && ($ = new ResizeObserver((B) => {
      const W = B[0];
      W && (b.value = Math.round(W.contentRect.height)), S();
    }), $.observe(t.value));
  }), Pe(() => {
    window.removeEventListener("resize", S), $ && ($.disconnect(), $ = null);
  }), {
    scrollTop: _,
    itemsPerRow: k,
    totalRows: m,
    totalHeight: g,
    visibleRange: f,
    visibleRows: F,
    updateItemsPerRow: S,
    handleScroll: L,
    getRowItems: H,
    getItemsInRange: Y,
    getItemPosition: Q,
    getContainerHeight: C
  };
}
function o_(s) {
  const {
    itemsPerRow: e,
    totalHeight: t,
    getItemsInRange: n,
    getKey: a,
    selectionObject: d,
    rowHeight: r,
    itemWidth: l,
    osInstance: c
  } = s, v = () => typeof l == "number" ? l : l.value, w = Math.floor(Math.random() * 2 ** 32).toString(), h = ae(), _ = h.fs, k = oe(_.selectedKeys), b = oe(_.sortedFiles), $ = R(() => {
    const z = /* @__PURE__ */ new Map();
    return b.value && b.value.forEach((x) => {
      z.set(a(x), x);
    }), z;
  }), m = M(/* @__PURE__ */ new Set()), g = M(!1), f = M(!1), F = (z) => z.map((x) => x.getAttribute("data-key")).filter((x) => !!x), C = (z) => {
    z.selection.clearSelection(!0, !0);
  }, A = (z) => {
    if (k.value && k.value.size > 0) {
      const x = document.querySelectorAll(`.file-item-${w}[data-key]`), U = /* @__PURE__ */ new Map();
      x.forEach((V) => {
        const I = V.getAttribute("data-key");
        I && U.set(I, V);
      });
      const E = [];
      k.value.forEach((V) => {
        const I = U.get(V);
        I && S(V) && E.push(I);
      }), E.forEach((V) => {
        z.selection.select(V, !0);
      });
    }
  }, S = (z) => {
    const x = $.value.get(z);
    if (!x) return !1;
    const U = h.selectionFilterType, E = h.selectionFilterMimeIncludes;
    return U === "files" && x.type === "dir" || U === "dirs" && x.type === "file" ? !1 : E && Array.isArray(E) && E.length > 0 ? x.type === "dir" ? !0 : x.mime_type ? E.some((V) => x.mime_type?.startsWith(V)) : !1 : !0;
  }, L = (z) => {
    if (h.selectionMode === "single")
      return !1;
    g.value = !1, !z.event?.metaKey && !z.event?.ctrlKey && (f.value = !0), z.selection.resolveSelectables(), C(z), A(z);
  }, H = M(0), Y = ({ event: z, selection: x }) => {
    H.value = (d.value?.getAreaLocation().y1 ?? 0) - (h.root.getBoundingClientRect().top ?? 0);
    const U = document.querySelector(
      ".selection-area-container"
    );
    if (U && (U.dataset.theme = h.theme.current), h.selectionMode === "single")
      return;
    const E = z;
    E && "type" in E && E.type === "touchend" && E.preventDefault();
    const V = z;
    !V?.ctrlKey && !V?.metaKey && (_.clearSelection(), x.clearSelection(!0, !0)), m.value.clear();
  }, Q = (z) => {
    if (h.selectionMode === "single")
      return;
    const x = F(z.store.changed.added), U = F(z.store.changed.removed);
    f.value = !1, g.value = !0, x.forEach((E) => {
      k.value && !k.value.has(E) && S(E) && (m.value.add(E), _.select(E, h.selectionMode || "multiple"));
    }), U.forEach((E) => {
      document.querySelector(`[data-key="${E}"]`) && $.value.has(E) && m.value.delete(E), _.deselect(E);
    }), z.selection.resolveSelectables(), A(z);
  }, B = () => {
    m.value.clear();
  }, W = (z) => {
    if (!z.event)
      return;
    const x = document.querySelector(".scroller-" + w);
    if (!x)
      return;
    const U = x.getBoundingClientRect(), E = U.left, V = U.top;
    let I = x.scrollTop;
    if (c?.value) {
      const { viewport: Ge } = c.value.elements();
      Ge && (I = Ge.scrollTop);
    }
    const O = d.value?.getAreaLocation();
    if (!O)
      return;
    const q = Math.min(O.x1, O.x2), P = I + Math.min(O.y1, O.y2), j = Math.max(O.x1, O.x2), de = I + Math.max(O.y1, O.y2), me = 4, G = v();
    let se = Math.floor((q - E - me) / G), fe = Math.floor((j - E - me) / G);
    const be = q - E - me - se * G, Ie = j - E - me - fe * G;
    be > G - me && (se = se + 1), Ie < me && (fe = fe - 1);
    const tt = Math.max(0, se), ee = Math.min(e.value - 1, fe);
    let ne = Math.floor((P - V - me) / r.value), ie = Math.floor((de - V - me) / r.value);
    const re = P - V - me - ne * r.value, Ue = de - V - me - ie * r.value, Te = Math.floor((t.value - me) / r.value);
    re > r.value - me && (ne = ne + 1), Ue < me && (ie = ie - 1);
    const Se = Math.max(0, ne), We = Math.min(ie, Te), Ae = n(
      b.value,
      Se,
      We,
      tt,
      ee
    ), Rt = document.querySelectorAll(`.file-item-${w}[data-key]`), gn = /* @__PURE__ */ new Map();
    Rt.forEach((Ge) => {
      const dt = Ge.getAttribute("data-key");
      dt && gn.set(dt, Ge);
    });
    const Bt = [];
    if (Ae.forEach((Ge) => {
      const dt = a(Ge);
      gn.get(dt) || Bt.push(dt);
    }), Bt.length > 0) {
      const Ge = h.selectionMode || "multiple";
      _.selectMultiple(Bt, Ge);
    }
  }, T = (z) => {
    W(z), C(z), A(z), _.setSelectedCount(k.value?.size || 0), g.value = !1;
  }, D = () => {
    let z = [".scroller-" + w];
    if (c?.value) {
      const { viewport: x } = c.value.elements();
      x && (z = x);
    }
    d.value = new Io({
      selectables: [
        ".file-item-" + w + ":not(.vf-explorer-item--unselectable):not(.vf-explorer-item--no-select)"
      ],
      boundaries: z,
      selectionContainerClass: "selection-area-container",
      behaviour: {
        overlap: "invert",
        intersect: "touch",
        startThreshold: 0,
        triggers: [0],
        scrolling: {
          speedDivider: 10,
          manualSpeed: 750,
          startScrollMargins: { x: 0, y: 10 }
        }
      },
      features: {
        touch: !0,
        range: !0,
        deselectOnBlur: !0,
        singleTap: {
          allow: !1,
          intersect: "native"
        }
      }
    }), d.value.on("beforestart", L), d.value.on("start", Y), d.value.on("move", Q), d.value.on("stop", T);
  }, N = () => {
    d.value && (d.value.destroy(), d.value = null);
  }, J = () => {
    d.value && (Array.from(
      k.value ?? /* @__PURE__ */ new Set()
    ).forEach((x) => {
      S(x) || _.deselect(x);
    }), N(), D());
  }, ce = (z) => {
    f.value && (d.value?.clearSelection(), B(), f.value = !1);
    const x = z;
    !m.value.size && !f.value && !x?.ctrlKey && !x?.metaKey && (_.clearSelection(), d.value?.clearSelection());
  };
  return we(() => {
    const z = (x) => {
      !x.buttons && g.value && (g.value = !1);
    };
    document.addEventListener("dragleave", z), Pe(() => {
      document.removeEventListener("dragleave", z);
    });
  }), {
    explorerId: w,
    isDragging: g,
    initializeSelectionArea: D,
    updateSelectionArea: J,
    handleContentClick: ce
  };
}
function s_(s) {
  const e = (n) => {
    if (!n)
      return { typeAllowed: !1, mimeAllowed: !1 };
    const a = s.selectionFilterType, d = s.selectionFilterMimeIncludes, r = !a || a === "both" || a === "files" && n.type === "file" || a === "dirs" && n.type === "dir";
    let l = !0;
    return d && Array.isArray(d) && d.length > 0 && (n.type === "dir" ? l = !0 : n.mime_type ? l = d.some((c) => n.mime_type.startsWith(c)) : l = !1), { typeAllowed: r, mimeAllowed: l };
  };
  return {
    isItemSelectable: e,
    canSelectItem: (n) => {
      const { typeAllowed: a, mimeAllowed: d } = e(n);
      return a && d;
    }
  };
}
function i_(s) {
  const e = (n) => ({
    item: n,
    defaultPrevented: !1,
    preventDefault() {
      this.defaultPrevented = !0;
    }
  });
  return {
    createCancelableEvent: e,
    openItem: (n, a, d) => {
      const r = e(n);
      if (n.type === "file" && a) {
        if (s.emitter.emit("vf-file-dclick", r), r.defaultPrevented) return;
      } else if (n.type === "dir" && d && (s.emitter.emit("vf-folder-dclick", r), r.defaultPrevented))
        return;
      const l = s.contextMenuItems?.find((c) => c.show(s, {
        items: [n],
        target: n,
        searchQuery: ""
      }));
      l && l.action(s, [n]);
    }
  };
}
function a_(s, e, t, n, a, d, r) {
  const l = s.fs, { canSelectItem: c } = s_(s), { openItem: v } = i_(s), w = (m) => {
    const g = m.target?.closest(".file-item-" + e);
    if (!g) return null;
    const f = String(g.getAttribute("data-key")), F = t.value?.find((C) => ke(C) === f);
    return { key: f, item: F };
  }, h = () => {
    const m = n.value;
    return t.value?.filter((g) => m?.has(ke(g))) || [];
  };
  return {
    handleItemClick: (m) => {
      const g = w(m);
      if (!g) return;
      const { key: f, item: F } = g, C = m;
      if (!c(F)) {
        F?.type === "dir" && (l.clearSelection(), a.value?.clearSelection(!0, !0), l.setSelectedCount(0));
        return;
      }
      const A = s.selectionMode || "multiple";
      !C?.ctrlKey && !C?.metaKey && (m.type !== "touchstart" || !l.isSelected(f)) && (l.clearSelection(), a.value?.clearSelection(!0, !0)), a.value?.resolveSelectables(), m.type === "touchstart" && l.isSelected(f) ? l.select(f, A) : l.toggleSelect(f, A), l.setSelectedCount(n.value?.size || 0);
    },
    handleItemDblClick: (m) => {
      const g = w(m);
      if (!g) return;
      const { item: f } = g;
      f && (f.type === "file" && !c(f) || v(f, d, r));
    },
    handleItemContextMenu: (m) => {
      m.preventDefault(), m.stopPropagation();
      const g = w(m);
      if (!g) return;
      const { key: f, item: F } = g;
      c(F) && (n.value?.has(f) || (l.clearSelection(), l.select(f)), s.emitter.emit("vf-contextmenu-show", {
        event: m,
        items: h(),
        target: F
      }));
    },
    handleContentContextMenu: (m) => {
      m.preventDefault(), s.emitter.emit("vf-contextmenu-show", { event: m, items: h() });
    },
    getSelectedItems: h
  };
}
function l_(s, e) {
  const t = M(null);
  return we(() => {
    if (_t.plugin([Mo]), s.value) {
      const n = _t(
        s.value,
        {
          scrollbars: { theme: "vf-scrollbars-theme" }
        },
        {
          initialized: (a) => {
            t.value = a;
            const { viewport: d } = a.elements();
            d && d.addEventListener("scroll", e);
          },
          updated: (a) => {
            const { viewport: d } = a.elements();
          }
        }
      );
      t.value = n;
    }
  }), Pe(() => {
    if (t.value) {
      const { viewport: n } = t.value.elements();
      n && n.removeEventListener("scroll", e), t.value.destroy(), t.value = null;
    }
  }), {
    osInstance: t
  };
}
const r_ = 4, d_ = 600;
function c_(s, e) {
  const t = M(null), n = /* @__PURE__ */ new WeakMap(), a = /* @__PURE__ */ new WeakMap();
  return we(() => {
    s.value && (t.value = new qt({
      elements_selector: ".lazy",
      container: s.value,
      // Put the placeholder back so the browser doesn't show a broken-image
      // icon (the "?" thumbnail) while we retry.
      restore_on_error: !0,
      callback_error: (d, r) => {
        const l = (n.get(d) ?? 0) + 1;
        if (l > r_) return;
        n.set(d, l);
        const c = d_ * 2 ** (l - 1) + Math.random() * 250, v = a.get(d);
        v && clearTimeout(v), a.set(
          d,
          setTimeout(() => {
            d.isConnected && (qt.resetStatus(d), r.update());
          }, c)
        );
      }
    })), e?.emitter && e.emitter.on("vf-refresh-thumbnails", () => {
      t.value && t.value.update();
    });
  }), ko(() => {
    t.value && t.value.update();
  }), Pe(() => {
    t.value && (t.value.destroy(), t.value = null);
  }), {
    vfLazyLoad: t
  };
}
const u_ = { class: "vuefinder__explorer__container" }, v_ = {
  key: 0,
  class: "vuefinder__linear-loader"
}, f_ = /* @__PURE__ */ le({
  __name: "Explorer",
  props: {
    onFileDclick: { type: Function },
    onFolderDclick: { type: Function }
  },
  setup(s) {
    const e = s, t = ae(), n = $t(t, ["vuefinder__drag-over"]), a = st("dragImage"), d = ft(null), r = st("scrollContainer"), l = st("scrollContent"), c = t.fs, v = t.config, w = oe(v.state), h = oe(c.sortedFiles), _ = oe(c.selectedKeys), k = oe(c.loading), b = (G) => _.value?.has(G) ?? !1, $ = R(() => {
      if (w.value?.view === "grid") {
        const be = w.value?.gridItemHeight ?? 80, Ie = w.value?.gridItemGap ?? 8;
        return be + Ie * 2;
      }
      const se = w.value?.listItemHeight ?? 32, fe = w.value?.listItemGap ?? 2;
      return se + fe * 2;
    }), m = R(() => {
      if (w.value?.view === "grid") {
        const se = w.value?.gridItemWidth ?? 96, fe = w.value?.gridItemGap ?? 8;
        return se + fe * 2;
      }
      return 104;
    }), g = R(() => w.value?.view === "grid" ? (w.value?.gridItemGap ?? 8) * 2 : 0), { t: f } = t.i18n, {
      itemsPerRow: F,
      totalHeight: C,
      visibleRows: A,
      handleScroll: S,
      getRowItems: L,
      getItemsInRange: H,
      updateItemsPerRow: Y
    } = n_(
      R(() => h.value ?? []),
      {
        scrollContainer: r,
        itemWidth: m,
        rowHeight: $,
        overscan: 2,
        containerPadding: g,
        lockItemsPerRow: R(() => w.value.view === "list")
      }
    ), { osInstance: Q } = l_(r, S), { explorerId: B, isDragging: W, initializeSelectionArea: T, updateSelectionArea: D, handleContentClick: N } = o_({
      itemsPerRow: F,
      totalHeight: C,
      getItemsInRange: H,
      getKey: (G) => ke(G),
      selectionObject: d,
      rowHeight: $,
      itemWidth: m,
      osInstance: Q
    }), J = M(null), ce = (G) => {
      if (!G || !J.value) return !1;
      const se = _.value?.has(J.value) ?? !1;
      return W.value && (se ? _.value?.has(G) ?? !1 : G === J.value);
    };
    pe(
      () => v.get("view"),
      (G) => {
        G === "list" ? F.value = 1 : Y();
      },
      { immediate: !0 }
    ), pe(F, (G) => {
      v.get("view") === "list" && G !== 1 && (F.value = 1);
    });
    const z = (G) => h.value?.[G];
    c_(r, t);
    const { handleItemClick: x, handleItemDblClick: U, handleItemContextMenu: E, handleContentContextMenu: V } = a_(
      t,
      B,
      h,
      _,
      d,
      e.onFileDclick,
      e.onFolderDclick
    );
    we(() => {
      const G = () => {
        d.value || T(), d.value && d.value.on("beforestart", ({ event: se }) => {
          const fe = se?.target === l.value;
          if (!se?.metaKey && !se?.ctrlKey && !se?.altKey && !fe)
            return !1;
        });
      };
      if (Q.value)
        G();
      else {
        const se = setInterval(() => {
          Q.value && (clearInterval(se), G());
        }, 50);
        setTimeout(() => {
          clearInterval(se), d.value || G();
        }, 500);
      }
      pe(() => [t.selectionFilterType, t.selectionFilterMimeIncludes], D, {
        deep: !0
      });
    });
    const I = (G) => {
      if (!(t.features?.move ?? !1) || G.altKey || G.ctrlKey || G.metaKey)
        return G.preventDefault(), !1;
      W.value = !0;
      const fe = G.target?.closest(
        ".file-item-" + B
      );
      if (J.value = fe ? String(fe.dataset.key) : null, G.dataTransfer && J.value) {
        G.dataTransfer.setDragImage(a.value, 0, 15), G.dataTransfer.effectAllowed = "all", G.dataTransfer.dropEffect = "copy";
        const be = _.value?.has(J.value) ? Array.from(_.value) : [J.value];
        G.dataTransfer.setData("items", JSON.stringify(be)), c.setDraggedItem(J.value);
      }
    }, O = () => {
      J.value = null;
    };
    let q = null, P = null;
    const j = (G) => {
      G.target?.closest(".file-item-" + B) || (P = G, q && clearTimeout(q), q = setTimeout(() => {
        P && (P.cancelable && P.preventDefault(), P.stopPropagation(), V(P)), P = null, q = null;
      }, 500));
    }, de = (G) => {
      q && (clearTimeout(q), q = null), P = null;
    }, me = (G) => {
      if (!P) return;
      const se = P.touches[0] || P.changedTouches[0], fe = G.touches[0] || G.changedTouches[0];
      if (se && fe) {
        const be = Math.abs(fe.clientX - se.clientX), Ie = Math.abs(fe.clientY - se.clientY);
        (be > 15 || Ie > 15) && (q && (clearTimeout(q), q = null), P = null);
      }
    };
    return (G, se) => (u(), p("div", u_, [
      i(w).view === "list" ? (u(), Z(t_, { key: 0 })) : K("", !0),
      o("div", {
        ref_key: "scrollContainer",
        ref: r,
        class: te(["vuefinder__explorer__selector-area", "scroller-" + i(B)])
      }, [
        i(v).get("loadingIndicator") === "linear" && i(k) ? (u(), p("div", v_)) : K("", !0),
        o("div", {
          ref_key: "scrollContent",
          ref: l,
          class: "scrollContent vuefinder__explorer__scroll-content",
          style: Ee({ height: `${i(C)}px`, position: "relative", width: "100%" }),
          onContextmenu: se[0] || (se[0] = ve(
            //@ts-ignore
            (...fe) => i(V) && i(V)(...fe),
            ["self", "prevent"]
          )),
          onClick: se[1] || (se[1] = ve(
            //@ts-ignore
            (...fe) => i(N) && i(N)(...fe),
            ["self"]
          )),
          onTouchstartCapture: ve(j, ["self"]),
          onTouchendCapture: ve(de, ["self"]),
          onTouchmoveCapture: ve(me, ["self"]),
          onTouchcancelCapture: ve(de, ["self"])
        }, [
          o("div", {
            ref_key: "dragImage",
            ref: a,
            class: "vuefinder__explorer__drag-item"
          }, [
            X(Ef, {
              count: J.value && i(_).has(J.value) ? i(_).size : 1
            }, null, 8, ["count"])
          ], 512),
          i(w).view === "grid" ? (u(!0), p(_e, { key: 0 }, ge(i(A), (fe) => (u(), Z(An, {
            key: fe,
            "row-index": fe,
            "row-height": $.value,
            view: "grid",
            "items-per-row": i(F),
            items: i(L)(i(h), fe),
            "show-thumbnails": i(w).showThumbnails,
            "is-dragging-item": ce,
            "is-selected": b,
            "drag-n-drop-events": (be) => i(n).events(be),
            "explorer-id": i(B),
            onClick: i(x),
            onDblclick: i(U),
            onContextmenu: i(E),
            onDragstart: I,
            onDragend: O
          }, {
            icon: ue((be) => [
              Me(G.$slots, "icon", Ne({ ref_for: !0 }, be))
            ]),
            _: 3
          }, 8, ["row-index", "row-height", "items-per-row", "items", "show-thumbnails", "drag-n-drop-events", "explorer-id", "onClick", "onDblclick", "onContextmenu"]))), 128)) : (u(!0), p(_e, { key: 1 }, ge(i(A), (fe) => (u(), Z(An, {
            key: fe,
            "row-index": fe,
            "row-height": $.value,
            view: "list",
            items: z(fe) ? [z(fe)] : [],
            "is-dragging-item": ce,
            "is-selected": b,
            "drag-n-drop-events": (be) => i(n).events(be),
            "explorer-id": i(B),
            onClick: i(x),
            onDblclick: i(U),
            onContextmenu: i(E),
            onDragstart: I,
            onDragend: O
          }, {
            icon: ue((be) => [
              Me(G.$slots, "icon", Ne({ ref_for: !0 }, be))
            ]),
            _: 3
          }, 8, ["row-index", "row-height", "items", "drag-n-drop-events", "explorer-id", "onClick", "onDblclick", "onContextmenu"]))), 128))
        ], 36)
      ], 2)
    ]));
  }
}), __ = ["href", "download"], p_ = { class: "vuefinder__context-menu__action vuefinder__context-menu__action--parent" }, m_ = { class: "vuefinder__context-menu vuefinder__context-menu__submenu" }, h_ = ["onClick"], g_ = ["onClick"], y_ = /* @__PURE__ */ le({
  __name: "ContextMenu",
  setup(s) {
    const e = ae(), t = M(null), n = M([]);
    let a = null, d = null, r = null, l = [], c = null;
    const v = Et({
      active: !1,
      items: [],
      positions: {}
    });
    e.emitter.on("vf-context-selected", (k) => {
      n.value = k;
    });
    const w = (k) => k.link(e, n.value), h = (k) => {
      e.emitter.emit("vf-contextmenu-hide"), k.action(e, n.value);
    };
    e.emitter.on("vf-contextmenu-show", (k) => {
      const { event: b, items: $, target: m = null } = k || {};
      v.items = (e.contextMenuItems || []).filter((g) => g.show(e, {
        items: $,
        target: m
      })).sort((g, f) => {
        const F = g.order ?? 1 / 0, C = f.order ?? 1 / 0;
        return F - C;
      }), m ? $.length > 1 && $.some((g) => g.path === m.path) ? e.emitter.emit("vf-context-selected", $) : e.emitter.emit("vf-context-selected", [m]) : e.emitter.emit("vf-context-selected", []), _(b);
    }), e.emitter.on("vf-contextmenu-hide", () => {
      v.active = !1, a && (a(), a = null), r && (l.forEach((k) => {
        k === window ? window.removeEventListener("scroll", r, !0) : k.removeEventListener("scroll", r, !0);
      }), r = null, l = []), c && (document.removeEventListener("mousedown", c, !0), document.removeEventListener("touchstart", c, !0), c = null), d = null, v.positions = {};
    });
    const _ = async (k) => {
      a && (a(), a = null);
      const $ = ((S) => {
        if ("clientX" in S && "clientY" in S)
          return { x: S.clientX, y: S.clientY };
        const L = "touches" in S && S.touches[0] || "changedTouches" in S && S.changedTouches[0];
        return L ? { x: L.clientX, y: L.clientY } : { x: 0, y: 0 };
      })(k);
      if (d = {
        getBoundingClientRect: () => ({
          width: 0,
          height: 0,
          x: $.x,
          y: $.y,
          top: $.y,
          left: $.x,
          right: $.x,
          bottom: $.y
        })
      }, v.positions = {
        position: "fixed",
        zIndex: "10001",
        opacity: "0",
        visibility: "hidden",
        left: "-9999px",
        top: "-9999px"
      }, v.active = !0, await De(), !t.value || !d) return;
      await new Promise((S) => {
        requestAnimationFrame(() => {
          requestAnimationFrame(S);
        });
      });
      const m = [
        pt(8),
        mt({
          padding: 16,
          fallbackPlacements: ["left-start", "right-end", "left-end", "top-start", "bottom-start"]
        }),
        ht({ padding: 16 })
      ];
      let g = 0, f = 0;
      try {
        const S = await it(d, t.value, {
          placement: "right-start",
          strategy: "fixed",
          middleware: m
        });
        g = S.x, f = S.y;
      } catch (S) {
        console.warn("[ContextMenu] Floating UI initial positioning error:", S);
        return;
      }
      v.positions = {
        position: "fixed",
        zIndex: "10001",
        left: `${g}px`,
        top: `${f}px`,
        opacity: "0",
        visibility: "visible",
        transform: "translateY(-8px)",
        transition: "opacity 150ms ease-out, transform 150ms ease-out"
      }, requestAnimationFrame(() => {
        t.value && (v.positions = {
          ...v.positions,
          opacity: "1",
          transform: "translateY(0)"
        });
      });
      const C = ((S) => {
        const L = [];
        let H = S;
        for (; H && H !== document.body && H !== document.documentElement; ) {
          const Y = window.getComputedStyle(H), Q = Y.overflow + Y.overflowX + Y.overflowY;
          (Q.includes("scroll") || Q.includes("auto")) && L.push(H), H = H.parentElement;
        }
        return L;
      })(t.value);
      l = [window, ...C], r = () => {
        v.active && e.emitter.emit("vf-contextmenu-hide");
      };
      const A = r;
      A && l.forEach((S) => {
        S === window ? window.addEventListener("scroll", A, !0) : S.addEventListener("scroll", A, !0);
      }), c = (S) => {
        if (!v.active) return;
        const L = S.target;
        if (!L || t.value && t.value.contains(L))
          return;
        const H = e.root;
        H && H.contains(L) || e.emitter.emit("vf-contextmenu-hide");
      }, setTimeout(() => {
        c && (document.addEventListener("mousedown", c, !0), document.addEventListener("touchstart", c, !0));
      }, 100), setTimeout(() => {
        if (!(!t.value || !d))
          try {
            a = Qt(d, t.value, async () => {
              if (!(!d || !t.value))
                try {
                  const { x: S, y: L } = await it(d, t.value, {
                    placement: "right-start",
                    strategy: "fixed",
                    middleware: m
                  });
                  v.positions = {
                    ...v.positions,
                    left: `${S}px`,
                    top: `${L}px`
                  };
                } catch (S) {
                  console.warn("Floating UI positioning error:", S);
                }
            });
          } catch (S) {
            console.warn("Floating UI autoUpdate setup error:", S), a = null;
          }
      }, 200);
    };
    return Pe(() => {
      a && (a(), a = null), r && (l.forEach((k) => {
        k === window ? window.removeEventListener("scroll", r, !0) : k.removeEventListener("scroll", r, !0);
      }), r = null, l = []), c && (document.removeEventListener("mousedown", c, !0), document.removeEventListener("touchstart", c, !0), c = null), d = null;
    }), (k, b) => he((u(), p("ul", {
      ref_key: "contextmenu",
      ref: t,
      class: te([{
        "vuefinder__context-menu--active": v.active,
        "vuefinder__context-menu--inactive": !v.active
      }, "vuefinder__context-menu"]),
      style: Ee(v.positions)
    }, [
      (u(!0), p(_e, null, ge(v.items, ($) => (u(), p("li", {
        key: $.title,
        class: te(["vuefinder__context-menu__item", { "vuefinder__context-menu__item--has-children": $.children?.length }])
      }, [
        $.link ? (u(), p("a", {
          key: 0,
          class: "vuefinder__context-menu__link",
          target: "_blank",
          href: w($),
          download: w($),
          onClick: b[0] || (b[0] = (m) => i(e).emitter.emit("vf-contextmenu-hide"))
        }, [
          o("span", null, y($.title(i(e).i18n)), 1)
        ], 8, __)) : $.children?.length ? (u(), p(_e, { key: 1 }, [
          o("div", p_, [
            o("span", null, y($.title(i(e).i18n)), 1),
            b[1] || (b[1] = o("svg", {
              class: "vuefinder__context-menu__chevron",
              viewBox: "0 0 16 16",
              fill: "currentColor",
              "aria-hidden": "true"
            }, [
              o("path", { d: "M6 4l4 4-4 4z" })
            ], -1))
          ]),
          o("ul", m_, [
            (u(!0), p(_e, null, ge($.children, (m) => (u(), p("li", {
              key: m.id,
              class: "vuefinder__context-menu__item"
            }, [
              o("div", {
                class: "vuefinder__context-menu__action",
                onClick: (g) => h(m)
              }, [
                o("span", null, y(m.title(i(e).i18n)), 1)
              ], 8, h_)
            ]))), 128))
          ])
        ], 64)) : (u(), p("div", {
          key: 2,
          class: "vuefinder__context-menu__action",
          onClick: (m) => h($)
        }, [
          o("span", null, y($.title(i(e).i18n)), 1)
        ], 8, g_))
      ], 2))), 128))
    ], 6)), [
      [qe, v.active]
    ]);
  }
}), w_ = { class: "vuefinder__status-bar__wrapper" }, b_ = { class: "vuefinder__status-bar__storage" }, k_ = ["title"], $_ = { class: "vuefinder__status-bar__storage-icon" }, x_ = ["value"], S_ = ["value"], C_ = { class: "vuefinder__status-bar__info space-x-2" }, F_ = { key: 0 }, T_ = { key: 1 }, E_ = {
  key: 0,
  class: "vuefinder__status-bar__size"
}, P_ = { class: "vuefinder__status-bar__actions" }, D_ = /* @__PURE__ */ le({
  __name: "Statusbar",
  setup(s) {
    const e = ae(), { t } = e.i18n, n = e.fs, a = oe(n.sortedFiles), d = oe(n.path), r = oe(n.selectedCount), l = oe(n.storages), c = oe(n.selectedItems), v = oe(n.path), w = (m) => {
      const g = m.target.value;
      e.adapter.open(g + "://");
    }, h = R(() => !c.value || c.value.length === 0 ? 0 : c.value.reduce((m, g) => m + (g.file_size || 0), 0)), _ = R(() => l.value), k = R(() => a.value), b = R(() => r.value || 0), $ = R(() => c.value || []);
    return (m, g) => (u(), p("div", w_, [
      o("div", b_, [
        o("div", {
          class: "vuefinder__status-bar__storage-container",
          title: i(t)("Storage")
        }, [
          o("div", $_, [
            X(i(ln))
          ]),
          o("select", {
            name: "vuefinder-media-selector",
            value: i(d).storage,
            class: "vuefinder__status-bar__storage-select",
            tabindex: "-1",
            onChange: w
          }, [
            (u(!0), p(_e, null, ge(_.value, (f) => (u(), p("option", {
              key: f,
              value: f
            }, y(f), 9, S_))), 128))
          ], 40, x_),
          g[0] || (g[0] = o("span", {
            class: "vuefinder__status-bar__storage-caret",
            "aria-hidden": "true"
          }, null, -1))
        ], 8, k_),
        o("div", C_, [
          b.value === 0 ? (u(), p("span", F_, y(k.value.length) + " " + y(i(t)("items")), 1)) : (u(), p("span", T_, [
            ye(y(b.value) + " " + y(i(t)("selected")) + " ", 1),
            h.value ? (u(), p("span", E_, y(i(e).filesize(h.value)), 1)) : K("", !0)
          ]))
        ])
      ]),
      o("div", P_, [
        Me(m.$slots, "actions", {
          path: i(v).path,
          count: b.value || 0,
          selected: $.value
        })
      ])
    ]));
  }
}), M_ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  class: "h-5 w-5",
  viewBox: "0 0 24 24"
};
function I_(s, e) {
  return u(), p("svg", M_, [...e[0] || (e[0] = [
    o("path", {
      fill: "none",
      d: "M0 0h24v24H0z"
    }, null, -1),
    o("path", { d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2m3.6 5.2a1 1 0 0 0-1.4.2L12 10.333 9.8 7.4a1 1 0 1 0-1.6 1.2l2.55 3.4-2.55 3.4a1 1 0 1 0 1.6 1.2l2.2-2.933 2.2 2.933a1 1 0 0 0 1.6-1.2L13.25 12l2.55-3.4a1 1 0 0 0-.2-1.4" }, null, -1)
  ])]);
}
const A_ = { render: I_ };
function po(s, e) {
  const t = s.findIndex((n) => n.path === e.path);
  t > -1 ? s[t] = e : s.push(e);
}
const O_ = { class: "vuefinder__folder-loader-indicator" }, L_ = {
  key: 1,
  class: "vuefinder__folder-loader-indicator--icon"
}, mo = /* @__PURE__ */ le({
  __name: "FolderLoaderIndicator",
  props: /* @__PURE__ */ $o({
    storage: {},
    path: {}
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(s) {
    const e = s, t = ae(), n = zn(s, "modelValue"), a = M(!1);
    pe(
      () => n.value,
      () => d()
    );
    const d = async () => {
      a.value = !0;
      try {
        const r = await t.adapter.list(e.path);
        po(t.treeViewData, { path: e.path, entries: r.files });
      } catch (r) {
        Fe(r, "Failed to fetch subfolders");
      } finally {
        a.value = !1;
      }
    };
    return (r, l) => (u(), p("div", O_, [
      a.value ? (u(), Z(i(Ot), {
        key: 0,
        class: "vuefinder__folder-loader-indicator--loading"
      })) : (u(), p("div", L_, [
        n.value ? (u(), Z(i(It), {
          key: 0,
          class: "vuefinder__folder-loader-indicator--minus"
        })) : K("", !0),
        n.value ? K("", !0) : (u(), Z(i(Mt), {
          key: 1,
          class: "vuefinder__folder-loader-indicator--plus"
        }))
      ]))
    ]));
  }
}), R_ = { key: 0 }, B_ = { class: "vuefinder__treesubfolderlist__no-folders" }, z_ = {
  key: 0,
  class: "vuefinder__treesubfolderlist__item-content"
}, V_ = ["onClick"], U_ = ["title", "data-tree-entry-path", "data-tree-entry-type", "aria-expanded", "onDblclick", "onClick"], N_ = { class: "vuefinder__treesubfolderlist__item-icon" }, H_ = ["title"], j_ = {
  key: 1,
  class: "vuefinder__treesubfolderlist__item-content vuefinder__treesubfolderlist__item-content--file"
}, K_ = ["title", "data-tree-entry-path", "data-tree-entry-type", "aria-label", "onClick", "onDblclick", "onKeydown"], q_ = { class: "vuefinder__treesubfolderlist__item-icon" }, W_ = ["title"], G_ = {
  key: 2,
  class: "vuefinder__treesubfolderlist__subfolder"
}, Y_ = {
  key: 1,
  class: "vuefinder__treesubfolderlist__more-note"
}, X_ = /* @__PURE__ */ le({
  __name: "TreeSubfolderList",
  props: {
    storage: {},
    path: {}
  },
  setup(s) {
    const e = ae(), t = e.fs, n = $t(e, ["vuefinder__drag-over"]), a = M({}), d = e.config, r = oe(d.state), { t: l } = e.i18n, c = oe(t.path), v = s, w = M(null), h = M(50), _ = /* @__PURE__ */ new Map();
    we(() => {
      v.path === v.storage + "://" && w.value && _t(w.value, {
        scrollbars: {
          theme: "vf-scrollbars-theme"
        }
      });
    });
    const k = R(() => {
      const Y = e.treeViewData.find((B) => B.path === v.path)?.entries || [], Q = r.value.showFilesInTree ? Y : Y.filter((B) => B.type === "dir");
      return Q.length > h.value ? Q.slice(0, h.value) : Q;
    }), b = R(() => {
      const Y = e.treeViewData.find((Q) => Q.path === v.path)?.entries || [];
      return r.value.showFilesInTree ? Y.length : Y.filter((Q) => Q.type === "dir").length;
    }), $ = R(() => b.value > h.value), m = R(() => `${v.storage}://`), g = R(() => r.value.showFilesInTree ? "No items" : "No folders"), f = (H, Y) => H === Y || H.startsWith(`${Y}/`);
    pe(
      k,
      (H) => {
        const Y = r.value.expandTreeByDefault && v.path === m.value, Q = r.value.expandedTreePaths || [];
        H.forEach((B) => {
          if (B.type !== "dir")
            return;
          const W = Q.some(
            (T) => f(T, B.path)
          );
          (Y || W) && a.value[B.path] === void 0 && (a.value[B.path] = !0);
        });
      },
      { immediate: !0 }
    );
    const F = () => {
      h.value += 50;
    }, C = (H) => {
      H.type === "file" && e.emitter.emit("vf-tree-file-click", H);
    }, A = (H) => {
      if (H.type !== "file")
        return;
      const Y = ke(H);
      if (_.has(Y))
        return;
      const Q = setTimeout(() => {
        _.delete(Y), C(H);
      }, 250);
      _.set(Y, Q);
    }, S = (H) => {
      const Y = ke(H), Q = _.get(Y);
      Q && (clearTimeout(Q), _.delete(Y));
    }, L = (H, Y) => {
      H.key !== "Enter" && H.key !== " " || (H.preventDefault(), S(Y), C(Y));
    };
    return rt(() => {
      _.forEach((H) => clearTimeout(H)), _.clear();
    }), (H, Y) => {
      const Q = Bn("TreeSubfolderList", !0);
      return u(), p("ul", {
        ref_key: "parentSubfolderList",
        ref: w,
        class: "vuefinder__treesubfolderlist__container"
      }, [
        k.value.length ? K("", !0) : (u(), p("li", R_, [
          o("div", B_, y(i(l)(g.value)), 1)
        ])),
        (u(!0), p(_e, null, ge(k.value, (B) => (u(), p("li", {
          key: i(ke)(B),
          class: "vuefinder__treesubfolderlist__item"
        }, [
          B.type === "dir" ? (u(), p("div", z_, [
            o("div", {
              class: "vuefinder__treesubfolderlist__item-toggle",
              onClick: (W) => a.value[B.path] = !a.value[B.path]
            }, [
              X(mo, {
                modelValue: a.value[B.path],
                "onUpdate:modelValue": (W) => a.value[B.path] = W,
                storage: s.storage,
                path: B.path
              }, null, 8, ["modelValue", "onUpdate:modelValue", "storage", "path"])
            ], 8, V_),
            o("div", Ne({
              class: "vuefinder__treesubfolderlist__item-link",
              title: B.path,
              "data-tree-entry-path": B.path,
              "data-tree-entry-type": B.type,
              role: "treeitem",
              "aria-expanded": !!a.value[B.path]
            }, Ye(i(n).events(B), !0), {
              onDblclick: (W) => a.value[B.path] = !a.value[B.path],
              onClick: (W) => i(e).adapter.open(B.path)
            }), [
              o("div", N_, [
                i(c)?.path === B.path ? (u(), Z(i(At), {
                  key: 0,
                  class: "vuefinder__item-icon__folder--open"
                })) : (u(), Z(i(Re), {
                  key: 1,
                  class: "vuefinder__item-icon__folder"
                }))
              ]),
              o("div", {
                class: te(["vuefinder__treesubfolderlist__item-text", {
                  "vuefinder__treesubfolderlist__item-text--active": i(c).path === B.path
                }]),
                title: B.basename
              }, y(B.basename), 11, H_)
            ], 16, U_)
          ])) : (u(), p("div", j_, [
            Y[0] || (Y[0] = o("div", {
              class: "vuefinder__treesubfolderlist__item-toggle vuefinder__treesubfolderlist__item-toggle--spacer",
              "aria-hidden": "true"
            }, null, -1)),
            o("div", Ne({
              class: "vuefinder__treesubfolderlist__item-link vuefinder__treesubfolderlist__item-link--file",
              title: B.basename,
              "data-tree-entry-path": B.path,
              "data-tree-entry-type": B.type,
              role: "treeitem",
              tabindex: "0",
              "aria-label": B.basename
            }, Ye(i(n).events(B), !0), {
              onClick: ve((W) => A(B), ["stop"]),
              onDblclick: ve((W) => S(B), ["stop", "prevent"]),
              onKeydown: (W) => L(W, B)
            }), [
              o("div", q_, [
                X(Xt, {
                  item: B,
                  small: "",
                  view: "list"
                }, null, 8, ["item"])
              ]),
              o("div", {
                class: "vuefinder__treesubfolderlist__item-text",
                title: B.basename
              }, y(B.basename), 9, W_)
            ], 16, K_)
          ])),
          B.type === "dir" ? (u(), p("div", G_, [
            he(X(Q, {
              storage: v.storage,
              path: B.path
            }, null, 8, ["storage", "path"]), [
              [qe, a.value[B.path]]
            ])
          ])) : K("", !0)
        ]))), 128)),
        $.value ? (u(), p("li", Y_, [
          o("div", {
            class: "vuefinder__treesubfolderlist__load-more",
            onClick: F
          }, y(i(l)("load more")), 1)
        ])) : K("", !0)
      ], 512);
    };
  }
}), Q_ = /* @__PURE__ */ le({
  __name: "TreeStorageItem",
  props: {
    storage: {}
  },
  setup(s) {
    const e = ae(), t = e.fs, n = e.config, a = s, d = oe(n.state), r = R(() => {
      const k = d.value.expandedTreePaths || [], b = `${a.storage}://`;
      return k.some(
        ($) => $ === b || $.startsWith(`${b}`)
      );
    }), l = M(d.value.expandTreeByDefault || r.value), c = $t(e, ["vuefinder__drag-over"]), v = oe(t.path), w = R(() => a.storage === v.value?.storage);
    pe(
      () => ({
        expandTreeByDefault: d.value.expandTreeByDefault,
        hasExpandedPathInStorage: r.value
      }),
      (k) => {
        (k.expandTreeByDefault || k.hasExpandedPathInStorage) && (l.value = !0);
      }
    );
    const h = {
      storage: a.storage,
      path: a.storage + "://",
      dir: a.storage + "://",
      type: "dir",
      basename: a.storage,
      extension: "",
      file_size: null,
      last_modified: null,
      mime_type: null,
      visibility: "public"
    };
    function _(k) {
      k === v.value?.storage ? l.value = !l.value : e.adapter.open(k + "://");
    }
    return (k, b) => (u(), p(_e, null, [
      o("div", {
        class: "vuefinder__treestorageitem__header",
        onClick: b[2] || (b[2] = ($) => _(s.storage))
      }, [
        o("div", Ne({
          class: ["vuefinder__treestorageitem__info", w.value ? "vuefinder__treestorageitem__info--active" : ""]
        }, Ye(i(c).events(h), !0)), [
          o("div", {
            class: te(["vuefinder__treestorageitem__icon", w.value ? "vuefinder__treestorageitem__icon--active" : ""])
          }, [
            X(i(ln))
          ], 2),
          o("div", null, y(s.storage), 1)
        ], 16),
        o("div", {
          class: "vuefinder__treestorageitem__loader",
          onClick: b[1] || (b[1] = ve(($) => l.value = !l.value, ["stop"]))
        }, [
          X(mo, {
            modelValue: l.value,
            "onUpdate:modelValue": b[0] || (b[0] = ($) => l.value = $),
            storage: s.storage,
            path: s.storage + "://"
          }, null, 8, ["modelValue", "storage", "path"])
        ])
      ]),
      he(X(X_, {
        storage: s.storage,
        path: s.storage + "://",
        class: "vuefinder__treestorageitem__subfolder"
      }, null, 8, ["storage", "path"]), [
        [qe, l.value]
      ])
    ], 64));
  }
}), J_ = { class: "vuefinder__folder-indicator" }, Z_ = { class: "vuefinder__folder-indicator--icon" }, ep = /* @__PURE__ */ le({
  __name: "FolderIndicator",
  props: {
    modelValue: { type: Boolean },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(s) {
    const e = zn(s, "modelValue");
    return (t, n) => (u(), p("div", J_, [
      o("div", Z_, [
        e.value ? (u(), Z(i(It), {
          key: 0,
          class: "vuefinder__folder-indicator--minus"
        })) : K("", !0),
        e.value ? K("", !0) : (u(), Z(i(Mt), {
          key: 1,
          class: "vuefinder__folder-indicator--plus"
        }))
      ])
    ]));
  }
}), tp = {
  key: 0,
  class: "vuefinder__treeview__header"
}, np = { class: "vuefinder__treeview__pinned-label" }, op = { class: "vuefinder__treeview__pin-text text-nowrap" }, sp = {
  key: 0,
  class: "vuefinder__treeview__pinned-list"
}, ip = ["onClick"], ap = ["title"], lp = ["onClick"], rp = { key: 0 }, dp = { class: "vuefinder__treeview__no-pinned" }, cp = /* @__PURE__ */ le({
  __name: "TreeView",
  setup(s) {
    const e = ae(), { enabled: t } = Ve(), { t: n } = e.i18n, { getStore: a, setStore: d } = e.storage, r = e.fs, l = e.config, c = oe(l.state), v = oe(r.sortedFiles), w = oe(r.storages), h = R(() => w.value || []), _ = oe(r.path), k = $t(e, ["vuefinder__drag-over"]), b = M(190), $ = M(a("pinned-folders-opened", !0));
    pe($, (C) => d("pinned-folders-opened", C));
    const m = (C) => {
      const A = l.get("pinnedFolders");
      l.set("pinnedFolders", A.filter((S) => S.path !== C.path));
    }, g = (C) => {
      const A = C.clientX, S = C.target.parentElement;
      if (!S) return;
      const L = S.getBoundingClientRect().width;
      S.classList.remove("transition-[width]"), S.classList.add("transition-none");
      const H = (Q) => {
        b.value = L + Q.clientX - A, b.value < 50 && (b.value = 0, l.set("showTreeView", !1)), b.value > 50 && l.set("showTreeView", !0);
      }, Y = () => {
        const Q = S.getBoundingClientRect();
        b.value = Q.width, S.classList.add("transition-[width]"), S.classList.remove("transition-none"), window.removeEventListener("mousemove", H), window.removeEventListener("mouseup", Y);
      };
      window.addEventListener("mousemove", H), window.addEventListener("mouseup", Y);
    }, f = M(null);
    we(() => {
      f.value && _t(f.value, {
        overflow: {
          x: "hidden"
        },
        scrollbars: {
          theme: "vf-scrollbars-theme"
        }
      });
    });
    const F = (C, A) => {
      po(e.treeViewData, {
        path: A || "",
        entries: [...C]
      });
    };
    return pe(
      [v, () => _.value.path],
      ([C, A]) => F(C, A),
      { immediate: !0 }
    ), (C, A) => (u(), p(_e, null, [
      o("div", {
        class: te(["vuefinder__treeview__overlay", i(c).showTreeView ? "vuefinder__treeview__backdrop" : "hidden"]),
        onClick: A[0] || (A[0] = (S) => i(l).toggle("showTreeView"))
      }, null, 2),
      o("div", {
        style: Ee(
          i(c).showTreeView ? "min-width:100px;max-width:75%; width: " + b.value + "px" : "width: 0"
        ),
        class: "vuefinder__treeview__container"
      }, [
        o("div", {
          ref_key: "treeViewScrollElement",
          ref: f,
          class: "vuefinder__treeview__scroll"
        }, [
          i(t)("pinned") ? (u(), p("div", tp, [
            o("div", {
              class: "vuefinder__treeview__pinned-toggle",
              onClick: A[2] || (A[2] = (S) => $.value = !$.value)
            }, [
              o("div", np, [
                X(i(yt), { class: "vuefinder__treeview__pin-icon" }),
                o("div", op, y(i(n)("Pinned Folders")), 1)
              ]),
              X(ep, {
                modelValue: $.value,
                "onUpdate:modelValue": A[1] || (A[1] = (S) => $.value = S)
              }, null, 8, ["modelValue"])
            ]),
            $.value ? (u(), p("ul", sp, [
              (u(!0), p(_e, null, ge(i(c).pinnedFolders, (S) => (u(), p("li", {
                key: S.path,
                class: "vuefinder__treeview__pinned-item"
              }, [
                o("div", Ne({ class: "vuefinder__treeview__pinned-folder" }, Ye(i(k).events(S), !0), {
                  onClick: (L) => i(e).adapter.open(S.path)
                }), [
                  i(_).path !== S.path ? (u(), Z(i(Re), {
                    key: 0,
                    class: "vuefinder__treeview__folder-icon vuefinder__item-icon__folder"
                  })) : K("", !0),
                  i(_).path === S.path ? (u(), Z(i(At), {
                    key: 1,
                    class: "vuefinder__item-icon__folder--open vuefinder__treeview__open-folder-icon"
                  })) : K("", !0),
                  o("div", {
                    title: S.path,
                    class: te(["vuefinder__treeview__folder-name", {
                      "vuefinder__treeview__folder-name--active": i(_).path === S.path
                    }])
                  }, y(S.basename), 11, ap)
                ], 16, ip),
                o("div", {
                  class: "vuefinder__treeview__remove-folder",
                  onClick: (L) => m(S)
                }, [
                  X(i(A_), { class: "vuefinder__treeview__remove-icon" })
                ], 8, lp)
              ]))), 128)),
              i(c).pinnedFolders.length ? K("", !0) : (u(), p("li", rp, [
                o("div", dp, y(i(n)("No folders pinned")), 1)
              ]))
            ])) : K("", !0)
          ])) : K("", !0),
          (u(!0), p(_e, null, ge(h.value, (S) => (u(), p("div", {
            key: S,
            class: "vuefinder__treeview__storage"
          }, [
            X(Q_, { storage: S }, null, 8, ["storage"])
          ]))), 128))
        ], 512),
        o("div", {
          class: "vuefinder__treeview__resize-handle",
          onMousedown: g
        }, null, 32)
      ], 4)
    ], 64));
  }
}), Ce = {
  new_folder: "new_folder",
  selectAll: "selectAll",
  pinFolder: "pinFolder",
  unpinFolder: "unpinFolder",
  delete: "delete",
  refresh: "refresh",
  preview: "preview",
  openAs: "openAs",
  openAsText: "openAsText",
  openAsImage: "openAsImage",
  open: "open",
  openDir: "openDir",
  download: "download",
  download_archive: "download_archive",
  archive: "archive",
  unarchive: "unarchive",
  rename: "rename",
  move: "move",
  copy: "copy",
  paste: "paste"
};
function up(s) {
  return s.items.length > 1 && s.items.some((e) => e.path === s.target?.path) ? "many" : s.target ? "one" : "none";
}
function $e(s) {
  const e = Object.assign(
    {
      needsSearchQuery: !1
    },
    s
  );
  return (t, n) => !(e.needsSearchQuery !== !!n.searchQuery || e.target !== void 0 && e.target !== up(n) || e.targetType !== void 0 && e.targetType !== n.target?.type || e.mimeType !== void 0 && e.mimeType !== n.target?.mime_type || e.feature !== void 0 && !(t.features[e.feature] ?? !1));
}
function vt(...s) {
  return (e, t) => s.some((n) => n(e, t));
}
function nt(...s) {
  return (e, t) => s.every((n) => n(e, t));
}
const ho = [
  {
    id: Ce.openDir,
    title: ({ t: s }) => s("Open containing folder"),
    action: (s, e) => {
      const t = e[0];
      t && s.adapter.open(t.dir);
    },
    show: $e({ target: "one", needsSearchQuery: !0 }),
    order: 10
  },
  {
    id: Ce.refresh,
    title: ({ t: s }) => s("Refresh"),
    action: (s) => {
      const e = s.fs;
      s.adapter.invalidateListQuery(e.path.get().path), s.adapter.open(e.path.get().path);
    },
    show: vt($e({ target: "none" }), $e({ target: "many" })),
    order: 20
  },
  {
    id: Ce.selectAll,
    title: ({ t: s }) => s("Select All"),
    action: (s) => {
      s.fs.selectAll(s.selectionMode || "multiple");
    },
    show: (s, e) => s.selectionMode === "multiple" && $e({ target: "none" })(s, e),
    order: 30
  },
  {
    id: Ce.new_folder,
    title: ({ t: s }) => s("New Folder"),
    action: (s) => s.modal.open(un),
    show: $e({ target: "none", feature: "newfolder" }),
    order: 40
  },
  {
    id: Ce.open,
    title: ({ t: s }) => s("Open"),
    action: (s, e) => {
      e[0] && s.adapter.open(e[0].path);
    },
    show: $e({ target: "one", targetType: "dir" }),
    order: 50
  },
  {
    id: Ce.pinFolder,
    title: ({ t: s }) => s("Pin Folder"),
    action: (s, e) => {
      const t = s.config, n = t.get("pinnedFolders"), a = n.concat(
        e.filter(
          (d) => n.findIndex((r) => r.path === d.path) === -1
        )
      );
      t.set("pinnedFolders", a);
    },
    show: nt($e({ target: "one", targetType: "dir", feature: "pinned" }), (s, e) => s.config.get("pinnedFolders").findIndex((a) => a.path === e.target?.path) === -1),
    order: 60
  },
  {
    id: Ce.unpinFolder,
    title: ({ t: s }) => s("Unpin Folder"),
    action: (s, e) => {
      const t = s.config, n = t.get("pinnedFolders");
      t.set(
        "pinnedFolders",
        n.filter(
          (a) => !e.find((d) => d.path === a.path)
        )
      );
    },
    show: nt($e({ target: "one", targetType: "dir", feature: "pinned" }), (s, e) => s.config.get("pinnedFolders").findIndex((a) => a.path === e.target?.path) !== -1),
    order: 70
  },
  {
    id: Ce.preview,
    title: ({ t: s }) => s("Preview"),
    action: (s, e) => s.modal.open(Xe, { storage: e[0]?.storage, item: e[0] }),
    show: nt(
      $e({ target: "one", feature: "preview" }),
      (s, e) => e.target?.type !== "dir"
    ),
    order: 80
  },
  {
    id: Ce.openAs,
    title: ({ t: s }) => s("Preview as"),
    action: () => {
    },
    children: [
      {
        id: Ce.openAsText,
        title: ({ t: s }) => s("Text"),
        action: (s, e) => s.modal.open(Xe, {
          storage: e[0]?.storage,
          item: e[0],
          forceType: "text"
        }),
        show: () => !0
      },
      {
        id: Ce.openAsImage,
        title: ({ t: s }) => s("Image"),
        action: (s, e) => s.modal.open(Xe, {
          storage: e[0]?.storage,
          item: e[0],
          forceType: "image"
        }),
        show: () => !0
      }
    ],
    show: nt(
      $e({ target: "one", feature: "preview" }),
      (s, e) => e.target?.type !== "dir"
    ),
    order: 81
  },
  {
    id: Ce.download,
    link: (s, e) => {
      if (e[0])
        return s.adapter.getDownloadUrl(e[0]);
    },
    title: ({ t: s }) => s("Download"),
    action: () => {
    },
    show: nt(
      $e({ target: "one", feature: "download" }),
      (s, e) => e.target?.type !== "dir"
    ),
    order: 90
  },
  {
    id: Ce.rename,
    title: ({ t: s }) => s("Rename"),
    action: (s, e) => s.modal.open(Dt, { items: e }),
    show: $e({ target: "one", feature: "rename" }),
    order: 100
  },
  {
    id: Ce.move,
    title: ({ t: s }) => s("Move files"),
    action: (s, e) => {
      const t = s.fs, n = {
        storage: t.path.get().storage || "",
        path: t.path.get().path || "",
        type: "dir"
      };
      s.modal.open(at, { items: { from: e, to: n } });
    },
    show: vt(
      $e({ target: "one", feature: "move" }),
      $e({ target: "many", feature: "move" })
    ),
    order: 110
  },
  {
    id: Ce.copy,
    title: ({ t: s }) => s("Copy"),
    action: (s, e) => {
      e.length > 0 && s.fs.setClipboard("copy", new Set(e.map((t) => ke(t))));
    },
    show: vt(
      $e({ target: "one", feature: "copy" }),
      $e({ target: "many", feature: "copy" })
    ),
    order: 120
  },
  {
    id: Ce.paste,
    title: ({ t: s }) => s("Paste"),
    action: (s, e) => {
      const t = s.fs.getClipboard();
      if (t?.items?.size > 0) {
        const a = s.fs.path.get();
        let d = a.path, r = a.storage;
        e.length === 1 && e[0]?.type === "dir" && (d = e[0].path, r = e[0].storage);
        const l = {
          storage: r || "",
          path: d || "",
          type: "dir"
        };
        s.modal.open(t.type === "cut" ? at : rn, {
          items: { from: Array.from(t.items), to: l }
        });
      }
    },
    show: (s, e) => s.features?.copy ?? !1 ? s.fs.getClipboard()?.items?.size > 0 : !1,
    order: 130
  },
  {
    id: Ce.archive,
    title: ({ t: s }) => s("Archive"),
    action: (s, e) => s.modal.open(_n, { items: e }),
    show: vt(
      $e({ target: "many", feature: "archive" }),
      nt(
        $e({ target: "one", feature: "archive" }),
        (s, e) => e.target?.mime_type !== "application/zip"
      )
    ),
    order: 140
  },
  {
    id: Ce.unarchive,
    title: ({ t: s }) => s("Unarchive"),
    action: (s, e) => s.modal.open(fn, { items: e }),
    show: $e({ target: "one", feature: "unarchive", mimeType: "application/zip" }),
    order: 150
  },
  {
    id: Ce.delete,
    title: ({ t: s }) => s("Delete"),
    action: (s, e) => {
      s.modal.open(Pt, { items: e });
    },
    show: vt(
      $e({ feature: "delete", target: "one" }),
      $e({ feature: "delete", target: "many" })
    ),
    order: 160
  }
], vp = ["data-theme"], fp = {
  key: 0,
  class: "vuefinder__external-drop-overlay vuefinder__external-drop-overlay--relative"
}, _p = { class: "vuefinder__external-drop-message" }, pp = { class: "vuefinder__main__content" }, mp = /* @__PURE__ */ le({
  __name: "VueFinderView",
  props: {
    id: {},
    driver: {},
    config: {},
    features: {},
    debug: { type: Boolean },
    locale: {},
    contextMenuItems: {},
    selectionMode: {},
    selectionFilterType: {},
    selectionFilterMimeIncludes: {},
    onError: { type: Function },
    onSelect: { type: Function },
    onPathChange: { type: Function },
    onUploadComplete: { type: Function },
    onDeleteComplete: { type: Function },
    onNotify: { type: Function },
    onReady: { type: Function },
    onFileDclick: { type: Function },
    onFolderDclick: { type: Function },
    onTreeFileClick: { type: Function },
    customUploader: { type: Function }
  },
  emits: [
    "select",
    "path-change",
    "upload-complete",
    "delete-complete",
    "notify",
    "error",
    "ready",
    "file-dclick",
    "folder-dclick",
    "tree-file-click",
    "update:locale"
  ],
  setup(s, { emit: e }) {
    const t = e, n = s, a = ae(), d = st("root"), r = a.config;
    pe(
      () => n.features,
      (f) => {
        const F = Nn(f);
        Object.keys(a.features).forEach((C) => {
          delete a.features[C];
        }), Object.assign(a.features, F);
      },
      { deep: !0 }
    );
    const l = a.fs, c = oe(a.i18n.localeAtom), v = oe(r.state), w = R(() => {
      const f = v.value;
      return {
        "--vf-grid-item-width": `${f.gridItemWidth}px`,
        "--vf-grid-item-height": `${f.gridItemHeight}px`,
        "--vf-grid-item-gap": `${f.gridItemGap}px`,
        "--vf-grid-icon-size": `${f.gridIconSize}px`,
        "--vf-list-item-height": `${f.listItemHeight}px`,
        "--vf-list-item-gap": `${f.listItemGap}px`,
        "--vf-list-icon-size": `${f.listIconSize}px`
      };
    });
    Id();
    const { isDraggingExternal: h, handleDragEnter: _, handleDragOver: k, handleDragLeave: b, handleDrop: $ } = Ad();
    function m(f) {
      l.setPath(f.dirname), r.get("persist") && r.set("path", f.dirname), l.setReadOnly(f.read_only ?? !1), a.modal.close(), l.setFiles(f.files), l.clearSelection(), l.setSelectedCount(0), l.setStorages(f.storages);
    }
    a.adapter.onBeforeOpen = () => {
      l.setLoading(!0);
    }, a.adapter.onAfterOpen = (f) => {
      m(f), l.setLoading(!1);
    }, a.emitter.on("vf-fetch-abort", () => {
      a.adapter.cancelOpen(), l.setLoading(!1);
    }), a.emitter.on("vf-upload-complete", (f) => {
      t("upload-complete", f);
    }), a.emitter.on("vf-delete-complete", (f) => {
      t("delete-complete", f);
    }), a.emitter.on("vf-notify", (f) => {
      t("notify", f);
      const { type: F, message: C } = f ?? {};
      F === "error" && t("error", C);
    }), a.emitter.on("vf-file-dclick", (f) => {
      t("file-dclick", f);
    }), a.emitter.on("vf-folder-dclick", (f) => {
      t("folder-dclick", f);
    }), a.emitter.on("vf-tree-file-click", (f) => {
      const F = f;
      F?.type === "file" && t("tree-file-click", F);
    }), pe(
      () => n.config?.theme,
      (f) => {
        f && r.set("theme", i(f));
      },
      { immediate: !0 }
    ), pe(
      c,
      (f, F) => {
        f !== F && t("update:locale", String(f));
      },
      { immediate: !1 }
    ), we(() => {
      a.root = d.value, pe(
        () => r.get("path"),
        (F) => {
          a.adapter.open(F);
        }
      );
      const f = r.get("persist") ? r.get("path") : r.get("initialPath") ?? "";
      l.setPath(f), a.adapter.open(f), l.path.listen((F) => {
        t("path-change", F.path);
      }), l.selectedItems.listen((F) => {
        t("select", F);
      }), t("ready");
    });
    const g = async (f) => {
      const F = await $(f);
      F.length > 0 && (a.modal.open(vn), setTimeout(() => {
        a.emitter.emit(
          "vf-external-files-dropped",
          F.map((C) => C.file)
        );
      }, 100));
    };
    return (f, F) => (u(), p("div", {
      ref_key: "root",
      ref: d,
      tabindex: "0",
      class: te(["vuefinder vuefinder__main vuefinder__themer", { "vuefinder--dragging-external": i(h) }]),
      "data-theme": i(a).theme.current,
      style: Ee(w.value),
      onDragenter: F[2] || (F[2] = //@ts-ignore
      (...C) => i(_) && i(_)(...C)),
      onDragover: F[3] || (F[3] = //@ts-ignore
      (...C) => i(k) && i(k)(...C)),
      onDragleave: F[4] || (F[4] = //@ts-ignore
      (...C) => i(b) && i(b)(...C)),
      onDrop: g
    }, [
      o("div", {
        class: te(i(a).theme.current),
        style: { height: "100%", width: "100%" }
      }, [
        o("div", {
          class: te([
            i(v)?.fullScreen ? "vuefinder__main__fixed" : "vuefinder__main__relative",
            "vuefinder__main__container"
          ]),
          onMousedown: F[0] || (F[0] = (C) => i(a).emitter.emit("vf-contextmenu-hide")),
          onTouchstart: F[1] || (F[1] = (C) => i(a).emitter.emit("vf-contextmenu-hide"))
        }, [
          i(h) ? (u(), p("div", fp, [
            o("div", _p, y(i(a).i18n.t("Drag and drop the files/folders to here.")), 1)
          ])) : K("", !0),
          i(v).showMenuBar ? (u(), Z(Bu, { key: 1 })) : K("", !0),
          i(v).showToolbar ? (u(), Z(Vv, { key: 2 })) : K("", !0),
          X(xf),
          o("div", pp, [
            X(cp),
            X(f_, {
              "on-file-dclick": n.onFileDclick,
              "on-folder-dclick": n.onFolderDclick
            }, {
              icon: ue((C) => [
                Me(f.$slots, "icon", Ze(et(C)))
              ]),
              _: 3
            }, 8, ["on-file-dclick", "on-folder-dclick"])
          ]),
          X(D_, null, {
            actions: ue((C) => [
              Me(f.$slots, "status-bar", Ze(et(C)))
            ]),
            _: 3
          })
        ], 34),
        (u(), Z(bt, { to: "body" }, [
          X(xo, { name: "fade" }, {
            default: ue(() => [
              i(a).modal.visible ? (u(), Z(On(i(a).modal.type), { key: 0 })) : K("", !0)
            ]),
            _: 1
          })
        ])),
        X(y_, { items: i(ho) }, null, 8, ["items"]),
        i(v).notificationsEnabled ? (u(), Z(i(Fo), {
          key: 0,
          position: i(v).notificationPosition,
          duration: i(v).notificationDuration,
          "visible-toasts": i(v).notificationVisibleToasts,
          "rich-colors": i(v).notificationRichColors
        }, null, 8, ["position", "duration", "visible-toasts", "rich-colors"])) : K("", !0)
      ], 2)
    ], 46, vp));
  }
}), hp = /* @__PURE__ */ le({
  __name: "VueFinderProvider",
  props: {
    id: {},
    driver: {},
    config: {},
    features: {},
    debug: { type: Boolean, default: !1 },
    locale: {},
    contextMenuItems: { default: () => ho },
    selectionMode: { default: "multiple" },
    selectionFilterType: { default: "both" },
    selectionFilterMimeIncludes: { default: () => [] },
    onError: {},
    onSelect: {},
    onPathChange: {},
    onUploadComplete: {},
    onDeleteComplete: {},
    onNotify: {},
    onReady: {},
    onFileDclick: {},
    onFolderDclick: {},
    onTreeFileClick: {},
    customUploader: {}
  },
  emits: ["tree-file-click"],
  setup(s, { emit: e }) {
    const t = s, n = e, a = R(() => {
      const c = { ...t };
      return delete c.onTreeFileClick, c;
    }), d = (c) => {
      t.onTreeFileClick?.(c), n("tree-file-click", c);
    }, r = t.id ?? Ct(Wt);
    if (!r)
      throw new Error('VueFinderProvider requires an "id" prop.');
    const l = Jo(t, Ct("VueFinderOptions") || {});
    return pe(
      () => t.config,
      (c) => {
        if (c) {
          const v = {};
          for (const w in c) {
            const h = i(c[w]);
            h !== void 0 && (v[w] = h);
          }
          l.config.init(v);
        }
      },
      { deep: !0, immediate: !0 }
    ), pe(
      () => t.locale,
      (c) => {
        c && l.i18n.localeAtom && l.i18n.localeAtom.get() !== c && l.i18n.localeAtom.set(c);
      },
      { immediate: !0 }
    ), Oo(r, l), So(Wt, r), rt(() => {
      Lo(r);
    }), (c, v) => (u(), Z(mp, Ne(a.value, { onTreeFileClick: d }), {
      icon: ue((w) => [
        Me(c.$slots, "icon", Ze(et(w)))
      ]),
      "status-bar": ue((w) => [
        Me(c.$slots, "status-bar", Ze(et(w)))
      ]),
      _: 3
    }, 16));
  }
});
function Ap(s) {
  const e = ae(s), t = oe(e.fs.path), n = R(() => t.value?.path ?? ""), a = (r) => r || e.fs.path.get().path || "", d = (r) => {
    Array.isArray(r.files) && e.fs.setFiles(r.files);
  };
  return {
    async refresh() {
      const r = e.fs.path.get().path || "";
      e.adapter.invalidateListQuery(r), await e.adapter.open(r);
    },
    async open(r) {
      await e.adapter.open(r);
    },
    preview(r) {
      const l = (e.fs.files.get() || []).find((c) => c.path === r);
      !l || l.type !== "file" || e.modal.open(Xe, { storage: l.storage, item: l });
    },
    notify(r, l) {
      ot(e, r, l);
    },
    getPath() {
      return e.fs.path.get().path || "";
    },
    path: n,
    select(r) {
      const l = new Set((e.fs.files.get() || []).map((v) => v.path)), c = (r || []).filter((v) => l.has(v));
      e.fs.setSelection(c);
    },
    selectOne(r) {
      new Set((e.fs.files.get() || []).map((c) => c.path)).has(r) && e.fs.setSelection([r]);
    },
    clearSelection() {
      e.fs.clearSelection();
    },
    getSelectedPaths() {
      return (e.fs.selectedItems.get() || []).map((r) => r.path);
    },
    async createFolder(r, l) {
      const c = await e.adapter.createFolder({ path: a(l), name: r });
      d(c);
    },
    async createFile(r, l) {
      const c = await e.adapter.createFile({ path: a(l), name: r });
      d(c);
    },
    async delete(r, l) {
      const c = a(l), v = new Map(
        (e.fs.files.get() || []).map((_) => [_.path, _])
      ), w = (r || []).map((_) => v.get(_)).filter((_) => !!_).map((_) => ({ path: _.path, type: _.type })), h = await e.adapter.delete({ path: c, items: w });
      d(h);
    },
    async rename(r, l, c) {
      const v = await e.adapter.rename({
        path: a(c),
        item: r,
        name: l
      });
      d(v);
    },
    async copy(r, l, c) {
      const v = await e.adapter.copy({
        path: a(c),
        sources: r,
        destination: l
      });
      d(v);
    },
    async move(r, l, c) {
      const v = await e.adapter.move({
        path: a(c),
        sources: r,
        destination: l
      });
      d(v);
    },
    getFiles() {
      return e.fs.files.get() || [];
    },
    getStorages() {
      return e.fs.storages.get() || [];
    },
    isLoading() {
      return e.fs.isLoading();
    },
    isReadOnly() {
      return e.fs.getReadOnly();
    }
  };
}
const Op = {
  install(s, e = {}) {
    e.i18n = e.i18n ?? {};
    const [t] = Object.keys(e.i18n);
    e.locale = e.locale ?? t ?? "en", s.provide("VueFinderOptions", e), s.component("VueFinder", hp);
  }
};
export {
  Yo as A,
  en as B,
  Ce as C,
  Ip as I,
  qn as R,
  Op as V,
  hp as _,
  Ap as a,
  Bo as c,
  ho as m,
  $n as p,
  ae as u
};
